var _defs, _defs2, _defs3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatalan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x39_2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 255.999,
    id: "SVGID_1_",
    r: 219
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ANDORRA_2_",
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 446.331,
    id: "SVGID_3_",
    width: 766.991,
    x: -129.202,
    y: 32.348
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_3_"
  })), /*#__PURE__*/React.createElement("rect", {
    height: 446.331,
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#D90037"
    },
    width: 239.84,
    x: 397.949,
    y: 32.348
  }), /*#__PURE__*/React.createElement("rect", {
    height: 446.331,
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#EEE528"
    },
    width: 287.256,
    x: 110.668,
    y: 32.348
  }), /*#__PURE__*/React.createElement("rect", {
    height: 446.331,
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#221E88"
    },
    width: 239.845,
    x: -129.202,
    y: 32.348
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_4_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 446.331,
    id: "SVGID_5_",
    width: 766.991,
    x: -129.202,
    y: 32.348
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_5_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.692,164.305c-1.349-0.783-1.097-2.407-0.277-3.409c0.761-0.898,2.204-1,3.542-0.263         l1.449,0.783c0.085,0.05,0.164,0.192,0.125,0.267c-0.04,0.076-0.084,0.14-0.163,0.102l-1.578-0.863         c-1.183-0.646-2.462-0.57-3.112,0.191C262.968,162.002,262.726,163.407,263.692,164.305L263.692,164.305z",
    style: {
      fill: "#272425"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.594,285.539l1.146-2.105c0.369-0.569,0.583-0.89,0.928-1.479l1.117-2.071         c0.175-0.295,0.305-0.545,0.497-1.012c0.038-0.09,0.127-0.135,0.217-0.103c0.1,0.038,0.125,0.138,0.1,0.228         c-0.189,0.496-0.341,0.75-0.522,1.054l-0.634,0.812l0.139,0.072l-0.635,1.182c-0.327,0.598-0.547,0.934-0.929,1.498         L171.594,285.539L171.594,285.539z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.499,129.319c9.472,0,13.31,8.091,22.743,8.091        c5.823,0,9.23-1.916,14.311-4.768c3.551-1.989,5.798-3.071,9.866-3.071c4.158,0,6.715,1.259,8.841,4.834        c1.198,2.018,2.189,5.936,1.673,8.229c-0.993,4.273-1.61,6.151-3.333,10.094c-0.805,1.916-1.613,3.043-1.613,5.123        c0,4.997,6.854,6.721,11.482,6.787c1.014,0.026,9.495,0.164,14.727-5.125c-2.83-0.101-5.994-2.298-5.994-5.123        c0-3.21,2.236-5.4,5.285-6.302c0.585-0.19,1.574,0.342,2.112,0.063c0.739-0.38,0.396-1.22,1.067-1.738        c1.509-1.218,2.488-1.978,4.432-1.978c1.3,0,2.047,0.165,3.051,0.912c0.563,0.369,0.75,0.852,1.422,0.852        c1.389,0,2.078-0.876,3.487-0.876c1.144,0,1.819,0.139,2.813,0.672c0.831,0.418,0.831,1.826,1.751,1.826        c0.458,0,2.953-1.014,4.245-1.014c2.716,0,4.175,0.989,5.904,3.006c0.455,0.571,0.758,1.671,1.254,1.671        c0.952,0,3.177,0.624,4.566,2.003c0.582,0.609,0.861,0.876,1.318,1.613c0.316,0.507,0.814,1.75,1.359,1.952        c0.649,0.252,1.209,0.216,2.073,0.762c2.011,1.279,3.506,3.65,3.459,5.957c-0.044,0.761-0.41,1.853-0.588,2.592        c-2.324,8.036-7.807,10.572-13.344,17.458c-2.365,2.942-4.198,5.288-4.198,9.067c0,0.914,1.104,2.588,1.632,3.337        c-0.304-1.766,0.479-3.944,2.363-4.046c2.564-0.124,4.578,1.824,4.903,4.338c0.066,0.62-0.151,1.622-0.39,2.255        c1.383-0.926,3.187-1.56,4.87-1.725c0.884-0.1,1.403-0.125,2.313-0.125c4.113,0.125,8.652,2.419,11.4,4.742        c8.412,7.141,9.423,17.577,8.959,20.49c-1.017,6.445-0.356,18.097-16.881,22.74c3.052,1.28,5.134,3.575,5.134,6.38        c0,3.069-2.363,5.692-5.411,5.692c-1.757,0-3.004-0.445-4.223-1.662c-3.433,3.422-4.095,6.913-4.095,11.752        c0,2.935,0.55,4.622,1.782,7.255c1.299,2.769,2.206,4.402,4.523,6.395c1.248-1.838,2.534-3.207,4.754-3.207        c2.19,0,4.001,0.688,4.873,2.643c0.262,0.614,0.034,1.101,0.338,1.682c0.397,0.737,1.049,0.898,1.451,1.656        c0.608,1.134,0,2.119,0.559,3.299c0.33,0.771,1.096,0.902,1.445,1.65c0.514,1.205,0.646,2.004,0.646,3.323        c0,3.677-3.363,6.302-7.026,6.302c-1.109,0-1.727-0.445-2.815-0.344c2.104,2.105,3.714,3.006,5.31,5.527        c2.313,3.629,2.9,6.212,3.418,10.5c0.093,0.801,0.119,1.286,0.119,2.094c0,5.477-0.856,8.775-3.336,13.696        c-2.334,4.69-4.342,7.304-8.619,10.383c-6.657,4.767-11.54,6.151-19.597,7.709c-5.156,1.005-8.11,1.45-13.399,1.78        c-6.711,0.428-10.574,0.445-17.261,0.883c-8.808,0.586-14.914,1.832-21.153,8.068c2.975,2.133,5.002,4.258,5.002,7.889        c0,3.736-2.301,6.375-5.893,7.56c-0.823,0.28-1.447,0.021-2.211,0.443c-0.914,0.479-0.86,1.543-1.755,2.118        c-1.574,0.963-2.767,1.202-4.651,1.202c-3.303,0-5.515-0.786-7.867-3.106c-2.686,2.244-3.602,4.258-6.625,5.971        c-1.014,0.547-1.511,1.334-2.658,1.334c-1.813,0-2.657-1.168-4.106-2.209c-2.295-1.701-3.531-2.789-5.41-4.982        c-2.776,1.647-4.453,2.993-7.655,2.993c-1.972,0-3.204-0.281-4.87-1.334c-0.863-0.544-1.017-1.345-1.871-1.887        c-0.939-0.571-1.674-0.358-2.652-0.744c-3.701-1.607-6.116-4.343-6.116-8.35c0-3.521,2.226-5.77,5.44-7.239        c-6.15-6.102-12.152-7.178-20.821-7.727c-6.687-0.414-10.474-0.438-17.133-0.883c-5.314-0.356-8.264-0.898-13.527-1.78        c-3.956-0.628-6.331-0.843-9.966-2.532c-12.521-5.817-20.504-13.799-22.141-27.491c-0.13-1.183-0.091-1.844-0.091-3.048        c0-7.113,2.808-11.488,7.839-16.494c-1.293-0.317-2.159,0.129-3.427-0.344c-3.143-1.133-5.417-3.311-5.417-6.67        c0-1.243,0.052-2.084,0.661-3.146c0.435-0.759,1.246-0.91,1.421-1.773c0.255-1.131-0.048-1.926,0.458-2.994        c0.357-0.7,0.993-0.836,1.335-1.537c1.084-2.266,2.468-4.09,4.969-4.09c2.151,0,3.538,1.15,4.653,3.003        c2.087-0.989,2.669-2.538,3.895-4.551c1.955-3.286,2.857-5.595,2.857-9.434c0-2.692-0.242-4.239-1.106-6.776        c-0.594-1.826-0.84-3.068-2.187-4.437c-1.246,1.217-2.466,1.662-4.23,1.662c-3.523,0-6.19-3.018-6.19-6.531        c0-2.588,1.28-4.542,3.659-5.633c-1.905-1.61-3.533-1.747-5.669-3.08c-3.177-2.014-4.322-4.135-6.406-7.291        c-1.361-2.056-1.73-3.477-2.441-5.833c-0.838-2.854-1.319-4.555-1.319-7.533c0-0.761,0-1.216,0.124-1.979        c0.761-5.997,1.844-9.739,5.634-14.458c2.222-2.814,3.759-4.538,7.094-5.971c2.809-1.22,4.496-2.091,7.587-2.091        c0.913,0,1.449,0,2.363,0.1c1.422,0.192,2.312,0.315,3.561,1.015c0.443,0.253,1.319,1.028,1.319,0.481        c0-0.633-0.355-0.962-0.355-1.595c0-2.538,1.831-4.87,4.387-4.87c1.855,0,2.58,1.61,3.484,3.207        c0.595-0.962,0.888-1.635,0.888-2.751c0-4.199-2.276-6.341-4.869-9.611c-5.695-7.115-12.849-10.438-12.849-19.541        c0-2.727,1.333-4.581,3.672-5.975c0.674-0.393,1.577,0,2.237-0.431c0.56-0.357,0.508-1.09,0.865-1.661        c0.56-0.899,1.042-1.283,1.857-1.98c1.296-1.125,2.44-0.787,3.888-1.775c0.711-0.504,0.889-1.138,1.451-1.81        c1.601-1.929,3.025-2.854,5.566-2.854c1.271,0,1.982,0,3.153,0.467c0.404,0.14,1.17,0.748,1.269,0.647        c0.244-0.316,0.919-1.051,1.755-1.432c1.043-0.512,1.476-0.71,2.67-0.71c1.363,0,2.265,0.76,3.612,0.76        c0.51,0,0.623-0.481,1.019-0.76c1.204-0.799,1.879-1.256,3.356-1.256c1.397,0,2.184,0.458,3.364,1.219        c1.146,0.685,1.298,1.634,2.444,2.307c0.648,0.368,1.155,0.201,1.866,0.428c3.179,1.058,5.558,3.159,5.558,6.458        c0,1.798-0.434,3.107-1.794,4.262c-1.041,0.949-2.058,0.774-3.406,1.216c4.399,3.499,8.224,4.387,13.829,4.387        c5.15,0,11.442-2.117,11.442-7.241c0-2.395-1.322-3.68-2.25-5.86c-1.703-3.905-2.62-6.213-2.62-10.461        c0-3.371,0.369-5.415,2.342-8.14C224.577,129.968,227.044,129.319,230.499,129.319L230.499,129.319z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.454,210.06c-0.419,0-0.863-0.114-1.271-0.328c-0.087-0.04-0.127-0.14-0.073-0.229         c0.022-0.076,0.137-0.112,0.225-0.064c0.774,0.394,1.64,0.367,2.29-0.089c0.713-0.531,1.043-1.521,0.866-2.636         c-0.192-1.13-1.437-2.45-2.924-2.55c1.678-0.226,3.036,1.216,3.255,2.501c0.201,1.239-0.179,2.359-1.004,2.952         C163.421,209.91,162.938,210.06,162.454,210.06L162.454,210.06z",
    style: {
      fill: "#272425"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.586,368.549c-4.715-0.595-6.798-3.496-6.798-5.958c0-0.688,0-1.356,0.09-1.983         c0.582-3.361,2.872-5.811,5.362-8.24l0.992-0.9c1.347-1.222,2.24-1.785,3.084-2.318c3.557-2.275,7.363-3.895,12.63-5.529         l3.062-0.824c2.326-0.537,3.957-0.791,5.459-1.014l1.867-0.301c2.271-0.389,4.381-0.526,6.806-0.686l2.486-0.178         c3.375-0.232,6.148-0.166,8.831-0.109l4.92,0.038c2.489,0.042,4.499,0.053,6.75-0.038l1.131-0.057         c2.481-0.114,4.172-0.193,6.916-0.436c6.966-0.62,12.318-1.661,17.518-4.941c6.202-3.979,10.883-13.023,7.951-21.302         c-0.211-0.665-0.548-1.744-1.314-3.026c-0.337-0.566-0.915-1.429-1.271-1.924c-0.984-1.266-2.142-1.922-3.001-2.405         c-2.709-1.516-6.053-0.447-7.325,0.921c-1.115,1.242-1.495,2.609-1.148,3.955c0.208,0.727,0.529,1.154,0.783,1.458         c0.063,0.068,0.063,0.179-0.021,0.23c-0.073,0.052-0.173,0.052-0.226-0.012c-0.264-0.306-0.627-0.796-0.85-1.588         c-0.397-1.456,0.016-2.931,1.208-4.257c1.327-1.439,4.78-2.643,7.578-1.094c1.04,0.584,2.244,1.256,3.251,2.589         c0.378,0.505,0.968,1.38,1.322,1.963c0.763,1.306,1.114,2.422,1.299,2.94c3.021,8.567-1.734,17.795-8.059,21.822         c-5.262,3.329-10.656,4.382-17.668,5.015c-2.747,0.238-4.453,0.313-6.928,0.435l-1.135,0.047         c-2.286,0.102-4.285,0.064-6.152,0.049l-5.539-0.049c-2.673-0.047-5.446-0.13-8.802,0.102l-2.478,0.178         c-2.425,0.166-4.514,0.3-6.789,0.682l-1.869,0.308c-1.486,0.229-3.129,0.489-4.801,0.857l-3.672,0.981         c-5.229,1.607-9,3.234-11.871,5.07c-1.518,0.939-2.382,1.484-3.03,2.104l-1.663,1.482c-2.441,2.402-4.681,4.805-5.267,8.052         c-0.074,0.618-0.074,1.271-0.074,1.934C254.132,364.907,256.114,367.66,260.586,368.549L260.586,368.549z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.751,368.66c-2.102,0-3.511-1.414-4.097-2.725c1.247,0.939,2.625,2.18,4.583,1.954         c0.733-0.093,1.341-0.432,1.726-0.938c0.365-0.481,0.506-1.103,0.377-1.828l-0.044-1.088l-0.356,0.154         c-0.079-0.193-0.385-0.766-0.764-1.017l0.435-0.624c0.634,0.443,1.011,1.306,1.025,1.334l0.443,1.129         c0.154,0.912-0.022,1.747-0.507,2.396c-0.508,0.674-1.294,1.103-2.24,1.214C278.133,368.65,277.932,368.66,277.751,368.66         L277.751,368.66z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.133,333.273c-4.651-3.542-8.465-11.08-5.698-19.008c0.218-0.663,0.576-1.771,1.364-3.1         c0.292-0.521,0.875-1.279,1.284-1.807c1.194-1.602,2.414-2.286,3.305-2.793c2.871-1.63,6.408-0.384,7.678,1.2         c1.142,1.448,1.73,3.707,0.585,5.227c-0.88,1.155-1.679,0.978-2.367,0.822c-0.786-0.122-1.014-0.467-1.222-0.747l0.208-0.914         l0.403,0.486c1.425,0.595,1.793,0.656,2.392-0.103c0.886-1.195,0.353-3.106-0.583-4.302c-1.107-1.38-4.173-2.448-6.688-1.041         c-0.916,0.525-2.007,1.143-2.952,2.415c-0.56,0.707-1.104,1.428-1.396,1.938c-0.748,1.252-1.093,2.314-1.244,2.829         C156.48,322.103,160.165,329.367,164.133,333.273L164.133,333.273z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.407,368.307c-1.708,0-3.155-0.977-3.94-2.7c1.027,0.455,2.068,2.257,4.435,1.913         c0.712-0.073,1.353-0.405,1.729-0.912c0.359-0.477,0.484-1.1,0.341-1.814c-0.021-0.297-0.123-0.595-0.274-0.938l0,0         c0,0-0.296-0.415-0.739-0.886c-0.14-0.154-0.14-0.378,0.013-0.529c0.15-0.141,0.381-0.141,0.534,0.025         c0.518,0.546,0.835,1.035,0.835,1.035c0.232,0.473,0.352,0.824,0.384,1.209c0.153,0.874-0.011,1.693-0.497,2.344         c-0.489,0.668-1.318,1.114-2.242,1.219C277.79,368.295,277.594,368.307,277.407,368.307L277.407,368.307z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.597,164.738c0.396-1.394,0.277-2.727-0.355-3.475c-0.506-0.62-1.844-0.837-3.052-0.164         l-2.821,1.571c-0.193,0.09-0.434,0.041-0.521-0.138c-0.101-0.179-0.038-0.406,0.14-0.506l2.834-1.587         c1.424-0.783,3.217-0.634,3.989,0.357C245.663,161.786,245.815,163.583,244.597,164.738L244.597,164.738z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.22,156.661c0.329,1.255,1.394,2.447,2.985,2.983        c0.991,0.292,3.242,0.162,4.689-1.728c1.198-1.509,1.107-3.398,0.638-4.909c-0.282-0.962-1.046-1.912-2.085-2.711        l-6.227,6.302V156.661z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#272425"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.157,160.138c-0.394,0-0.764-0.054-1.069-0.14c-1.623-0.535-2.844-1.751-3.238-3.249         l6.317-6.721c1.674,0.853,2.44,1.864,2.731,2.878c0.369,1.167,0.752,3.4-0.723,5.252         C202.801,159.947,200.905,160.138,200.157,160.138L200.157,160.138z M202.218,150.601l-5.746,6.264         c0.432,0.923,1.486,1.963,2.847,2.419l0.838,0.106c0.637,0,2.266-0.168,3.432-1.701c1.26-1.572,0.916-3.537,0.587-4.578         C203.932,152.259,203.232,151.374,202.218,150.601L202.218,150.601z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "201.555,149.649 202.423,150.257 203.334,151.248         203.919,152.466 204.227,153.489 204.289,154.812 204.227,155.736 203.919,156.763 203.334,157.474 202.598,158.271         201.555,158.817 200.235,159.107 199.052,159.3 197.842,158.753 196.737,157.955 196.091,156.989 195.607,155.772         195.607,155.292       ",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.638,169.542l-0.167-0.745c6.689-1.371,12.218-4.438,16.248-6.67         C236,165.045,230.435,168.138,223.638,169.542L223.638,169.542z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.268,169.204l-0.153-0.736c6.788-1.42,12.266-4.451,16.258-6.682         C235.698,164.688,230.169,167.768,223.268,169.204L223.268,169.204z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.056,381.17c-4.143-1.451-8.059-5.037-9.763-7.691c2.286,2.147,6.038,5.598,9.763,6.983         c3.456-1.386,7.22-4.836,8.862-7.386l0.619,0.402C261.846,376.133,257.947,379.719,254.056,381.17L254.056,381.17z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.221,163.925c2.018-2.836,2.961-4.144,3.598-7.363c0.482-2.235,0.102-5.859-1.805-8.522         c-1.757-2.435-4.07-2.765-7.249-1.038c-0.205,0.098-0.407,0.023-0.51-0.156c-0.104-0.189-0.034-0.405,0.143-0.506         c3.47-1.89,6.245-1.471,8.224,1.256c2.046,2.855,2.436,6.731,1.931,9.117C329.894,160.097,328.837,161.546,326.221,163.925         L326.221,163.925z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.796,169.037c2.794-2.42,6.24-6.213,6.444-11.577c0.129-3.08-0.363-4.969-1.877-7.228         c-2.244-3.323-6.195-4.058-9.589-1.789c-0.163,0.116-0.405,0.064-0.521-0.101c-0.117-0.179-0.068-0.405,0.104-0.52         c3.775-2.511,8.135-1.685,10.614,1.993c1.602,2.371,2.156,4.45,2.017,7.671C340.775,163.164,337.137,167.174,333.796,169.037         L333.796,169.037z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.745,202.759c-0.746,0-1.51-0.141-2.263-0.471c-3.768-1.699-5.424-4.971-5.424-10.613         c0-6.634,5.662-12.584,9.811-16.933c1.348-1.393,2.517-2.61,3.256-3.637l0.633-0.849c2.489-3.323,3.989-5.341,3.989-10.224         c0-3.968-3.366-7.721-7.349-8.191l0.079-0.733c4.351,0.504,8.01,4.602,8.01,8.925c0,5.137-1.628,7.341-4.118,10.666         l-0.637,0.863c-0.76,1.027-1.957,2.283-3.316,3.702c-4.061,4.261-9.625,10.083-9.625,16.412c0,5.309,1.553,8.368,4.999,9.928         c2.261,1.015,4.97-0.09,6.187-1.207c1.729-1.556,1.922-3.638,1.524-5.072c-0.433-1.471-1.451-2.497-2.753-2.737         c-1.405-0.239-2.165,0.482-2.482,0.938c-0.559,0.811-0.658,1.953-0.203,2.702c0.357,0.609,0.968,0.888,1.881,0.786         c-1.121,0.888-2.028,0.458-2.527-0.392c-0.603-1.015-0.498-2.461,0.241-3.527c0.71-1.027,1.866-1.508,3.229-1.243         c1.558,0.291,2.846,1.546,3.327,3.271c0.598,2.105-0.072,4.338-1.728,5.834C340.573,201.806,338.717,202.759,336.745,202.759         L336.745,202.759z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.725,197.076c-1.97,0-3.787-2.435-3.867-4.78c-0.191-5.147,5.024-10.274,9.219-14.395         c1.407-1.382,2.68-2.611,3.496-3.654c3.681-4.536,4.98-6.541,4.98-11.106c0-3.058-2.347-5.721-5.236-5.936l0.05-0.748         c3.276,0.242,5.922,3.234,5.922,6.684c0,4.819-1.318,6.886-5.129,11.577c-0.843,1.052-2.109,2.311-3.563,3.729         c-4.077,4.005-9.171,9-8.999,13.822c0.102,2.409,2.147,4.603,3.766,4.731C338.159,197.05,337.939,197.076,337.725,197.076         L337.725,197.076z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.271,245.089c-0.344,0-0.701-0.016-1.048-0.029c-2.907-0.114-5.384-1.217-6.975-3.107         c-1.45-1.7-2.065-3.93-1.757-6.277c0.283-2.295,1.522-4.148,3.421-5.095c1.722-0.876,3.751-0.853,5.429,0.073         c2.03,1.131,2.634,3.183,2.338,4.717c-0.327,1.661-1.602,2.83-3.347,3.033c-1.304,0.115-2.628-0.545-3.16-1.66         c-0.436-0.863-0.27-1.801,0.402-2.5c-0.083,1.168,0.108,1.839,0.259,2.168c0.356,0.71,1.325,1.417,2.416,1.242         c1.424-0.166,2.414-1.079,2.695-2.423c0.226-1.179-0.156-2.915-1.981-3.931c-1.452-0.799-3.208-0.823-4.705-0.065         c-1.666,0.854-2.772,2.501-3.028,4.531c-0.273,2.139,0.279,4.171,1.586,5.707c1.454,1.722,3.742,2.725,6.452,2.839         c4.622,0.152,9.391-1.102,12.694-3.537c6.976-5.083,9.474-13.392,7.631-25.361c-0.991-6.733-5.746-12.135-8.402-14.268         c-5.573-4.423-14.694-5.755-19.682-0.213c-3.05,3.371-2.962,7.175-1.858,9.608c1.124,2.451,3.165,3.897,5.698,3.897         c2.659-0.053,4.647-1.433,5.327-3.693c0.601-2.014-0.04-4.21-1.512-5.212c-1.115-0.749-2.146-0.989-3.074-0.749         c-1.299,0.369-1.905,1.573-2.091,1.93c-0.455,1.026-0.069,1.966,0.513,2.449c0.467,0.378,1.243,0.594,1.984,0.048         c0.177-0.104,0.403-0.076,0.532,0.09c0.118,0.178,0.076,0.405-0.09,0.531c-0.905,0.647-2.036,0.608-2.912-0.101         c-0.795-0.659-1.333-1.942-0.696-3.322c0.184-0.432,0.947-1.892,2.556-2.334c1.17-0.341,2.396-0.04,3.694,0.837         c1.771,1.204,2.504,3.688,1.819,6.046c-0.788,2.589-3.026,4.173-6.022,4.227c-2.889,0.125-5.161-1.611-6.406-4.339         c-1.2-2.652-1.322-6.771,1.985-10.412c5.285-5.872,14.863-4.516,20.708,0.125c2.726,2.198,7.647,7.775,8.681,14.739         c1.877,12.272-0.72,20.808-7.934,26.069C359.207,243.729,354.731,245.089,350.271,245.089L350.271,245.089z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.194,240.116c-1.624,0-3.831-0.531-5.133-1.751c-0.684-0.645-1.057-1.408-1.064-2.282         c0.759,0.647,1.037,1.229,1.575,1.736c1.153,1.092,3.316,1.573,4.877,1.534c8.441-0.366,13.227-7.112,13.147-18.516         c-0.133-8.865-5.53-18.411-13.384-18.524c-3.151,0-6.31,0.446-7.186,4.326l-0.725-0.153c1.006-4.452,4.932-4.974,7.921-4.92         c8.562,0.115,13.993,10.093,14.123,19.262c0.087,11.691-5.101,18.895-13.872,19.273         C351.388,240.116,351.298,240.116,351.194,240.116L351.194,240.116z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.009,238.77c10.787-3.423,11.707-10.702,11.707-17.298c0-4.207-1.086-14.213-11.159-16.46         l-0.384-0.074l0.18-0.735l0.353,0.076c7.368,1.636,11.769,8.066,11.769,17.193         C360.474,226.444,360.474,235.701,348.009,238.77L348.009,238.77z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.01,297.397c-0.912,0-1.806-0.142-2.696-0.394c-1.713-0.455-4.221-1.561-5.184-2.109         c-3.31-1.856-5.503-3.438-7.107-5.095c-3.696-3.778-6.088-8.329-7.285-13.925c-1.447-6.682,0-13.543,0.322-14.85         c1.943-8.088,7.911-16.687,15.164-16.687c1.726,0,3.053,0.052,4.271,0.811c0.559,0.331,1.106,0.852,1.666,1.548         c0.545,0.735,0.874,1.369,1.102,2.142c0.486,1.649,0.281,3.45-0.531,4.858c-0.735,1.308-1.881,2.182-3.282,2.545         c-1.844,0.484-3.888,0.08-5.173-1.034c-0.828-0.725-1.764-2.084-1.488-4.479c0.154-1.153,1.34-2.205,2.697-2.397         c1.512-0.228,2.827,0.66,3.51,2.294c0.093,0.193,0,0.421-0.206,0.497c-0.176,0.076-0.401-0.01-0.477-0.201         c-0.564-1.32-1.542-1.965-2.725-1.84c-1.017,0.14-1.939,0.91-2.05,1.738c-0.185,1.636,0.246,2.954,1.238,3.816         c1.092,0.949,2.859,1.305,4.501,0.875c1.189-0.302,2.173-1.062,2.806-2.194c0.713-1.228,0.883-2.814,0.473-4.26         c-0.205-0.687-0.507-1.244-0.995-1.901c-0.486-0.609-0.979-1.079-1.47-1.371c-0.955-0.596-2.011-0.694-3.866-0.694         c-6.863,0-12.558,8.288-14.441,16.101c-0.29,1.283-1.726,8.004-0.305,14.536c1.172,5.438,3.485,9.876,7.092,13.534         c1.55,1.635,3.688,3.15,6.944,4.981c0.912,0.517,3.365,1.593,4.994,2.04c1.512,0.44,3.022,0.48,4.644,0.125         c1.849-0.405,3.267-1.447,3.962-2.93c0.687-1.494,0.571-3.269-0.347-4.992c-0.896-1.732-2.836-2.957-4.682-2.998         c-1.1-0.141-2.484,0.333-3.536,2.156c-0.041,0.077-0.436,0.842-0.436,1.701c0,1.05,0.454,2.146,1.07,2.535         c0.914,0.597,2.102,0.699,2.883,0.254c0.678-0.378,1.006-1.154,0.967-2.232c0.802,1.317,0.313,2.357-0.602,2.884         c-1.011,0.595-2.474,0.475-3.655-0.266c-0.943-0.616-1.427-2.06-1.427-3.175c0-1.027,0.455-1.904,0.547-2.067         c0.953-1.675,2.503-2.561,4.208-2.538c2.109,0.039,4.295,1.434,5.338,3.4c1.014,1.93,1.146,3.949,0.345,5.656         c-0.792,1.7-2.375,2.892-4.491,3.35C359.523,297.305,358.772,297.397,358.01,297.397L358.01,297.397z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.518,293.297c-0.665,0-1.334-0.197-2.306-0.633c-0.528-0.224-1.153-0.576-1.855-0.986         c-3.408-1.932-7.266-4.717-10.879-11.465c-0.968-1.789-1.667-3.602-2.134-5.545c-0.346-1.368-0.56-2.732-0.632-4.146         c-0.061-2.352,0.201-4.879,0.78-7.693c0.944-4.604,2.089-7.103,5.063-11.185c1.502-2.092,2.819-3.234,5.538-3.298         c-2.388,0.797-3.543,1.802-4.929,3.743c-2.899,3.97-4.018,6.418-4.934,10.892c-0.586,2.763-0.823,5.223-0.759,7.518         c0.05,1.36,0.266,2.676,0.608,3.999c0.456,1.873,1.12,3.623,2.062,5.376c3.504,6.567,7.263,9.265,10.142,10.907         c1.116,0.631,1.717,0.976,2.232,1.203c1.504,0.682,2.113,0.719,3.267,0.295l0.272,0.689         C358.485,293.186,358.002,293.297,357.518,293.297L357.518,293.297z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.212,288.971c-1.703-0.349-2.423-1.854-2.423-3.432c0-2.826,2.301-5.133,5.143-5.133         c2.851,0,5.16,2.307,5.16,5.133l-0.547,0.557l-0.198-0.557c0-2.422-1.97-4.387-4.415-4.387c-2.424,0-4.396,1.965-4.396,4.387         C353.535,286.885,354.16,288.179,355.212,288.971L355.212,288.971z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.407,285.414c-1.432-0.457-1.92-1.689-1.92-2.955c0-2.738,2.19-4.957,4.871-4.957         c2.402,0,4.424,1.745,4.777,4.141l-0.737,0.119c-0.301-2.037-2.006-3.513-4.04-3.513c-2.262,0-4.12,1.885-4.12,4.21         C352.238,283.563,352.645,284.588,353.407,285.414L353.407,285.414z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.831,281.762c-3.711-2.681-7.695-8.104-7.775-15.359c0-4.932,1.955-10.304,4.551-12.513         c-1.961,2.646-3.793,7.771-3.793,12.501c0.052,6.975,3.892,12.203,7.453,14.75L351.831,281.762L351.831,281.762z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.407,286.096c-4.474-1.569-6.452-4.182-8.137-6.68c-0.125-0.181-0.073-0.408,0.107-0.524         c0.177-0.11,0.4-0.062,0.509,0.104C347.523,281.406,349.443,283.937,353.407,286.096L353.407,286.096z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.328,358.634c6.347-9.007,18.309-9.485,30.98-9.981         c10.146-0.391,22.854-1.281,31.295-4.755c13.427-5.512,16.887-13.239,18.179-16.144c1.614-3.152,2.647-8.002,2.757-12.072         c0.065-2.396-0.323-4.987-1.033-6.898c-2.21-6.406-5.449-10.094-11.972-13.582c-3.657-1.98-6.687-2.726-9.809-2.318         c-3.713,0.456-6.768,3.028-7.87,4.32l-0.568-0.481c1.621-1.915,4.931-4.171,8.332-4.589         c3.282-0.378,6.457,0.343,10.284,2.408c6.7,3.586,10.027,7.38,12.32,13.998c0.734,1.98,1.117,4.676,1.063,7.154         c-0.123,4.238-1.154,9.131-2.475,11.627c-1.661,3.718-5.224,11.644-18.926,17.277c-8.544,3.51-21.334,4.41-31.549,4.805         C298.82,349.9,287.022,350.367,280.328,358.634L280.328,358.634z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.375,317.243c-0.052,0-0.104,0-0.143,0c-2.116-0.04-4.269-1.153-6.362-3.337         c-2.033-2.155-4.075-7.33-2.243-12.084c0.916-2.462,2.6-4.174,5.39-5.529c7.578-3.755,15.726,0.639,18.87,2.691         c0.175,0.111,0.228,0.338,0.097,0.516c-0.097,0.164-0.334,0.217-0.509,0.103c-3.049-1.991-10.88-6.241-18.125-2.64         c-2.654,1.281-4.158,2.817-5.033,5.125c-1.701,4.451,0.188,9.294,2.083,11.309c1.955,2.015,3.914,3.059,5.851,3.096         c0.042,0,0.073,0,0.125,0c4.725,0,5.316-3.551,5.316-3.59c0.558-3.36-1.544-4.4-2.188-4.626         c-0.41-0.154-1.55-0.174-2.441,0.263c-0.504,0.256-0.838,0.619-0.99,1.105c-0.154,0.483-0.208,1.455,0.23,2.145         c-1.176-0.446-1.176-1.6-0.947-2.357c0.207-0.67,0.673-1.207,1.375-1.561c1.092-0.548,2.443-0.504,3.029-0.303         c0.557,0.198,3.352,1.418,2.668,5.451C342.27,314.197,340.9,317.243,336.375,317.243L336.375,317.243z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.625,368.359c-4.917-0.228-7.039-3.223-7.039-5.769c0-0.688,0-1.385,0.087-2.005         c0.611-3.43,2.896-5.912,5.414-8.358l1.015-0.913c1.354-1.246,2.241-1.802,3.103-2.326c3.572-2.3,7.404-3.936,12.676-5.577         l3.09-0.818c2.313-0.523,3.959-0.79,5.469-1.03l1.854-0.293c2.284-0.379,4.394-0.527,6.838-0.693l2.475-0.178         c3.375-0.234,6.169-0.164,8.852-0.102l4.931,0.052c2.479,0.026,4.465,0.036,6.728-0.052l2.285-0.092         c1.905-0.074,3.455-0.125,5.748-0.387c7.933-0.939,13.153-2.416,17.438-4.927c6.078-3.633,10.805-12.731,7.857-21.05         c-0.208-0.659-0.561-1.729-1.294-2.984c-0.33-0.566-0.99-1.414-1.39-1.91c-0.953-1.316-2.069-1.925-2.948-2.433         c-2.457-1.365-5.325-0.94-6.727,0.975c-1.013,1.385-1.319,2.526-0.989,3.729l-0.715,0.203         c-0.403-1.422-0.054-2.813,1.111-4.379c1.613-2.205,4.901-2.716,7.664-1.188c0.914,0.518,2.16,1.206,3.207,2.646         c0.4,0.495,1.084,1.385,1.444,1.979c0.773,1.338,1.141,2.449,1.313,2.984c3.113,8.813-1.816,18.27-8.147,22.076         c-4.39,2.56-9.686,4.067-17.75,5.021c-2.287,0.271-3.865,0.317-5.793,0.393l-2.274,0.091         c-2.303,0.091-4.313,0.059-6.169,0.047l-5.539-0.047c-2.673-0.063-5.446-0.113-8.775,0.102l-2.492,0.178         c-2.416,0.164-4.496,0.307-6.756,0.68l-1.887,0.307c-1.473,0.23-3.106,0.495-4.791,0.861l-3.652,0.979         c-5.212,1.599-8.976,3.208-11.816,5.049c-1.502,0.934-2.363,1.468-3.002,2.077l-1.666,1.486         c-2.415,2.357-4.636,4.743-5.201,7.937c-0.073,0.583-0.073,1.228-0.073,1.891         C254.335,364.831,256.28,367.487,260.625,368.359L260.625,368.359z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.785,373.79c-2.211,0-4.342-0.89-6.041-2.513c-1.992-1.928-3.191-4.691-3.191-7.412         c0-11.375,19.021-16.039,19.834-16.231c6.686-1.581,10.777-2.214,21.973-2.85c1.635-0.085,3.094-0.126,4.536-0.175         c2.441-0.064,4.835-0.122,7.862-0.446c4.449-0.454,6.684-0.681,10.975-1.675c6.038-1.396,11.006-3.904,15.186-7.667         c3.589-3.253,5.57-5.545,7.143-9.847c1.359-3.652,2.087-11.121-1.469-16.656c-2.979-4.605-7.145-7.322-12.41-8.078         c-4.554-0.676-8.315,1.314-10.594,5.615c-1.05,2.004-0.797,5.503,0.119,7.178c0.725,1.316,2.877,3.422,5.543,3.459         c0.042,0,0.073,0,0.125,0c4.725,0,5.316-3.551,5.316-3.59c0.558-3.36-1.544-4.4-2.188-4.626         c-0.41-0.154-1.55-0.174-2.441,0.263c-0.504,0.256-0.838,0.619-0.99,1.105c-0.154,0.483-0.208,1.455,0.23,2.145         c-1.176-0.446-1.176-1.6-0.947-2.357c0.207-0.67,0.673-1.207,1.375-1.561c1.092-0.548,2.443-0.504,3.029-0.303         c0.557,0.198,3.352,1.418,2.668,5.451c-0.158,1.178-1.527,4.224-6.053,4.224c-0.052,0-0.104,0-0.143,0         c-3.014-0.052-5.349-2.339-6.191-3.856c-1.023-1.863-1.297-5.646-0.121-7.889c2.417-4.527,6.558-6.683,11.363-6.01         c5.49,0.797,9.834,3.629,12.927,8.424c3.722,5.77,2.961,13.527,1.549,17.334c-1.624,4.434-3.674,6.789-7.333,10.117         c-4.27,3.869-9.354,6.439-15.531,7.85c-4.322,1.018-6.584,1.239-10.682,1.656c-3.427,0.355-5.821,0.426-8.287,0.484         c-1.451,0.052-2.896,0.09-4.525,0.183c-11.137,0.62-15.216,1.254-21.852,2.825c-6.644,1.586-19.256,6.87-19.256,15.504         c0,2.52,1.119,5.092,2.975,6.863c1.625,1.577,3.583,2.377,5.82,2.294c2.534-0.103,4.83-1.151,6.332-2.886         c1.17-1.334,1.754-3.034,1.676-4.795c-0.07-1.053-0.272-1.982-0.598-2.751c-1.078-2.461-3.288-4.02-5.753-4.059         c-1.622-0.04-2.7,0.585-3.665,1.62c-0.963,1.054-1.426,2.408-1.298,3.744c0.106,1.077,0.61,2.071,1.353,2.672         c0.66,0.522,1.473,0.762,2.423,0.625c0.883-0.091,1.563-0.484,1.894-1.053c0.346-0.633,0.258-1.522-0.251-2.548         c-0.079-0.183,0-0.407,0.175-0.494c0.191-0.106,0.412-0.019,0.506,0.166c0.793,1.581,0.55,2.636,0.234,3.231         c-0.455,0.796-1.351,1.315-2.467,1.446c-1.144,0.151-2.158-0.146-2.988-0.788c-0.897-0.72-1.5-1.915-1.613-3.182         c-0.166-1.545,0.381-3.123,1.479-4.328c1.112-1.204,2.869-2.016,4.22-1.85c2.771,0.039,5.235,1.766,6.44,4.492         c0.369,0.873,0.583,1.873,0.65,3.016c0.103,1.951-0.561,3.854-1.855,5.324c-1.615,1.893-4.12,3.047-6.869,3.146         C277.01,373.773,276.898,373.79,276.785,373.79L276.785,373.79z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.005,377.072c-2.712,0-4.871-0.822-7.061-2.654c-2.591-2.19-4.19-5.869-4.19-9.587         c0-1.798,0.388-4.356,1.5-6.147c3.777-5.937,8.361-7.964,14.155-10.537c0.192-0.089,0.427,0,0.499,0.188         c0.088,0.182,0,0.408-0.19,0.494c-5.899,2.627-10.167,4.52-13.831,10.252c-1.018,1.659-1.385,4.055-1.385,5.751         c0,3.505,1.512,6.968,3.93,9.021c2.374,1.984,4.766,2.713,7.902,2.41c2.211-0.216,4.281-1.883,4.603-2.906         c0.294,1.614-2.086,3.41-4.54,3.655C271.912,377.061,271.443,377.072,271.005,377.072L271.005,377.072z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.75,220.75c-1.095,0-2.264-0.19-3.481-0.519c-8.177-2.294-11.21-8.889-11.21-12.515         c0-2.97,1.088-5.353,3.329-7.281l0.479,0.569c-2.062,1.777-3.075,3.971-3.075,6.712c0,3.397,2.901,9.611,10.681,11.792         c2.933,0.812,5.681,0.694,7.348-0.292C346.929,220.282,345.477,220.75,343.75,220.75L343.75,220.75z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.498,254.094c-2.697-0.789-5.439-3.566-5.439-8.778c0-4.399,2.184-8.598,4.992-9.549         l0.239,0.708c-2.473,0.851-4.499,4.808-4.499,8.841C329.791,250.187,332.354,252.771,334.498,254.094L334.498,254.094z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.906,284.797c-5.191-5.088-7.008-9.985-6.848-16.414         c0.147-7.58,2.932-11.403,7.836-17.489c0.13-0.165,0.371-0.188,0.525-0.049c0.163,0.123,0.201,0.354,0.061,0.521         c-4.8,5.958-7.541,9.691-7.689,17.03C329.66,274.637,331.414,279.375,335.906,284.797L335.906,284.797z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.842,163.612c2.209-2.308,3.893-4.591,4.371-7.051c0.943-4.629-0.122-8.375-3.015-10.565         c-1.128-0.848-2.524-1.218-3.875-0.962c-1.57,0.265-2.983,1.216-3.985,2.699l-1.071,0.215l0.292-0.404         c1.283-1.878,2.858-2.954,4.643-3.246c1.547-0.254,3.161,0.128,4.453,1.105c3.096,2.33,4.289,6.454,3.297,11.309         C322.443,159.364,320.629,161.811,317.842,163.612L317.842,163.612z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.359,169.648c-6.786,0-12.522-1.564-17.046-4.642c-4.943-3.348-9.698-7.521-7.384-13.124         c0.787-1.904,2.326-3.25,4.322-3.792c2.25-0.61,4.832-0.102,6.715,1.32c1.267,0.959,1.981,1.862,2.261,2.826         c0.583,2.018,0.33,3.881-0.713,5.239c-1.577,1.989-3.966,2.183-5.099,1.838c-1.565-0.496-2.759-1.65-3.2-3.083         c-0.369-1.192-0.194-2.394,0.518-3.308c0.51-0.662,1.423-0.942,2.341-0.725c1.029,0.252,1.778,1.053,1.994,2.145         c0.04,0.203-0.09,0.407-0.289,0.444c-0.195,0.062-0.411-0.102-0.447-0.305c-0.166-0.787-0.698-1.37-1.436-1.548         c-0.64-0.164-1.232,0.024-1.577,0.456c-0.548,0.697-0.689,1.661-0.395,2.613c0.382,1.205,1.384,2.167,2.709,2.588         c0.823,0.254,2.898,0.19,4.297-1.572c1.127-1.497,0.938-3.313,0.569-4.581c-0.23-0.799-0.862-1.571-1.992-2.434         c-1.707-1.279-4.043-1.737-6.051-1.191c-1.784,0.484-3.129,1.674-3.83,3.348c-2.108,5.11,2.402,9.054,7.106,12.224         c4.488,3.055,10.247,4.464,17.034,4.516c10.108-0.115,18.193-4.631,23.545-7.609l1.522-0.85         c1.424-0.773,2.924-0.645,3.763,0.318c0.925,1.165,0.792,2.826-0.342,3.852c0.443-1.421,0.342-2.648-0.245-3.373         c-0.566-0.67-1.724-0.733-2.821-0.137l-1.51,0.837c-5.431,3.031-13.602,7.597-23.913,7.711         C215.64,169.648,215.505,169.648,215.359,169.648L215.359,169.648z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.194,163.369c-3.109-1.811-4.182-3.256-4.868-6.657c-0.51-2.548-0.277-6.467,1.982-9.129         c1.998-2.41,4.743-2.829,8.163-1.256c0.179,0.076,0.268,0.306,0.179,0.496c-0.092,0.187-0.33,0.265-0.497,0.187         c-3.087-1.43-5.478-1.088-7.258,1.042c-2.099,2.472-2.301,6.124-1.829,8.511         C178.725,159.781,179.668,161.088,182.194,163.369L182.194,163.369z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.482,168.377c-3.712-1.203-7.349-5.214-7.552-10.892c-0.141-3.298,0.379-5.3,2.009-7.671         c2.465-3.655,6.85-4.478,10.625-1.993l-0.417,0.621c-3.472-2.283-7.325-1.558-9.599,1.789         c-1.51,2.217-2.01,4.109-1.882,7.228C167.869,162.824,171.313,166.616,174.482,168.377L174.482,168.377z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.163,202.759c-1.971,0-3.802-0.964-4.73-1.803c-1.678-1.496-2.351-3.741-1.741-5.844         c0.484-1.752,1.728-2.97,3.303-3.26c1.35-0.253,2.542,0.216,3.267,1.256c0.74,1.064,0.842,2.499,0.243,3.514         c-0.508,0.861-1.411,1.28-2.618,1.14c0.966-0.661,1.599-0.924,1.969-1.534c0.445-0.75,0.354-1.881-0.217-2.689         c-0.315-0.469-1.092-1.191-2.5-0.952c-1.299,0.24-2.329,1.255-2.736,2.713c-0.407,1.446-0.218,3.54,1.526,5.096         c1.131,1.028,3.787,2.261,6.179,1.207c3.455-1.56,5.008-4.619,5.008-9.928c0-6.329-5.572-12.138-9.636-16.385         c-1.375-1.434-2.568-2.702-3.33-3.74c-3.004-4.111-4.45-6.341-4.45-11.933c0-4.339,3.305-8.004,7.701-8.509l0.079,0.733         c-4.004,0.481-7.044,3.817-7.044,7.775c0,5.364,1.403,7.517,4.323,11.488c0.736,1.026,1.933,2.256,3.281,3.663         c4.139,4.338,9.826,10.287,9.826,16.907c0,5.643-1.688,8.915-5.453,10.613C172.673,202.618,171.911,202.759,171.163,202.759         L171.163,202.759z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.877,197.849c-0.114,0-0.228-0.01-0.343-0.038c0.484-0.658,0.84-0.773,1.206-1.064         c1.068-0.827,1.948-2.856,2.008-4.604c0.178-4.934-5.006-10.157-8.782-13.962c-1.284-1.305-2.455-2.471-3.253-3.461         c-3.902-4.87-5.684-7.063-5.684-11.716c0-3.629,3.356-6.317,6.507-6.545l0.054,0.748c-2.809,0.204-5.822,2.589-5.822,5.797         c0,4.387,1.73,6.516,5.159,10.778c1.159,1.446,2.304,2.6,3.588,3.88c3.863,3.896,9.176,9.246,8.975,14.51         c-0.052,1.989-1.047,4.209-2.292,5.172C170.77,197.684,170.325,197.849,169.877,197.849L169.877,197.849z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.854,245.073c-4.295,0-8.415-1.597-12.242-4.756c-0.61-0.518-0.979-0.91-1.385-1.367         l-0.966-1.033c-0.532-0.566-1.041-1.229-1.603-2.036c-1.752-2.513-3.076-5.746-3.838-9.334         c-0.483-2.196-0.584-3.905-0.61-5.148c-0.025-2.142,0.253-3.931,0.737-6.29c1.78-8.674,8.061-13.851,8.771-14.407         c5.95-4.705,15.154-6.112,20.249-0.267c2.633,3.031,3.295,7.179,1.718,10.575c-1.222,2.626-3.609,4.491-6.14,4.175         c-3.013-0.054-5.276-1.637-6.063-4.239c-0.699-2.346,0.052-4.83,1.817-6.034c1.793-1.205,3.2-1.127,4.08-0.863         c1.246,0.393,2.01,1.382,2.314,2.168c0.582,1.511-0.039,2.878-0.915,3.555c-0.865,0.668-1.935,0.694-2.799,0.05         c-0.178-0.115-0.204-0.358-0.087-0.521c0.125-0.167,0.355-0.206,0.521-0.079c0.609,0.432,1.295,0.407,1.908-0.05         c0.66-0.509,1.117-1.533,0.66-2.687c-0.229-0.62-0.839-1.41-1.833-1.727c-1.016-0.328-2.211-0.049-3.431,0.773         c-1.472,1.002-2.109,3.183-1.513,5.199c0.676,2.273,2.682,3.653,5.353,3.706c2.211-0.078,4.323-1.358,5.44-3.744         c1.478-3.132,0.842-6.959-1.602-9.762c-4.791-5.494-13.524-4.121-19.205,0.353c-2.504,1.979-7.095,7.142-8.505,13.974         c-0.484,2.308-0.765,4.057-0.738,6.125c0.038,1.207,0.127,2.879,0.609,4.997c0.738,3.5,2.022,6.646,3.714,9.066         c0.545,0.775,1.016,1.41,1.523,1.941l0.991,1.052c0.395,0.432,0.738,0.813,1.297,1.296c3.917,3.23,8.188,4.744,12.534,4.575         c2.695-0.114,4.997-1.102,6.444-2.83c1.31-1.531,1.894-3.565,1.612-5.716c-0.279-2.196-1.551-3.997-3.416-4.809         c-1.49-0.659-3.042-0.542-4.284,0.331c-1.08,0.758-1.756,2.5-1.5,3.931c0.128,0.849,0.637,1.979,2.262,2.458         c0.954,0.254,1.777-0.29,2.185-0.948c0.33-0.547,0.458-1.345-0.126-1.964c1.272,0.251,1.372,1.367,0.762,2.356         c-0.534,0.901-1.701,1.66-3.036,1.27c-1.551-0.46-2.557-1.549-2.786-3.058c-0.306-1.71,0.482-3.728,1.806-4.668         c1.422-1,3.303-1.14,5.021-0.394c2.099,0.928,3.545,2.946,3.861,5.403c0.294,2.36-0.34,4.602-1.789,6.302         c-1.59,1.865-4.068,2.968-6.991,3.082C158.386,245.073,158.133,245.073,157.854,245.073L157.854,245.073z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.744,297.436c-0.764,0-1.5-0.108-2.187-0.309c-1.985-0.59-3.485-1.824-4.246-3.459         c-0.764-1.623-0.725-3.527,0.126-5.501c0.827-1.92,2.896-3.339,5.033-3.451c1.856-0.138,3.532,0.784,4.539,2.544         c0.255,0.473,0.548,1.271,0.548,2.084c-0.038,1.142-0.485,2.559-1.401,3.175c-1.181,0.74-2.657,0.86-3.686,0.266         c-0.914-0.526-1.396-1.566-1.333-2.905c0.697,1.1,1.028,1.876,1.714,2.254c0.761,0.445,1.959,0.343,2.896-0.254         c0.652-0.434,1.019-1.607,1.059-2.547c0-0.699-0.294-1.396-0.447-1.701c-0.866-1.479-2.199-2.298-3.863-2.164         c-1.857,0.102-3.662,1.327-4.374,2.984c-0.763,1.78-0.8,3.463-0.125,4.898c0.66,1.434,2.008,2.523,3.776,3.071         c1.359,0.392,2.933,0.355,4.626-0.128c1.64-0.459,4.053-1.526,4.993-2.052c3.307-1.877,5.445-3.4,6.954-4.981         c3.571-3.658,5.885-8.096,7.081-13.534c1.42-6.573,0-13.253-0.303-14.536c-1.87-7.813-7.565-16.101-14.431-16.101         c-1.892,0-2.949,0.098-3.903,0.694c-0.353,0.228-0.901,0.649-1.472,1.381c-0.457,0.647-0.752,1.216-0.955,1.891         c-0.43,1.407-0.267,2.993,0.432,4.271c0.625,1.122,1.616,1.882,2.809,2.184c1.629,0.43,3.408,0.09,4.527-0.888         c0.991-0.862,1.412-2.181,1.208-3.803c-0.09-0.812-1.004-1.598-2.023-1.738c-1.146-0.139-2.159,0.494-2.719,1.84         c-0.078,0.191-0.305,0.277-0.485,0.201c-0.188-0.076-0.279-0.292-0.203-0.497c0.688-1.646,2.01-2.475,3.508-2.294         c1.371,0.203,2.542,1.244,2.67,2.409c0.293,2.36-0.634,3.728-1.448,4.456c-1.297,1.125-3.344,1.53-5.214,1.046         c-1.412-0.363-2.543-1.255-3.292-2.557c-0.801-1.45-0.978-3.26-0.495-4.846c0.228-0.761,0.558-1.382,1.065-2.13         c0.522-0.66,1.092-1.192,1.679-1.56c1.219-0.758,2.554-0.811,4.309-0.811c7.258,0,13.235,8.599,15.164,16.687         c0.306,1.297,1.759,8.127,0.306,14.85c-1.222,5.596-3.609,10.146-7.27,13.925c-1.565,1.61-3.765,3.185-7.119,5.095         c-0.966,0.549-3.482,1.654-5.173,2.121C151.599,297.293,150.657,297.436,149.744,297.436L149.744,297.436z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.378,293.297c-0.482,0-0.968-0.111-1.549-0.33l0.253-0.689         c1.193,0.424,1.792,0.376,3.305-0.295c0.432-0.191,0.902-0.456,1.449-0.765l0.8-0.438c2.873-1.643,6.634-4.348,10.144-10.907         c0.902-1.713,1.538-3.421,2.02-5.376c0.408-1.541,0.587-2.8,0.611-3.999c0.101-2.278-0.124-4.663-0.739-7.518         c-0.951-4.492-2.056-6.938-4.917-10.892c-1.462-1.98-2.568-2.945-4.944-2.994c2.936-0.673,4.245,0.785,5.541,2.549         c2.95,4.061,4.082,6.57,5.071,11.185c0.599,2.904,0.844,5.354,0.742,7.693c-0.013,1.244-0.221,2.568-0.626,4.146         c-0.494,2.016-1.168,3.784-2.082,5.545c-3.613,6.731-7.475,9.533-10.45,11.223c-1.373,0.762-1.882,1.04-2.328,1.229         C151.699,293.1,151.038,293.297,150.378,293.297L150.378,293.297z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.176,289.571c0.56-1.404,1.169-2.696,1.169-4.032c0-2.422-1.971-4.387-4.397-4.387         c-2.429,0-4.398,1.965-4.398,4.387l-0.661,0.962l-0.104-0.962c0-2.826,2.314-5.133,5.163-5.133         c2.845,0,5.147,2.307,5.147,5.133C155.094,287.096,154.37,288.613,153.176,289.571L153.176,289.571z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.03,285.932c0.206-1.315,0.611-2.344,0.611-3.473c0-2.325-1.828-4.21-4.094-4.21         c-2.006,0-3.723,1.476-4.068,3.513l-0.737-0.131c0.409-2.384,2.419-4.129,4.806-4.129c2.67,0,4.834,2.219,4.834,4.957         C156.381,283.789,155.922,284.981,155.03,285.932L155.03,285.932z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.046,281.762l-0.433-0.621c3.589-2.547,7.426-7.762,7.453-14.75         c0.037-5.189-2.138-10.131-4.248-11.931c3.102,1.647,5.033,7.022,4.998,11.942         C163.777,273.67,159.786,279.098,156.046,281.762L156.046,281.762z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.875,286.752c3.56-2.815,5.493-5.346,7.121-7.756c0.112-0.166,0.355-0.215,0.519-0.104         c0.167,0.116,0.22,0.344,0.104,0.524C160.928,281.901,158.948,284.526,154.875,286.752L154.875,286.752z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.351,357.965c-7.319-7.764-19.117-8.229-31.625-8.727         c-10.906-0.449-23.173-1.371-31.54-4.824c-13.666-5.613-17.25-13.53-18.595-16.522c-1.652-3.231-2.694-8.228-2.797-12.358         c-0.074-2.481,0.319-5.151,1.043-7.195c2.29-6.588,5.643-10.383,12.354-13.975c3.751-2.015,6.917-2.743,10.271-2.398         c3.941,0.436,6.218,1.83,7.373,4.506l-0.697,0.306c-1.053-2.438-3.065-3.648-6.75-4.063         c-3.204-0.349-6.229,0.375-9.839,2.313c-6.537,3.486-9.774,7.168-12,13.563c-0.701,1.954-1.068,4.547-0.994,6.915         c0.103,4.604,1.283,9.258,2.364,11.299c1.679,3.688,5.176,11.426,18.563,16.926c8.249,3.4,20.438,4.321,31.267,4.764         C209.438,348.988,221.397,349.454,228.351,357.965L228.351,357.965z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.542,317.243c-4.436,0-5.908-3.046-6.086-4.224c-0.662-3.996,2.108-5.241,2.668-5.451         c0.599-0.213,1.983-0.245,3.074,0.315c0.689,0.341,1.159,0.888,1.361,1.548c0.203,0.791,0.181,1.927-0.316,2.754         c-0.256-1.02-0.256-1.958-0.407-2.553c-0.144-0.454-0.47-0.822-0.965-1.076c-0.915-0.473-2.112-0.408-2.492-0.28         c-0.647,0.241-2.745,1.292-2.188,4.614c0.012,0.051,0.481,3.45,5.478,3.602c2.583-0.037,4.743-1.951,5.812-3.096         c1.878-2.015,3.79-6.84,2.11-11.309c-0.866-2.281-2.365-3.818-5.036-5.125c-7.246-3.584-15.124,0.648-18.151,2.64         c-0.178,0.114-0.408,0.062-0.521-0.103c-0.114-0.178-0.063-0.404,0.113-0.516c3.128-2.07,11.291-6.434,18.89-2.691         c2.823,1.367,4.473,3.079,5.406,5.541c1.79,4.754-0.245,9.932-2.268,12.072c-1.394,1.496-3.621,3.297-6.34,3.337         C171.634,317.243,171.594,317.243,171.542,317.243L171.542,317.243z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.43,369.096c4.208-1.608,6.157-4.265,6.157-6.505c0-0.677,0-1.308-0.111-1.874         c-0.538-3.187-2.777-5.584-5.214-7.953c-0.284-0.294-0.56-0.524-0.866-0.789l-0.788-0.697         c-0.577-0.578-1.372-1.076-2.14-1.561l-0.835-0.517c-2.861-1.852-6.637-3.45-11.857-5.057l-1.34-0.803l-0.101,0.356         c-0.572-0.158-1.146-0.286-1.702-0.409c-2.199-0.493-3.839-0.747-5.365-0.989l-1.803-0.295         c-2.254-0.373-4.323-0.516-6.74-0.68l-2.468-0.178c-3.394-0.215-6.148-0.165-8.794-0.102l-4.936,0.039         c-2.526,0.037-4.522,0.052-6.757-0.039l-1.198-0.052c-2.465-0.114-4.167-0.189-6.878-0.432         c-7.041-0.63-12.467-1.694-17.77-5.032c-6.393-4.089-11.198-13.41-8.174-21.938c0.192-0.586,0.535-1.729,1.375-3.119         c0.332-0.585,0.99-1.475,1.395-1.979c1.046-1.396,2.188-2.064,3.233-2.638c2.885-1.612,6.281-0.357,7.651,1.167         c1.169,1.277,1.548,2.765,1.13,4.384l-0.724-0.176c0.357-1.364,0.027-2.61-0.966-3.715c-1.169-1.297-4.218-2.424-6.723-1.018         c-0.773,0.434-1.956,1.07-2.988,2.449c-0.407,0.496-1.041,1.344-1.372,1.91c-0.774,1.316-1.106,2.39-1.27,2.895         c-2.925,8.256,1.703,17.21,7.828,21.151c5.188,3.249,10.515,4.289,17.445,4.915c2.691,0.236,4.395,0.313,6.851,0.428         l1.181,0.051c2.235,0.088,4.22,0.063,6.102,0.052l5.556-0.052c2.656-0.063,5.44-0.133,8.858,0.102l2.465,0.178         c2.441,0.166,4.541,0.314,6.813,0.693l1.808,0.279c1.523,0.254,3.19,0.508,4.904,0.901c1.069,0.233,1.654,0.371,2.237,0.533         l1.45,0.428c5.303,1.642,9.129,3.277,12.052,5.151l0.825,0.52c0.812,0.495,1.653,1.02,2.274,1.661l0.75,0.662         c0.323,0.284,0.627,0.537,0.901,0.822c2.547,2.46,4.86,4.958,5.417,8.349c0.129,0.63,0.129,1.338,0.129,2.015         C254.335,365.137,252.196,368.132,247.43,369.096L247.43,369.096z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.097,373.79c-0.116,0-0.229-0.017-0.344-0.017c-2.732-0.1-5.237-1.254-6.863-3.158         c-1.257-1.48-1.905-3.369-1.816-5.313c0.075-1.242,0.277-2.204,0.647-3.016c1.169-2.727,3.625-4.453,6.419-4.492         c1.805-0.037,3.141,0.656,4.246,1.861c1.105,1.193,1.653,2.771,1.487,4.316c-0.118,1.267-0.727,2.462-1.628,3.182         c-0.812,0.643-1.869,0.928-2.988,0.788c-1.117-0.131-2.007-0.65-2.451-1.435c-0.332-0.596-0.56-1.65,0.214-3.243l0.685,0.328         c-0.507,1.041-0.593,1.915-0.253,2.548c0.332,0.586,1.017,0.962,1.895,1.053c0.956,0.11,1.767-0.091,2.43-0.625         c0.736-0.588,1.243-1.595,1.345-2.672c0.14-1.336-0.332-2.69-1.283-3.735c-0.965-1.044-2.212-1.376-3.699-1.629         c-2.481,0.039-4.679,1.598-5.733,4.059c-0.333,0.736-0.521,1.607-0.586,2.751c-0.086,1.749,0.497,3.449,1.64,4.795         c1.488,1.734,3.789,2.783,6.327,2.886c2.268,0.106,4.212-0.735,5.852-2.303c1.857-1.789,2.974-4.335,2.974-6.854         c0-8.622-12.596-13.918-19.243-15.504c-6.638-1.571-10.731-2.205-21.867-2.825c-1.628-0.093-3.089-0.131-4.523-0.183         c-2.466-0.059-4.883-0.129-7.92-0.443c-4.475-0.458-6.722-0.68-11.072-1.697c-6.15-1.41-11.21-3.98-15.495-7.85         c-3.673-3.313-5.708-5.672-7.336-10.117c-1.436-3.772-2.21-11.506,1.538-17.334c3.065-4.783,7.415-7.627,12.93-8.424         c4.841-0.673,8.949,1.482,11.339,6.01c1.268,2.386,0.8,6.203-0.102,7.889c-0.828,1.518-3.153,3.805-6.178,3.856         c-4.655,0.376-6.039-3.036-6.229-4.224c-0.662-3.996,2.108-5.241,2.668-5.451c0.599-0.213,1.983-0.245,3.074,0.315         c0.689,0.341,1.159,0.888,1.361,1.548c0.203,0.791,0.181,1.927-0.316,2.754c-0.256-1.02-0.256-1.958-0.407-2.553         c-0.144-0.454-0.47-0.822-0.965-1.076c-0.915-0.473-2.112-0.408-2.492-0.28c-0.647,0.241-2.745,1.292-2.188,4.614         c0.012,0.051,0.481,3.45,5.478,3.602c2.685-0.037,4.82-2.143,5.532-3.459c0.799-1.5,1.231-5.047,0.102-7.178         c-2.265-4.301-5.95-6.291-10.565-5.615c-5.287,0.756-9.47,3.484-12.419,8.078c-3.584,5.588-2.847,13.031-1.472,16.656         c1.601,4.311,3.582,6.605,7.144,9.847c4.193,3.763,9.151,6.282,15.164,7.667c4.305,0.994,6.545,1.221,10.587,1.639         c3.408,0.36,5.799,0.418,8.247,0.482c1.469,0.049,2.928,0.09,4.568,0.175c11.184,0.636,15.293,1.269,21.979,2.85         c0.8,0.192,19.833,4.874,19.833,16.231c0,2.703-1.198,5.475-3.191,7.388C235.457,372.9,233.31,373.79,231.097,373.79         L231.097,373.79z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.883,377.072c-0.449,0-0.906-0.012-1.363-0.062c-2.49-0.245-4.881-2.041-5.263-3.454         c1.007,0.822,3.052,2.489,5.34,2.705c3.15,0.313,5.491-0.426,7.846-2.41c2.453-2.053,3.976-5.516,3.976-9.021         c0-1.696-0.382-4.092-1.423-5.751c-3.648-5.708-7.906-7.625-13.807-10.252l0.306-0.682         c6.024,2.688,10.375,4.627,14.133,10.523c1.135,1.789,1.53,4.363,1.53,6.161c0,3.718-1.603,7.396-4.221,9.587         C241.8,376.231,239.59,377.072,236.883,377.072L236.883,377.072z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.78,220.612c-2.098,0-3.955-0.609-5.172-1.344c2.006,0.315,4.806,1.054,7.803,0.242         c7.795-2.181,10.706-8.395,10.706-11.792c0-2.753-1.02-4.936-3.102-6.712l0.484-0.569c2.261,1.916,3.367,4.3,3.367,7.281         c0,3.626-3.063,10.221-11.25,12.515C166.651,220.495,165.683,220.612,164.78,220.612L164.78,220.612z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.337,227.371c-2.781,0-5.223-0.723-7.458-2.219c-3.089-2.067-4.348-4.831-4.855-6.783         c1.208,1.633,2.389,4.223,5.274,6.173c2.148,1.42,4.817,1.979,7.185,2.081c4.598-0.076,8.414-2.512,10.447-4.782         c1.374-1.495,2.188-3.129,2.188-4.349c0-1.75-0.485-2.727-1.782-3.638l0.43-0.609c1.489,1.04,2.101,2.27,2.101,4.248         c0,1.421-0.867,3.197-2.377,4.86c-2.15,2.381-6.154,4.943-11.007,5.006C165.431,227.371,165.379,227.371,165.337,227.371         L165.337,227.371z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.797,237.959c0.495-1.142,1.249-1.713,1.946-2.306c3.063-2.662,4.374-5.176,4.374-8.395         c0-2.449-0.586-4.034-1.959-5.291l0.521-0.547c1.512,1.397,2.188,3.198,2.188,5.838c0,3.46-1.386,6.134-4.641,8.951         C173.516,236.844,172.723,237.438,171.797,237.959L171.797,237.959z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.821,254.725c1.741-1.955,4.296-4.539,4.296-9.41c0-3.819-1.301-6.316-4.602-8.903         l0.455-0.582c3.521,2.74,4.896,5.401,4.896,9.485C178.866,250.528,176.122,253.305,173.821,254.725L173.821,254.725z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.573,285.273c3.917-5.898,5.668-10.637,5.544-16.879         c-0.153-7.316-2.761-10.867-7.731-17.03c-0.125-0.167-0.102-0.398,0.066-0.521c0.15-0.139,0.39-0.115,0.52,0.049         c4.932,6.116,7.728,9.942,7.894,17.489C179.004,274.812,177.188,279.709,172.573,285.273L172.573,285.273z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.472,162.978c-3.178-1.143-4.997-3.588-5.546-6.266         c-0.962-4.943,0.206-8.963,3.333-11.309c1.285-0.977,2.822-1.396,4.424-1.105c1.78,0.292,3.356,1.357,4.5,3.018l0.114,0.837         l-0.317,0.203l-0.076-0.102c-1.36-2.003-2.771-2.966-4.348-3.219c-1.333-0.216-2.718,0.115-3.867,0.962         c-2.869,2.167-3.938,5.92-3.022,10.565C186.175,159.071,187.828,161.29,190.472,162.978L190.472,162.978z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.772,165.017c-0.115,0-0.245,0-0.345-0.01c-8.008-0.241-12.735-2.246-17.489-7.383         c5.134,4.464,9.735,6.394,17.515,6.635c2.035-0.026,6.456-0.646,9.029-2.448c2.283-1.648,2.995-3.679,2.171-6.214         c-0.216-0.646-0.675-1.623-1.207-2.804c-1.421-3.09-3.358-7.318-3.498-10.6c-0.328-8.206,3.482-11.3,6.75-12.453         c5.594-1.954,11.415,1.333,16.095,3.994c1.878,1.067,3.569,2.03,4.981,2.498c2.567,0.85,3.863,0.952,6.219,0.964         c2.3-0.012,3.592-0.114,6.136-0.964c1.423-0.468,3.104-1.431,4.983-2.498c4.685-2.661,10.477-5.959,16.072-3.994         c3.281,1.153,7.115,4.236,6.781,12.453c-0.133,3.271-2.068,7.493-3.48,10.562c-0.557,1.195-1.016,2.183-1.22,2.842         c-0.862,2.546-0.153,4.578,2.161,6.214c2.566,1.802,6.809,2.372,9.029,2.448c7.777-0.242,12.379-2.171,16.954-7.14         l0.554,0.505c-4.75,5.138-9.475,7.143-17.484,7.383c-2.19,0.137-6.777-0.676-9.484-2.589         c-2.592-1.824-3.408-4.195-2.44-7.059c0.213-0.663,0.68-1.691,1.239-2.921c1.391-3.017,3.283-7.149,3.409-10.284         c0.254-6.137-1.913-10.185-6.278-11.704c-5.244-1.852-10.907,1.356-15.43,3.931c-1.938,1.089-3.661,2.078-5.136,2.563         c-2.646,0.874-4.026,0.976-6.366,1c-2.396-0.025-3.804-0.127-6.444-1c-1.451-0.485-3.206-1.461-5.114-2.551         c-4.549-2.586-10.205-5.809-15.479-3.943c-4.349,1.52-6.515,5.58-6.256,11.704c0.125,3.146,2.035,7.294,3.431,10.323         c0.561,1.206,1.018,2.219,1.232,2.893c0.93,2.84,0.114,5.212-2.453,7.048C220.344,164.232,216.1,165.017,213.772,165.017         L213.772,165.017z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.973,169.648c-2.34,0-4.473-1.297-5.71-3.451c-1.22-2.146-1.282-4.652-0.169-6.541         c3.944-6.598,11.485-3.172,18.186-0.079c-0.133-0.139-0.206-0.418-0.313-0.685c-0.248-0.786-0.499-1.533-0.45-2.941         c0.074-3.121,1.444-5.2,2.896-7.393c0.98-1.473,1.98-2.995,2.596-4.909c0.936-2.904,1.152-5.085-0.712-6.898         c-1.515-1.484-3.336-1.697-5.851-0.736c-1.312,0.506-2.681,1.28-4.196,2.142c-4.002,2.257-8.974,5.072-16.255,5.188         c-7.326-0.115-12.347-2.931-16.361-5.198c-1.526-0.852-2.899-1.625-4.194-2.132c-2.521-0.977-4.31-0.736-5.851,0.736         c-1.856,1.802-1.652,3.893-0.709,6.898c0.611,1.89,1.624,3.413,2.59,4.88c1.448,2.208,2.824,4.287,2.914,7.421         c0.034,1.408-0.218,2.143-0.475,2.928c-0.133,0.404-0.277,0.837-0.405,1.41c7.03-3.945,14.668-7.497,18.308-0.608         c1.079,2.027,0.935,4.624-0.356,6.757c-2.417,4.006-8.621,4.299-10.196-0.468c-0.535-1.69-0.205-3.349,1.018-5.109         c-0.458,1.973-0.765,3.436-0.306,4.882c1.399,4.221,6.736,3.813,8.848,0.315c1.146-1.89,1.269-4.259,0.333-6.035         c-3.307-6.253-10.276-2.994-17.038,0.14l-0.659,0.316l-0.687-0.355c0.124-0.595,0.276-1.053,0.433-1.486         c0.254-0.748,0.467-1.394,0.431-2.661c-0.09-2.928-1.401-4.922-2.8-7.038c-0.989-1.511-2.02-3.069-2.665-5.06         c-0.841-2.627-1.448-5.389,0.889-7.672c1.753-1.674,3.861-1.954,6.661-0.891c1.322,0.521,2.717,1.308,4.271,2.171         c3.963,2.232,8.883,5.008,16.006,5.109c7.066-0.101,11.957-2.877,15.874-5.098c1.563-0.875,2.977-1.662,4.292-2.183         c2.828-1.063,4.938-0.783,6.665,0.891c2.14,2.09,1.905,4.578,0.892,7.672c-0.638,2.003-1.676,3.575-2.668,5.099         c-1.4,2.103-2.709,4.081-2.803,6.999c-0.021,1.28,0.18,1.926,0.436,2.673c0.155,0.433,0.307,0.892,0.43,1.474l0.141,0.737         l-1.08-0.496c-6.783-3.159-13.803-6.406-17.423-0.316c-0.983,1.644-0.921,3.866,0.163,5.783         c2.109,3.702,7.678,4.16,9.025-0.089c0.53-1.716,0.033-2.715-0.971-4.489l0.66-0.368c1.047,1.849,1.645,3.08,1.023,5.084         C267.91,168.302,266.204,169.648,263.973,169.648L263.973,169.648z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.981,151.512c-3.764-0.037-5.58-0.558-9.689-2.751c-1.233-0.647-2.108-1.291-2.851-1.828         c-1.255-0.936-2.105-1.543-3.694-1.543c-0.395,0-1.042,0.241-1.577,0.785c-0.421,0.433-0.905,1.191-0.878,2.396         c-0.383-1.304,0.176-2.155,0.634-2.625c0.534-0.542,1.25-0.887,1.822-0.887c1.717,0,2.628,0.671,3.899,1.597         c0.74,0.531,1.605,1.167,2.799,1.815c4.038,2.154,5.833,2.664,9.536,2.711c3.655-0.047,5.44-0.557,9.485-2.711         c1.179-0.634,2.029-1.257,2.737-1.79c1.3-0.951,2.231-1.622,3.97-1.622c0.457,0,1.232,0.229,1.884,0.874         c0.431,0.458,0.935,1.254,0.914,2.525l-0.345-0.014c0.037-1.152-0.418-1.862-0.824-2.269         c-0.525-0.544-1.193-0.785-1.629-0.785c-1.625,0-2.479,0.621-3.76,1.559c-0.739,0.545-1.59,1.166-2.786,1.813         C259.523,150.954,257.715,151.476,253.981,151.512L253.981,151.512z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.811,159.657l0.025-0.104l-0.345,0.09c0.446-1.193,0.675-1.841,0.637-2.995         c-0.089-2.916-1.347-4.921-2.682-7.038c-0.954-1.512-1.932-3.068-2.566-5.06c-0.876-2.65-1.628-5.653,0.684-7.901         c2.211-2.117,4.96-1.382,6.865-0.646c1.321,0.518,2.72,1.305,4.269,2.179c3.967,2.223,8.875,4.983,15.965,5.112         c-7.283,0.609-12.304-2.192-16.32-4.462c-1.523-0.853-2.898-1.611-4.196-2.133c-2.515-0.99-4.348-0.747-5.847,0.736         c-1.877,1.813-1.64,4.058-0.711,6.886c0.61,1.927,1.63,3.45,2.593,4.947c1.451,2.181,2.822,4.258,2.901,7.353         c0.036,1.357-0.203,2.094-0.436,2.867L231.811,159.657L231.811,159.657z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.663,144.044c3.458-0.433,6.398-1.305,8.951-2.347c-2.732,1.026-5.767,1.815-8.961,1.98         l-0.041-0.75c6.715-0.341,12.77-3.589,16.777-5.733c1.847-0.987,3.186-1.712,4.078-1.878         c2.666-0.541,4.088-0.188,5.867,1.436c-2-0.799-3.74-0.99-6.179-0.052c-1.294,0.521-2.667,1.28-4.198,2.143         C266.945,141.103,261.963,143.916,254.663,144.044L254.663,144.044z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.613,169.542l-0.409-0.618c0.812-0.522,1.423-1.369,1.829-2.525         c0.589-1.865,0.484-3.235-0.328-4.428c1.928,1.261,1.989,2.717,1.634,4.645c-0.23,1.305-1.046,2.027-1.979,2.866         c0.102-0.354,0.213-0.662,0.345-0.927C267.393,168.962,267.016,169.289,266.613,169.542L266.613,169.542z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.325,163.207c0-1.284,1.045-2.346,2.378-2.346        c1.296,0,2.352,1.062,2.352,2.346c0,1.304-1.056,2.36-2.352,2.36C241.37,165.567,240.325,164.511,240.325,163.207        L240.325,163.207z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.92,299.389c-0.623-0.787-0.535-1.472-0.436-2.224c0.176-1.172,0.176-3.005,0.176-3.005         l-0.044-19.705h0.733v19.705c0.063,0,0.063,1.891-0.123,3.105C330.135,298.033,330.041,298.73,329.92,299.389L329.92,299.389         z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.334,300.169c-0.533-1.142-0.344-2.153-0.193-3.356c0.156-1.164,0.193-2.979,0.193-2.979         l-0.081-21.292h0.771v21.292c0.049,0.012,0.018,1.872-0.13,3.071C329.73,298.127,329.538,299.171,329.334,300.169         L329.334,300.169z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.023,265.39 329.253,247.647 330.023,247.647 330.023,265.39        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.35,263.475 329.616,249.055 330.35,249.055 330.35,263.475        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.35,241.509 329.616,230.706 330.35,230.706 330.35,241.509        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.023,242.753 329.253,229.427 330.023,229.427 330.023,242.753        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.973,219.65v4.194V219.65z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.641,218.799v6.074V218.799z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.973,210.694v4.313V210.694z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.641,209.63v6.087V209.63z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.973,196.479v7.963V196.479z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.023,205.598 329.253,194.716 330.023,194.716 330.023,205.598        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.894,326.814c-1.296-0.951-4.959-3.234-8.199-4.537c-2.418-0.986-3.824-1.323-6.267-1.754         c-2.795-0.496-4.4-0.479-7.322-0.496c-1.842,0-3.14,0.129-4.732,0.281l-1.725,0.166c-1.526,0.128-2.721,0.291-3.914,0.46         c-1.325,0.204-2.646,0.376-4.351,0.505c-3.405,0.212-5.084,0.316-7.829,0.195c-3.29-0.161-5.197-0.297-8.441-1.044         c-3.168-0.724-5.11-1.192-8.134-2.692c-2.899-1.482-4.638-2.575-7.222-5.068l-0.736-0.762l1.272,0.228         c2.493,2.435,4.194,3.487,7.016,4.936c2.946,1.454,4.767,1.901,7.969,2.622c3.192,0.737,5.072,0.875,8.33,1.029         c2.704,0.111,4.344,0.025,6.809-0.142c2.592-0.181,3.893-0.352,5.215-0.544c1.193-0.17,2.414-0.344,3.94-0.473l1.727-0.163         c1.717-0.163,3.077-0.355,5.163-0.277c2.77,0,4.348,0.026,7.093,0.508c2.453,0.427,3.963,0.782,6.43,1.786         c3.193,1.295,7.045,3.618,7.92,4.782c0.322-1.183,4.182-3.499,7.362-4.782c2.436-1.004,3.968-1.359,6.422-1.786         c2.833-0.508,4.815-0.508,7.457-0.508c1.838,0,3.132,0.126,4.73,0.277l1.78,0.163c1.556,0.129,2.743,0.303,3.948,0.473         c1.319,0.192,2.611,0.363,4.313,0.498c3.37,0.213,5,0.311,7.689,0.188c3.258-0.154,5.133-0.292,8.35-1.029         c3.235-0.739,5.049-1.179,7.965-2.633c2.844-1.438,4.52-2.49,7.025-4.925c2.427-2.409,3.563-3.94,5.008-6.812l0.672,0.342         c-1.469,2.917-2.68,4.556-5.16,7.004c-2.568,2.493-4.294,3.57-7.203,5.061c-2.991,1.478-4.848,1.951-8.141,2.7         c-3.266,0.747-5.184,0.883-8.471,1.044c-2.723,0.133-4.377,0.017-6.893-0.145c-2.62-0.18-3.926-0.352-5.267-0.556         c-1.185-0.169-2.371-0.332-3.902-0.46l-1.788-0.176c-1.682-0.167-3.104-0.271-5.008-0.271c-2.769,0-4.323,0.027-6.971,0.496         c-2.462,0.431-3.877,0.768-6.28,1.754C259.318,323.58,255.646,325.863,254.894,326.814L254.894,326.814z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.562,326.473c-1.343-0.961-5.023-3.244-8.236-4.535c-2.388-0.991-3.817-1.309-6.252-1.77         c-2.684-0.455-4.249-0.479-6.968-0.49c-2.11,0-3.494,0.125-5.314,0.307l-1.485,0.14c-1.452,0.126-2.607,0.286-3.752,0.45         c-1.385,0.191-2.73,0.393-4.523,0.51c-3.079,0.227-4.806,0.344-7.81,0.189c-3.302-0.123-5.21-0.307-8.45-1.043         c-3.294-0.732-5.173-1.227-8.124-2.701c-2.974-1.48-4.704-2.557-7.22-5.043c-1.283-1.242-2.222-2.285-3.063-3.435         c1.435,0.671,2.339,1.683,3.583,2.9c2.443,2.426,4.132,3.459,7.031,4.907c2.896,1.448,4.653,1.915,7.956,2.639         c3.179,0.721,5.06,0.9,8.317,1.025c2.958,0.115,4.66,0.014,7.598-0.172c1.905-0.133,3.231-0.324,4.602-0.52         c1.144-0.154,2.313-0.334,3.788-0.464l1.475-0.134c1.845-0.18,3.252-0.303,5.402-0.303c2.757,0.008,4.363,0.035,7.097,0.507         c2.498,0.455,3.938,0.78,6.392,1.813c3.165,1.25,7.03,3.589,7.955,4.768c0.242-1.068,3.905-3.383,7.362-4.768         c2.453-1.033,3.905-1.358,6.394-1.813c2.749-0.472,4.321-0.499,7.12-0.507c2.12,0,3.508,0.123,5.338,0.303l1.55,0.134         c1.452,0.13,2.622,0.31,3.764,0.464c1.369,0.195,2.707,0.387,4.45,0.508c3.053,0.209,4.75,0.332,7.725,0.184         c3.268-0.125,5.138-0.305,8.354-1.025c3.343-0.736,5.097-1.219,7.935-2.639c3.191-1.571,4.76-2.674,7.029-4.907         c2.476-2.444,3.609-3.979,5.033-6.823l1.114-0.516l-0.288,0.577c-1.617,3.201-2.783,4.783-5.339,7.296         c-2.323,2.295-3.946,3.42-7.21,5.043c-2.898,1.463-4.776,1.969-8.112,2.701c-3.263,0.736-5.167,0.92-8.478,1.043         c-2.98,0.14-4.711,0.018-7.689-0.189c-1.885-0.117-3.238-0.318-4.625-0.51c-1.148-0.164-2.285-0.324-3.737-0.45l-1.55-0.14         c-1.793-0.182-3.176-0.307-5.264-0.307c-2.748,0.012-4.303,0.035-6.99,0.49c-2.441,0.442-3.845,0.767-6.231,1.77         C258.991,323.229,255.311,325.512,254.562,326.473L254.562,326.473z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.318,311.244c0-1.711,1.386-3.07,3.079-3.07        c1.663,0,3.047,1.359,3.047,3.07c0,1.646-1.384,3.031-3.047,3.031C167.704,314.275,166.318,312.891,166.318,311.244        L166.318,311.244z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.396,314.361c-1.755,0-3.179-1.392-3.179-3.117c0-1.736,1.424-3.16,3.179-3.16         c1.73,0,3.137,1.424,3.137,3.16C172.533,312.93,171.099,314.361,169.396,314.361L169.396,314.361z M169.396,308.265         c-1.653,0-3.003,1.327-3.003,2.979c0,1.621,1.35,2.953,3.003,2.953c1.601,0,2.972-1.358,2.972-2.953         C172.369,309.592,171.023,308.265,169.396,308.265L169.396,308.265z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "157.954,318.41 157.473,316.584 158.553,312.475 161.109,308.418 163.752,306.402          166.33,305.422 166.599,306.133 164.108,307.062 161.64,308.933 159.238,312.78 157.954,318.41        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.216,317.943c-4.652,0-6.15-3.188-6.507-4.163c1.018,0.606,2.339,3.411,6.507,3.411         c0.051,0,0.091,0,0.129,0c1.906-0.051,3.925-1.133,5.845-3.122c1.679-1.797,3.126-5.5,2.631-9.103l0.75-0.102         c0.523,3.838-1.04,7.787-2.846,9.717c-2.046,2.154-4.243,3.309-6.356,3.35C172.316,317.943,172.267,317.943,172.216,317.943         L172.216,317.943z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172.533,317.497 177.276,314.287 178.903,312.106 180.277,308.11 180.454,305.98          181.205,306.041 180.67,309.813 179.542,312.475 177.811,314.807 174.494,317.042 172.533,317.497        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.506,314.137l-0.306-0.205c1.259-2.23,1.5-5.719,0.458-7.738         c-0.609-1.15-1.348-2.166-2.209-2.998l0.531-0.533c0.916,0.887,1.703,1.963,2.353,3.193c1.169,2.247,0.899,6.006-0.143,7.875         L177.506,314.137L177.506,314.137z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.272,357.885c-7.394-7.039-18.786-7.48-30.836-7.964         c-10.255-0.417-23.108-1.347-31.548-4.808c-5.583-2.292-10.106-5.223-13.437-8.726l0.548-0.517         c3.252,3.425,7.689,6.299,13.167,8.543c8.339,3.429,21.101,4.352,31.298,4.755         C209.678,349.655,221.221,350.11,228.272,357.885L228.272,357.885z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.589,359.91c-1.577-2.369-3.521-4.434-5.617-6.479l0.534-0.545         C251.667,355.02,253.674,357.148,254.589,359.91L254.589,359.91z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.775,369.818l-0.953-0.561c5.731-1.176,6.776-4.156,6.977-5.048l0.74,0.163         C254.307,365.379,253.141,368.725,247.775,369.818L247.775,369.818z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.235,373.871c0.662-1.821,1.563-3.508,2.061-5.4c0.072-0.188,0.253-0.304,0.468-0.266         c0.201,0.05,0.313,0.266,0.265,0.472C247.499,370.68,246.526,372.467,245.235,373.871L245.235,373.871z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.464,368.622c-0.486-1.164-0.355-2.137-0.355-3.091c0-1.697-0.384-4.106-1.44-5.752         c-3.693-5.851-7.995-8.09-13.638-10.61c-4.563-1.985-5.314-2.175-5.795-2.296c-0.203-0.07-0.586-0.387-0.512-0.581         c0.065-0.187-0.024-0.353,0.181-0.301l-0.127,0.349l0.634-0.197c0.481,0.123,1.269,0.308,5.924,2.361         c5.77,2.557,10.156,4.844,13.971,10.867c1.435,2.239,1.533,5.285,1.533,6.16         C248.839,366.528,248.719,367.584,248.464,368.622L248.464,368.622z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.656,377.758c-0.47,0-0.967-0.03-1.475-0.082c-2.529-0.252-4.878-2.135-5.528-3.342         c1.255,0.734,3.418,2.383,5.605,2.598c3.207,0.341,5.52-0.388,7.895-2.408c0.265-0.215,0.545-0.479,0.801-0.762l0.559,0.507         c-0.297,0.304-0.587,0.585-0.876,0.829C242.478,376.932,240.325,377.758,237.656,377.758L237.656,377.758z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.069,366.023l-0.548,2.678L248.069,366.023z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "239.159,377.209 244.384,373.529 244.903,374.067 243.758,375.221 241.598,376.438          239.159,377.209        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.385,381.522c-4.128-1.446-8.034-5.037-9.736-7.683c2.263,2.143,6.025,5.592,9.736,6.985         c3.461-1.384,7.217-4.833,8.873-7.397l0.637,0.412C262.16,376.504,258.263,380.086,254.385,381.522L254.385,381.522z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.663,381.666c-3.897-1.409-7.781-4.977-9.508-7.61c1.984,2.41,5.797,5.907,9.508,7.286         c4.097-1.545,7.728-5.311,9.146-7.471l0.278,0.185C262.648,376.25,258.953,380.076,254.663,381.666L254.663,381.666z",
    style: {
      fill: "#272425"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.896,376.971l2.19-0.268L237.896,376.971z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.749,373.813c-2.109,0-3.988-1.041-5.239-2.499l0.183-0.618l0.379,0.122         c1.375,1.61,3.624,2.678,5.999,2.867C230.627,373.773,230.181,373.813,229.749,373.813L229.749,373.813z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.428,374.139c-0.101,0-0.203,0-0.305-0.01c-1.449-0.062-2.873-0.43-4.118-1.064         l0.33-0.659c1.169,0.581,2.491,0.925,3.825,0.989c2.125-0.017,4.195-0.756,5.836-2.346c1.854-1.778,2.96-4.322,2.96-6.822         c0-2.984-1.459-5.786-4.345-8.315c3.548,2.112,5.093,5.104,5.093,8.315c0,2.705-1.192,5.455-3.188,7.365         C235.802,373.24,233.652,374.139,231.428,374.139L231.428,374.139z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.071,368.318c-0.165,0-0.353,0-0.534-0.023c-1.168-0.14-2.187-0.758-2.694-1.65         c-0.353-0.652-0.636-1.762,0.104-3.368c0.073-0.196,0.277-0.266,0.478-0.196c0.208,0.093,0.281,0.318,0.192,0.513         c-0.471,1.041-0.521,1.964-0.114,2.683c0.383,0.688,1.182,1.159,2.136,1.271c0.941,0.131,1.778-0.111,2.455-0.671         c0.758-0.611,1.271-1.601,1.387-2.633c0.174-1.833-0.79-3.72-2.392-4.707c2.249,0.505,3.355,2.673,3.128,4.777         c-0.127,1.244-0.736,2.414-1.653,3.146C232.863,368.023,232.014,368.318,231.071,368.318L231.071,368.318z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.996,364.542c0-1.55,1.271-2.813,2.809-2.813        c1.562,0,2.833,1.263,2.833,2.813c0,1.548-1.271,2.788-2.833,2.788C229.267,367.33,227.996,366.09,227.996,364.542        L227.996,364.542z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.742,381.85c-4.577-1.607-8.317-5.475-9.76-7.671l-0.056-0.772l0.31-0.199         c2.061,3.115,5.818,6.582,9.507,7.945c3.402-1.355,7.193-4.818,8.886-7.391l0.62,0.417         C262.801,376.387,259.065,380.257,254.742,381.85L254.742,381.85z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.166,349.83l1.322-0.932c0.827-0.371,1.548-0.689,2.627-1.043         c1.057-0.333,1.821-0.507,2.686-0.688l1.521-0.344c0.07-0.033,0.183,0.026,0.211,0.13c0.011,0.091-0.041,0.176-0.132,0.202         l-1.526,0.344c-0.865,0.173-1.629,0.344-2.65,0.681c-1.075,0.348-1.785,0.662-2.598,1.021L271.166,349.83L271.166,349.83z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.736,355.826l0.194-0.595c0.224-0.376,0.432-0.693,0.823-1.11         c0.75-0.789,1.279-1.133,2.223-1.701c1.014-0.636,1.793-1.131,3.002-1.752c0.965-0.508,1.499-0.759,2.547-1.202         c0.941-0.446,1.5-0.677,2.484-1.053l2.06-0.811l-1.931,1.111c-0.992,0.385-1.537,0.612-2.49,1.056         c-1.014,0.445-1.564,0.697-2.518,1.192c-1.198,0.626-1.957,1.103-2.973,1.737c-0.932,0.553-1.453,0.902-2.163,1.664         c-0.355,0.375-0.558,0.697-0.791,1.053L265.736,355.826L265.736,355.826z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.488,354.408c0,0,0-0.008,0-0.024c0,0-0.356-0.557-0.356-0.568         c-0.205-0.333-0.37-0.638-0.687-0.981c-0.511-0.527-0.94-0.758-1.478-1.062c-1.473-0.892-1.878-1.062-2.619-1.435         l-1.116-0.557c-0.991-0.496-1.552-0.773-2.528-1.207l-5.176-2.076l2.844,0.695c0.995,0.42,1.542,0.649,2.47,1.076         c0.991,0.433,1.55,0.719,2.542,1.223l1.115,0.54c0.752,0.372,1.147,0.562,1.883,1.015c1.297,0.737,1.768,0.987,2.313,1.559         c0.333,0.383,0.536,0.701,0.728,1.047c0.04,0.071,0.188,0.455,0.114,0.507C239.465,354.194,239.512,354.408,239.488,354.408         L239.488,354.408z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.646,377.758c-2.67,0-4.869-0.849-6.993-2.66c-0.302-0.223-0.558-0.484-0.831-0.779         l0.412-0.633l0.117,0.116c0.251,0.254,0.486,0.493,0.776,0.708c2.363,2.034,4.67,2.74,7.883,2.422         c2.224-0.215,3.999-1.685,4.688-2.957l1.246-0.628c-0.127,0.524-0.585,1.014-0.637,1.063         c-0.74,1.367-2.732,3.025-5.232,3.266C272.59,377.728,272.109,377.758,271.646,377.758L271.646,377.758z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "271.522,377.387 275.359,375.725 276.652,374.625 277.469,373.266 278.107,373.659          277.213,375.119 275.745,376.363 273.557,377.272 271.522,377.387        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.822,374.473l-0.541-0.749c3.047-0.103,5.352-1.167,6.853-2.888         c1.124-1.352,1.714-3.045,1.622-4.813c-0.074-1.166-0.252-2.012-0.57-2.736c-0.537-1.245-1.565-2.548-2.68-3.396l0.445-0.595         c1.232,0.927,2.352,2.345,2.924,3.688c0.368,0.811,0.569,1.74,0.648,3.009c0.082,1.95-0.564,3.836-1.823,5.322         C283.064,373.207,280.572,374.36,277.822,374.473L277.822,374.473z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.189,374.139c-2.351,0-4.587-0.973-6.328-2.763c2.201,1.181,4.342,2.03,6.584,2.019         l0.023,0.734C277.365,374.139,277.281,374.139,277.189,374.139L277.189,374.139z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "277.139,374.19 277.063,373.458 279.29,373.24 282.71,371.554 284.996,368.449          285.4,365.568 286.01,366.619 285.25,369.682 283.188,372.113 279.463,373.961 277.139,374.19        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.303,364.693c0-1.625,1.299-2.905,2.898-2.905        c1.596,0,2.889,1.28,2.889,2.905c0,1.57-1.293,2.879-2.889,2.879C275.602,367.572,274.303,366.264,274.303,364.693        L274.303,364.693z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.131,358.785c6.418-8.675,18.217-9.13,30.711-9.616c10.17-0.403,22.915-1.326,31.27-4.755         c13.399-5.504,16.884-13.225,18.209-16.141c1.421-2.826,2.613-7.497,2.713-12.072c0.08-2.359-0.287-4.941-0.988-6.91         c-1.362-3.971-3.178-6.938-5.771-9.324l0.521-0.554c2.669,2.485,4.567,5.542,5.963,9.622c0.723,2.053,1.12,4.745,1.029,7.194         c-0.091,4.181-1.104,9.065-2.454,11.63c-1.678,3.709-5.265,11.638-18.929,17.254c-8.462,3.473-21.302,4.391-31.538,4.808         C299.539,350.404,287.905,350.846,281.131,358.785L281.131,358.785z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "280.621,358.479 280.115,357.927 283.875,354.738 289.494,351.649 299.641,349.615          287.131,353.613 282.834,356.478 280.621,358.479        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.328,308.783c-1.469-0.871-2.437-1.472-3.378-1.976c-2.667-1.487-5.824,0.175-6.583,1.203         l-0.608-0.431c1.013-1.374,4.588-3.098,7.55-1.432C345.322,306.691,346.396,307.355,347.328,308.783L347.328,308.783z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.442,321.462c0.647-0.696,1.144-0.417,1.234-0.733        c0.101-0.229-0.09-0.268-0.332-0.351c-0.344-0.128-0.71-0.222-1.092-0.351c-0.333-0.121-0.676-0.314-1.02-0.454        c-0.152-0.035-0.481-0.213-0.583,0.036c-0.179,0.488,1.245,0.445,0.774,1.729c-0.086,0.214-0.277,0.697-1.018,1.444        l-3.24,3.527c-0.052,0.113-0.179,0.28-0.228,0.229c-0.104-0.015-0.079-0.243-0.104-0.359l0.05-4.967        c0-0.942,0.102-1.663,0.257-2.058c0.215-0.596,0.862-0.1,1.015-0.469c0.062-0.227,0-0.25-0.365-0.39        c-0.221-0.063-0.602-0.151-1.388-0.443c-0.408-0.163-0.802-0.355-1.207-0.522c-0.193-0.066-0.521-0.316-0.648,0        c-0.055,0.103,0.101,0.238,0.127,0.269c0.431,0.345,0.557,0.546,0.557,1.152l0.092,9.091c0.034,0.666,0.089,0.837,0.218,0.887        c0.125,0.041,0.214-0.023,0.495-0.311L186.442,321.462z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.242,322.873c0.418-1.321,1.195-0.533,1.348-1.017        c0.027-0.163,0-0.205-0.368-0.333c-0.74-0.213-1.208-0.287-1.638-0.439c-0.463-0.13-0.918-0.355-1.415-0.51        c-0.113-0.014-0.393-0.164-0.493,0.064c-0.157,0.479,1.398,0.55,0.99,1.814l-2.096,6.669c-0.435,1.335-1.208,0.681-1.36,1.155        c-0.027,0.09-0.027,0.191,0.101,0.213c0.305,0.128,0.865,0.232,1.413,0.394c0.953,0.292,1.424,0.507,1.878,0.659        c0.267,0.1,0.434,0.07,0.473-0.086c0.152-0.442-1.449-0.249-0.927-1.953L190.242,322.873z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.769,324.188c0.252-0.822,0.646-0.709,1.104-0.578        c1.273,0.388,1.667,1.637,1.273,2.992c-0.243,0.823-0.562,1.599-2.48,1.014c-0.356-0.1-0.827-0.229-0.736-0.583        L194.769,324.188z M191.286,330.203c-0.485,1.773-1.388,1.005-1.55,1.439c-0.051,0.297,0.228,0.334,0.357,0.384        c0.633,0.181,1.282,0.305,1.957,0.495c0.531,0.154,0.837,0.317,1.055,0.377c0.302,0.092,0.415,0.039,0.454-0.072        c0.154-0.506-1.256-0.314-0.824-1.812l0.734-2.414c0.13-0.481,0.09-0.604,0.768-0.4c0.623,0.178,0.812,0.376,0.936,1.076        l0.397,2.509c0.15,0.931,0.28,1.919,1.257,2.208c0.532,0.169,1.449,0.111,1.577-0.323c0.023-0.123-0.027-0.219-0.128-0.248        c-0.114-0.062-0.267,0-0.393-0.038c-0.118-0.023-0.343-0.103-0.395-0.353c-0.383-2.017-0.864-4.393-0.838-4.455        c0.065-0.139,0.455-0.158,0.928-0.376c0.471-0.229,0.949-0.646,1.23-1.538c0.178-0.643,0.523-2.67-2.224-3.499        c-0.865-0.254-1.726-0.446-2.596-0.7c-0.758-0.227-0.847-0.311-1.433-0.48c-0.162-0.063-0.318-0.023-0.354,0.108        c-0.152,0.528,1.397,0.425,0.94,1.975L191.286,330.203z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.604,333.223c-0.407,1.695-1.689,0.668-1.803,1.214        c-0.102,0.315,0.152,0.353,0.355,0.405c0.523,0.129,0.966,0.164,1.832,0.37c0.823,0.214,1.258,0.356,1.755,0.479        c0.357,0.091,0.608,0.192,0.708-0.138c0.08-0.407-1.641-0.379-1.245-2.131l1.552-6.39c0.178-0.672,0.305-0.737,0.828-0.609        l1.076,0.263c1.514,0.292,0.712,1.769,1.249,1.891c0.292,0.091,0.292-0.504,0.33-0.664l0.153-1.348        c0.026-0.142,0.087-0.334-0.128-0.386c-1.17-0.289-2.033-0.425-3.915-0.898c-1.879-0.428-2.719-0.71-3.914-0.986        c-0.178-0.036-0.203,0.163-0.281,0.308l-0.635,1.821c-0.077,0.167-0.229,0.456,0.026,0.517        c0.586,0.156,0.649-1.802,2.086-1.438l1.09,0.252c0.523,0.121,0.611,0.203,0.458,0.895L201.604,333.223z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.151,329.276c0.497-0.802,1.019-0.638,1.081-0.95        c0.029-0.254-0.154-0.233-0.43-0.291c-0.342-0.064-0.736-0.064-1.092-0.123c-0.357-0.07-0.737-0.222-1.092-0.274        c-0.154-0.022-0.538-0.122-0.603,0.138c-0.085,0.486,1.338,0.195,1.085,1.563c-0.052,0.23-0.157,0.714-0.741,1.616        l-2.593,4.028c-0.022,0.092-0.125,0.273-0.216,0.273c-0.062-0.021-0.086-0.233-0.115-0.338l-0.838-4.956        c-0.154-0.898-0.178-1.615-0.125-2.05c0.125-0.592,0.867-0.236,0.927-0.631c0.065-0.232,0-0.232-0.431-0.315        c-0.216-0.047-0.586-0.047-1.411-0.216c-0.432-0.064-0.864-0.212-1.299-0.287c-0.186-0.04-0.583-0.218-0.656,0.127        c0,0.096,0.161,0.225,0.199,0.225c0.485,0.255,0.638,0.445,0.765,1.027l1.651,8.941c0.128,0.66,0.227,0.823,0.356,0.85        c0.153,0.013,0.243-0.061,0.46-0.41L217.151,329.276z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.851,337.483c0,0.354-0.026,0.479,0.279,0.605        c0.74,0.317,1.322,0.778,2.137,0.903c1.692,0.304,3.102-0.801,3.408-2.696c0.316-1.816-0.42-2.567-1.716-3.47        c-1.561-1.141-2.276-1.456-2.1-2.422c0.152-0.938,0.842-1.404,1.692-1.259c2.224,0.385,1.971,3.062,2.249,3.123        c0.306,0.052,0.383-0.128,0.407-0.432l0.179-1.951c0.039-0.341,0.102-0.548-0.09-0.581c-0.189,0-0.545,0.161-0.698,0.111        c-0.404-0.049-0.838-0.711-1.917-0.872c-1.513-0.253-2.749,0.772-3.012,2.41c-0.253,1.508,0.392,2.205,1.409,2.937        c1.948,1.365,2.707,1.701,2.53,2.913c-0.217,1.159-1.118,1.731-2.137,1.57c-1.41-0.257-2.007-1.713-2.184-3.162        c-0.026-0.189-0.026-0.309-0.243-0.359c-0.303-0.063-0.242,0.383-0.242,0.585L217.851,337.483z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.229,332.035c0.428-0.827,0.947-0.734,0.987-1.05        c0.025-0.236-0.164-0.225-0.442-0.236c-0.372-0.026-0.74,0-1.108-0.026c-0.383-0.038-0.74-0.104-1.118-0.143        c-0.178-0.021-0.548-0.09-0.585,0.181c-0.025,0.507,1.36,0.085,1.245,1.446c-0.037,0.236-0.101,0.73-0.558,1.684l-2.161,4.262        c-0.026,0.099-0.102,0.314-0.179,0.293c-0.076,0-0.126-0.206-0.153-0.316l-1.334-4.835c-0.281-0.902-0.367-1.579-0.344-2.026        c0.025-0.609,0.803-0.313,0.841-0.708c0.023-0.254-0.038-0.23-0.471-0.282c-0.217-0.008-0.584,0.028-1.414-0.059        c-0.458-0.016-0.891-0.135-1.319-0.146c-0.229-0.021-0.624-0.172-0.624,0.197c-0.023,0.071,0.153,0.188,0.188,0.199        c0.509,0.189,0.675,0.377,0.864,0.951l2.621,8.695c0.178,0.635,0.28,0.791,0.433,0.816c0.112,0.012,0.203-0.09,0.358-0.443        L237.229,332.035z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.312,339.092c-0.027,1.496-1.298,1.217-1.298,1.814        c0,0.229,0.278,0.164,0.405,0.164c0.37,0,0.714-0.069,1.144-0.037c0.46,0,0.891,0.059,1.526,0.059        c0.189,0,0.537,0.012,0.537-0.186c0-0.672-1.692,0.291-1.655-2.5l0.025-4.955c0-0.157,0.027-0.229,0.129-0.229        c0.051,0,0.112,0.071,0.2,0.188l6.253,7.635c0.106,0.114,0.167,0.19,0.359,0.19c0.154,0,0.154-0.1,0.154-0.415l0.083-8.184        c0-1.523,1.108-1.155,1.134-1.599c0-0.053,0-0.192-0.263-0.192c-0.091,0-0.565,0.038-1.391,0.038        c-0.931,0-1.295-0.06-1.527-0.071c-0.146,0-0.203,0.142-0.203,0.234c0,0.496,1.601,0.244,1.601,1.566l-0.062,4.842        c0,0.383-0.04,0.543-0.086,0.543c-0.106,0-0.258-0.16-0.411-0.365l-5.235-6.464c-0.214-0.306-0.063-0.388-0.496-0.388        c-0.711-0.021-1.055,0.043-1.387,0.043c-0.255-0.012-0.458-0.063-0.736-0.075c-0.152,0-0.218,0.114-0.218,0.236        c0,0.729,1.478-0.225,1.441,2.562L239.312,339.092z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.044,332.546c0-1.377,0.995-0.86,0.995-1.37        c0-0.161-0.078-0.19-0.468-0.202c-0.751,0-1.235,0.064-1.693,0.041c-0.456,0-0.965-0.061-1.489-0.061        c-0.112,0-0.458-0.039-0.458,0.215c0,0.505,1.411,0.099,1.411,1.419v7c0,1.378-0.953,1-0.953,1.504        c0,0.079,0.039,0.195,0.168,0.195c0.326,0,0.885-0.052,1.434-0.052c1.054,0,1.542,0.063,2.011,0.063        c0.319,0,0.433-0.063,0.433-0.206c0-0.467-1.492,0.195-1.452-1.595L252.044,332.546z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.541,339.308c0.023,1.737-1.452,1.053-1.452,1.624        c0,0.304,0.205,0.304,0.459,0.304c0.528,0,0.963-0.064,1.829-0.076c0.889,0,1.321,0.038,1.833,0.038        c0.376,0,0.659,0.038,0.659-0.291c0-0.418-1.705,0-1.705-1.788l-0.063-6.597c0-0.685,0.127-0.77,0.652-0.77h1.144        c1.493-0.066,1.104,1.542,1.623,1.542c0.341-0.013,0.192-0.558,0.151-0.748l-0.151-1.338c-0.026-0.161-0.026-0.362-0.2-0.362        c-1.249,0.018-2.11,0.078-4.046,0.108c-1.907,0.02-2.771-0.039-4.019-0.03c-0.175,0-0.175,0.189-0.2,0.367l-0.189,1.9        c-0.039,0.192-0.088,0.513,0.189,0.513c0.584,0,0.15-1.891,1.652-1.919l1.118-0.01c0.523,0,0.647,0.073,0.647,0.771        L257.541,339.308z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.212,336.554c-0.243,0.028-0.429,0.038-0.429-0.1        c-0.039-0.216,0.055-0.379,0.088-0.545l0.804-2.665c0.062-0.178,0.126-0.178,0.154-0.178c0.062,0,0,0,0.083,0.116l1.301,2.536        c0.066,0.164,0.168,0.34,0.189,0.52c0,0.149-0.189,0.149-0.407,0.181L265.212,336.554z M267.45,337.166        c0.358-0.018,0.411,0.111,0.944,1.208c0.176,0.384,0.295,0.645,0.33,0.983c0.051,0.848-0.887,0.787-0.863,1.188        c0.025,0.204,0.172,0.166,0.432,0.146c0.368-0.019,0.865-0.116,1.451-0.166c0.865-0.067,1.188-0.038,1.688-0.075        c0.345-0.033,0.468,0,0.432-0.246c-0.04-0.496-0.676,0.132-1.195-0.848l-4.23-8.635c-0.202-0.417-0.246-0.453-0.373-0.445        c-0.152,0.028-0.215,0.303-0.264,0.547l-2.873,9.066c-0.256,0.821-0.926,0.802-0.89,1.143c0,0.187,0.201,0.138,0.395,0.126        c0.368-0.023,0.749-0.126,1.146-0.158c0.428-0.035,0.825,0,1.227-0.035c0.287-0.022,0.713,0.035,0.691-0.254        c-0.04-0.403-1.449-0.038-1.523-1.088c-0.028-0.352,0.123-0.888,0.193-1.179c0.211-0.99,0.487-1.043,0.705-1.064        L267.45,337.166z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.637,331.113c-0.168-0.977-0.09-1,1.473-1.213        c2.529-0.332,1.73,1.49,2.342,1.4c0.316-0.033,0.164-0.488,0.126-0.683l-0.243-1.433c0-0.122-0.124-0.253-0.277-0.225        c-1.146,0.135-2.037,0.344-2.949,0.438c-2.014,0.269-2.973,0.332-3.502,0.403c-0.183,0.02-0.264,0.159-0.234,0.281        c0.052,0.574,1.473-0.082,1.625,1.217l0.891,6.761c0.252,1.769-0.861,1.12-0.77,1.788c0.029,0.09,0.129,0.155,0.284,0.132        c0.71-0.1,1.269-0.228,1.665-0.296c0.576-0.062,1.043-0.062,1.544-0.128c0.329-0.031,0.606-0.031,0.583-0.313        c-0.066-0.392-1.477,0.151-1.69-1.452l-0.277-2.14c-0.118-0.831-0.196-0.985,0.388-1.088l0.997-0.097        c1.353-0.183,1.165,1.377,1.6,1.337c0.306-0.05,0.151-0.549,0.124-0.73l-0.429-2.563c-0.065-0.409-0.182-0.371-0.284-0.343        c-0.281,0.038-0.127,1.364-1.27,1.535l-0.787,0.097c-0.58,0.066-0.58-0.035-0.689-0.668L277.637,331.113z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.404,334.437c0.561,2.904,2.67,4.516,5.287,4.061        c4.09-0.791,4.24-4.442,3.865-6.462c-0.576-3.035-2.828-4.52-5.354-4.027C283.113,328.601,281.857,331.291,282.404,334.437        L282.404,334.437z M283.846,333.325c-0.352-2.086-0.068-4.18,2.093-4.62c1.649-0.327,3.529,1.026,4.115,4.193        c0.456,2.378,0.104,4.442-2.121,4.894C285.621,338.251,284.254,335.426,283.846,333.325L283.846,333.325z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.072,328.25c-0.228-0.863,0.182-0.951,0.639-1.059        c1.291-0.313,2.285,0.563,2.616,1.954c0.193,0.816,0.304,1.636-1.632,2.122c-0.406,0.082-0.857,0.214-0.948-0.154        L294.072,328.25z M294.072,335.197c0.437,1.771-0.713,1.546-0.629,2.012c0.093,0.295,0.346,0.193,0.475,0.132        c0.637-0.132,1.261-0.372,1.963-0.537c0.528-0.099,0.888-0.143,1.115-0.183c0.304-0.079,0.365-0.19,0.331-0.325        c-0.132-0.491-1.226,0.386-1.606-1.15l-0.584-2.43c-0.123-0.509-0.197-0.59,0.469-0.739c0.615-0.163,0.891-0.078,1.328,0.467        l1.588,1.97c0.633,0.732,1.247,1.531,2.26,1.306c0.486-0.127,1.273-0.645,1.174-1.09c-0.031-0.119-0.131-0.161-0.258-0.149        c-0.116,0.03-0.242,0.149-0.354,0.161c-0.103,0.05-0.356,0.111-0.496-0.102c-1.361-1.57-2.938-3.363-2.963-3.443        c-0.027-0.142,0.305-0.373,0.586-0.767c0.305-0.429,0.558-1.024,0.329-1.951c-0.181-0.66-0.891-2.587-3.683-1.915        c-0.863,0.186-1.735,0.456-2.594,0.669c-0.804,0.188-0.927,0.149-1.502,0.293c-0.168,0.042-0.258,0.13-0.227,0.293        c0.123,0.503,1.396-0.354,1.752,1.215L294.072,335.197z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.612,332.839c0.429,1.671-1.188,1.373-1.032,1.913        c0.076,0.322,0.277,0.254,0.533,0.195c0.499-0.158,0.889-0.307,1.76-0.534c0.86-0.201,1.295-0.251,1.789-0.394        c0.368-0.09,0.646-0.129,0.539-0.473c-0.072-0.364-1.621,0.446-2.057-1.278l-1.663-6.379        c-0.193-0.686-0.065-0.795,0.476-0.927l1.063-0.262c1.449-0.443,1.449,1.235,1.942,1.09c0.345-0.07,0.067-0.587,0-0.765        l-0.493-1.254c-0.026-0.153-0.088-0.344-0.281-0.294c-1.192,0.321-2.032,0.587-3.878,1.069        c-1.855,0.479-2.746,0.656-3.926,0.954c-0.179,0.059-0.11,0.252-0.11,0.388l0.272,1.919c0.044,0.188,0.044,0.507,0.309,0.441        c0.557-0.157-0.265-1.89,1.132-2.273l1.095-0.275c0.521-0.128,0.672-0.102,0.836,0.594L304.612,332.839z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.357,323.873c-0.363-1.315,0.714-1.091,0.582-1.569        c-0.062-0.163-0.122-0.163-0.492-0.067c-0.736,0.217-1.165,0.383-1.64,0.514c-0.431,0.123-0.956,0.199-1.432,0.32        c-0.132,0.062-0.433,0.093-0.374,0.324c0.127,0.479,1.449-0.289,1.806,0.986l1.884,6.732c0.38,1.33-0.638,1.218-0.521,1.726        c0.039,0.06,0.061,0.169,0.188,0.13c0.334-0.078,0.865-0.293,1.43-0.457c0.974-0.281,1.444-0.343,1.926-0.477        c0.287-0.07,0.381-0.16,0.347-0.32c-0.118-0.447-1.36,0.605-1.845-1.135L311.357,323.873z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.154,327.158c0.939,2.787,3.243,4.081,5.744,3.271        c3.969-1.345,3.615-4.981,2.952-6.91c-0.995-2.944-3.417-4.092-5.85-3.249C314.045,321.299,313.137,324.102,314.154,327.158        L314.154,327.158z M315.428,325.822c-0.688-1.984-0.715-4.104,1.383-4.844c1.619-0.568,3.676,0.523,4.689,3.592        c0.766,2.283,0.713,4.362-1.418,5.121C317.872,330.49,316.098,327.842,315.428,325.822L315.428,325.822z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.73,319.246c-0.299-0.822,0.079-0.992,0.534-1.172        c1.222-0.476,2.313,0.26,2.831,1.578c0.311,0.809,0.549,1.6-1.328,2.33c-0.332,0.158-0.801,0.321-0.943-0.023L324.73,319.246z         M325.721,326.109c0.682,1.699-0.48,1.631-0.301,2.074c0.098,0.271,0.326,0.132,0.457,0.066        c0.609-0.242,1.196-0.51,1.873-0.783c0.504-0.207,0.871-0.275,1.051-0.358c0.307-0.131,0.381-0.229,0.307-0.358        c-0.18-0.48-1.172,0.549-1.75-0.928l-0.922-2.33c-0.194-0.48-0.307-0.543,0.332-0.783c0.627-0.256,0.9-0.193,1.418,0.262        l1.887,1.752c0.686,0.645,1.421,1.342,2.362,0.961c0.509-0.182,1.169-0.823,1.03-1.227c-0.065-0.115-0.165-0.18-0.275-0.115        c-0.118,0.039-0.192,0.167-0.323,0.229c-0.112,0.031-0.328,0.131-0.542-0.062c-1.537-1.368-3.373-2.915-3.396-2.985        c-0.063-0.143,0.254-0.406,0.495-0.852c0.218-0.461,0.368-1.099,0.034-1.986c-0.251-0.611-1.248-2.436-3.911-1.385        c-0.839,0.318-1.64,0.713-2.468,1.033c-0.775,0.294-0.902,0.275-1.443,0.512c-0.165,0.057-0.258,0.158-0.205,0.309        c0.205,0.486,1.329-0.545,1.959,0.99L325.721,326.109z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.771,288.542c-2.222-2.041-4.181-4.655-5.965-7.973c-0.963-1.813-1.667-3.64-2.122-5.564         c-0.277-1.198-0.57-2.626-0.599-4.122c-0.1-2.336,0.154-4.846,0.741-7.69c0.963-4.49,2.618-8.154,5.071-11.207         c0.875-1.116,1.766-2.257,2.658-2.802c-0.384,1.117-1.267,2.242-1.969,3.142c-2.482,3.097-4.087,6.649-5.028,11.02         c-0.583,2.815-0.811,5.201-0.732,7.508c0.047,1.445,0.326,2.816,0.579,3.984c0.463,1.863,1.124,3.625,2.06,5.387         c1.743,3.234,3.64,5.78,5.826,7.773L348.771,288.542L348.771,288.542z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.012,281.406l-0.714-0.078c-0.406-0.304-0.784-0.596-1.146-0.961         c-3.404-3.554-5.359-8.398-5.388-13.308c-0.026-4.892,1.91-10.271,4.512-12.478c-1.969,2.649-3.783,7.774-3.75,12.478         c0.029,4.718,1.908,9.373,5.156,12.784c0.338,0.329,0.69,0.611,1.063,0.877L352.012,281.406L352.012,281.406z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "345.173,265.818 344.436,265.761 345.247,260.645 347.257,256.148 348.62,254.483          345.322,263.901 345.173,265.818        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.826,298.115c-0.895,0-1.856-0.135-2.836-0.414c-0.536-0.141-1.157-0.374-1.792-0.596         l0.269-0.711c0.594,0.242,1.205,0.438,1.717,0.586c1.696,0.481,3.307,0.52,4.636,0.104c1.766-0.524,3.103-1.59,3.777-3.024         c0.658-1.428,0.62-3.128-0.133-4.91c-0.376-0.857-1.117-1.76-2-2.46c1.458,0.194,2.256,1.173,2.688,2.176         c0.843,1.975,0.895,3.888,0.131,5.505c-0.779,1.63-2.289,2.846-4.25,3.432C360.347,298.016,359.613,298.115,358.826,298.115         L358.826,298.115z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.704,287.186l-0.735-0.151l0.37,0.083l-0.283-0.881c0-1.255-0.531-2.459-1.464-3.301         l-0.661-1.567c0.345,0.151,0.61,0.446,0.865,0.708c1.391,1.283,2.01,2.689,2.01,4.16L363.704,287.186L363.704,287.186z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.984,282.281c-0.054-1.962-1.625-3.553-3.916-3.941c2.771-0.283,4.603,1.582,4.654,3.918         L360.984,282.281L360.984,282.281z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.564,257.133c-1.531,0-3.16-0.53-4.185-1.863l0.596-0.457         c1.195,1.538,3.421,1.813,5.01,1.396c1.198-0.315,2.175-1.063,2.821-2.197c0.69-1.253,0.853-2.851,0.417-4.259         c-0.201-0.672-0.493-1.242-0.96-1.903c-0.571-0.772-1.16-1.383-1.592-1.623l-0.012-0.965c1.094,0.723,1.83,1.636,2.214,2.144         c0.519,0.735,0.847,1.371,1.079,2.131c0.479,1.596,0.306,3.408-0.496,4.844c-0.752,1.305-1.884,2.193-3.294,2.549         C354.666,257.071,354.12,257.133,353.564,257.133L353.564,257.133z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "353.153,256.777 352.085,256.603 356.663,254.734 357.932,252.339 358.06,250.538          358.796,250.592 358.101,253.915 356.127,256.068 353.153,256.777        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.079,248.714c0.232,0.302,0.43,0.417,0.612,0.76c0.174,0.316,0.241,0.507,0.303,0.837         c0.025,0.345,0.053,0.534,0,0.823c-0.062,0.305-0.193,0.459-0.303,0.737L353.079,248.714z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.705,293.328c-0.587,0-1.157-0.127-1.632-0.413c-0.123-0.123-0.376-0.429-0.345-0.606         l-0.031,0.04l0.031-0.04c0-0.021,0.02-0.051,0.03-0.072c0.141-0.148,0.062-0.271,0.191-0.164         c1.399,0.712,2.798,0.57,3.636-0.141c0.447-0.366,0.888-1.037,0.496-2.121c1.132,0.876,0.869,1.952-0.01,2.688         C359.432,293.043,358.543,293.328,357.705,293.328L357.705,293.328z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.442,290.152c0-1.314,1.105-2.383,2.531-2.383        c1.407,0,2.53,1.068,2.53,2.383c0,1.338-1.123,2.398-2.53,2.398C356.548,292.551,355.442,291.49,355.442,290.152        L355.442,290.152z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.684,235.831c0-1.079,0.852-1.928,1.866-1.928        c1.045,0,1.869,0.849,1.869,1.928c0,1.038-0.824,1.901-1.869,1.901C346.535,237.732,345.684,236.869,345.684,235.831        L345.684,235.831z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.345,208.578c0-0.584,0.623-1.079,1.411-1.079        c0.779,0,1.403,0.494,1.403,1.079c0,0.585-0.624,1.092-1.403,1.092C344.968,209.67,344.345,209.163,344.345,208.578        L344.345,208.578z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.657,196.149c-1.276-0.43-2.06-1.776-2.086-3.182c-0.204-5.174,5.056-10.311,9.276-14.445         c1.399-1.356,2.649-2.573,3.471-3.601c3.753-4.691,5.256-6.57,5.316-11.148c0.025-3.091-2.707-6.235-5.605-6.466l0.047-0.745         c3.287,0.265,6.331,3.766,6.311,7.211c-0.075,4.847-1.737,6.915-5.337,11.454c-0.981,1.205-2.253,2.447-3.682,3.841         c-3.896,3.805-9.222,9.017-9.061,13.875C335.327,193.891,335.813,195.033,336.657,196.149L336.657,196.149z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.861,195.16c0-1.28,0.888-2.307,1.956-2.307        c1.06,0,1.958,1.026,1.958,2.307c0,1.255-0.898,2.281-1.958,2.281C337.749,197.441,336.861,196.416,336.861,195.16        L336.861,195.16z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.817,197.532c-1.117,0-2.059-1.065-2.059-2.372c0-2.636,4.09-2.662,4.09,0         C340.849,196.442,339.934,197.532,338.817,197.532L338.817,197.532z M338.817,192.942c-1.036,0-1.883,0.989-1.883,2.218         c0,2.385,3.738,2.41,3.75,0C340.685,193.956,339.833,192.942,338.817,192.942L338.817,192.942z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "335.004,191.84 334.264,191.686 334.699,189.617 336.83,185.69 351.353,167.895          351.863,165.324 352.012,162.051 351.732,161.227 352.747,161.962 352.051,168.138 349.318,172.841 336.271,187.997          335.409,189.859 335.004,191.84        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.531,198.876l-0.725-0.215c0.563-1.89,0.361-3.792-0.537-4.947         c-0.578-0.76-1.421-1.127-2.446-1.114c1.257-0.799,2.302-0.29,3.032,0.658C343.901,194.603,344.156,196.758,343.531,198.876         L343.531,198.876z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.782,203.049c-0.671,0-1.337-0.154-1.935-0.431c-1.063-0.457-1.934-1.027-2.641-1.737         l0.536-0.521c0.64,0.634,1.431,1.152,2.413,1.572c1.41,0.646,3.229,0.52,4.88-0.33         C339.094,202.618,337.928,203.049,336.782,203.049L336.782,203.049z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.649,177.055l0.169-1.23c1.771-1.792,3.31-3.324,4.763-4.997         c2.133-2.563,4.647-5.571,4.647-10.476c0-4.351-3.381-8.459-6.96-8.459v-0.748c4.04,0,7.723,4.386,7.723,9.207         c0,5.175-2.73,8.432-4.716,10.803c-1.584,1.853-3.138,3.398-4.94,5.199L337.649,177.055L337.649,177.055z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.908,169.048c2.72-2.683,6.485-6.184,6.665-11.232c0.123-3.108-0.356-4.999-1.888-7.253         c-0.863-1.284-1.979-2.271-3.225-2.842c-0.191-0.089-0.269-0.307-0.176-0.493c0.07-0.204,0.297-0.271,0.489-0.191         c1.38,0.633,2.61,1.711,3.552,3.119c1.601,2.396,2.137,4.412,2.007,7.696C341.128,163.217,337.187,166.895,333.908,169.048         L333.908,169.048z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.488,168.821c-0.031,0-0.054-0.012-0.054-0.023c-0.047-0.052-0.201-0.013-0.24-0.013         c-0.011,0-0.026-0.012-0.011-0.026l0.588-0.392c0.3-0.203,0.578-0.391,0.947-0.75l1.461-1.023l-0.114-0.118         c0.497-0.541,0.774-0.824,1.185-1.393c0.327-0.394,0.509-0.687,0.723-1.041c0.068,0.548-0.129,0.852-0.442,1.256         c-0.435,0.558-0.717,0.864-1.175,1.356c-0.311,0.318-0.533,0.496-0.758,0.673c-1.042,0.913-1.326,1.103-1.654,1.317         C332.875,168.697,332.612,168.821,332.488,168.821L332.488,168.821z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.18,163.955c2.294-2.588,3.228-3.97,3.991-7.08c0.496-1.952,0.417-5.82-1.802-8.483         c-0.232-0.278-0.466-0.507-0.73-0.722c-0.159-0.139-0.171-0.379-0.031-0.532c0.122-0.153,0.352-0.181,0.521-0.051         c0.291,0.254,0.543,0.52,0.812,0.837c2.403,2.867,2.491,7.038,1.967,9.144C330.096,160.327,329.059,161.873,326.18,163.955         L326.18,163.955z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.301,164.027c0,0,0,0,0-0.01l0.635-0.609c0.329-0.315,0.634-0.583,0.994-1.014         c0.533-0.648,0.782-1.026,1.218-1.75c0.23-0.354,0.378-0.634,0.534-0.952c0.127,0.471-0.014,0.762-0.24,1.128         c-0.447,0.738-0.729,1.126-1.25,1.776c-0.367,0.457-0.674,0.735-1.025,1.05c-0.049,0.065-0.459,0.344-0.549,0.309         C324.578,163.891,324.324,164.027,324.301,164.027L324.301,164.027z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.932,163.712c2.405-2.32,3.945-4.236,4.586-6.837c1.1-4.385-0.021-8.344-2.976-10.561         c-0.147-0.13-0.188-0.357-0.069-0.52c0.121-0.178,0.377-0.191,0.527-0.077c3.206,2.409,4.432,6.646,3.258,11.35         C322.546,159.87,320.916,161.923,317.932,163.712L317.932,163.712z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.949,163.446c-0.021,0-0.049,0-0.049-0.026c-0.05-0.051-0.152-0.038-0.207-0.025         c-0.02,0-0.048-0.013-0.02-0.026l0.51-0.354c0.356-0.239,0.658-0.443,1.069-0.785c0.429-0.371,0.629-0.546,1.04-0.94         c0.272-0.305,0.434-0.508,0.657-0.811l0.864-1.066l-0.132-0.09l0.719-1.305l-0.153-0.051         c0.023-0.089,0.252-0.685,0.357-0.685l0,0l0,0c0.129-0.012,0.283-0.407,0.283-0.367l-0.336,1.165         c-0.305,0.828-0.403,1.067-0.578,1.41l-0.638,1.051c-0.356,0.458-0.513,0.662-0.817,0.977         c-0.406,0.405-0.622,0.598-1.053,0.963c-0.424,0.353-0.723,0.56-1.084,0.812C317.31,163.331,317.072,163.446,316.949,163.446         L316.949,163.446z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.654,169.432c3.668-1.435,7.027-2.763,9.846-4.676c4.947-3.364,9.23-7.181,7.125-12.254         c-0.486-1.155-1.403-2.218-2.545-3.004l0.42-0.624c1.271,0.864,2.272,2.057,2.81,3.337c2.306,5.592-2.417,9.792-7.372,13.162         C307.007,167.351,303.555,168.722,299.654,169.432L299.654,169.432z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.071,160.113c-1.565,0-2.877-0.61-4.114-1.944c-0.541-0.521-0.844-0.962-0.962-1.368         c0.667-0.025,0.962,0.317,1.492,0.847c1.448,1.538,2.745,1.726,3.584,1.726V160.113L309.071,160.113z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.01,163.028c-0.685-0.316-1.317-0.786-1.729-1.255c-1.447-1.598-1.801-3.476-1.054-5.707         c0.222-0.683,0.702-1.713,1.259-2.93c1.377-3.018,3.277-7.164,3.408-10.283c0.252-6.189-1.98-10.5-6.268-12.123         c4.882,1.051,7.283,5.616,7.016,12.147c-0.14,3.284-2.068,7.493-3.469,10.563c-0.559,1.194-1.016,2.195-1.233,2.852         c-0.674,1.992-0.368,3.578,0.899,4.986c0.346,0.392,0.904,0.797,1.494,1.065L286.01,163.028L286.01,163.028z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.393,158.649l-0.912-1.012l0.774-2.967l3.463-8.269l0.843-5.093         c0-0.206,0.191-0.385,0.396-0.344c0.219,0.011,0.372,0.188,0.345,0.391l-0.176,2.588l-3.088,8.671l-1.821,5.033         L283.393,158.649L283.393,158.649z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.191,220.942c-0.854,0-1.718-0.126-2.597-0.382c-3.123-0.899-5.793-2.42-7.681-4.401         c-1.097-1.063-1.595-1.533-1.902-2.497c-0.078-0.189,0.037-0.404,0.23-0.469c0.201-0.075,0.405,0.041,0.479,0.242         c0.258,0.786,0.633,1.153,1.183,1.661c2.354,2.438,4.9,3.879,7.906,4.756c2.594,0.724,5.224,0.352,7.439-1.028         C346.877,220.292,345.086,220.942,343.191,220.942L343.191,220.942z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.156,217.606c-0.598-0.013-0.865-0.024-1.27-0.073c-0.74-0.065-1.043-0.09-1.45-0.243         c-0.436-0.155-0.711-0.355-1.018-0.571l-0.383-0.596l0.547,0.38c0.291,0.203,0.545,0.394,0.94,0.535         c0.368,0.139,0.652,0.152,1.007,0.19c0.784,0.089,1.039,0.089,1.4,0.101c0.807,0.013,1.119,0.013,1.704-0.063         c0.376-0.052,0.607-0.115,0.966-0.201c0.578-0.129,0.813-0.193,1.219-0.345l1.114-0.393l-0.061-0.126l1.296-0.507l0.06,0.125         l-2.322,1.155c-0.407,0.154-0.649,0.217-1.056,0.317c-0.551,0.128-0.789,0.19-1.196,0.243         C345.058,217.606,344.752,217.606,344.156,217.606L344.156,217.606z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.911,224.795l-0.812-0.05l0.617-0.341c0.286-0.14,0.552-0.267,0.864-0.494         c0.56-0.379,0.823-0.647,1.311-1.101c0.461-0.409,0.661-0.652,1.013-1.083c0.347-0.404,0.54-0.694,0.782-1.088         c0.518-0.851,0.682-1.152,0.953-1.736c0.214-0.457,0.343-0.825,0.48-1.203l0.347-0.916l0.065,1.05         c-0.145,0.408-0.284,0.774-0.501,1.256c-0.263,0.586-0.431,0.913-0.775,1.458c-0.455,0.722-0.662,1.029-1.018,1.459         c-0.375,0.442-0.589,0.713-1.025,1.089c-0.516,0.496-0.809,0.774-1.386,1.178         C349.489,224.503,349.216,224.645,348.911,224.795L348.911,224.795z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.958,237.364c0.178,0.102,0.306,0.164,0.487,0.266c0.275,0.164,0.469,0.229,0.771,0.38         c0.558,0.228,0.927,0.281,1.514,0.47L333.958,237.364z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.29,253.71c-0.038,0-0.078-0.013-0.116-0.041c-0.058-0.064-0.069-0.162-0.012-0.242         l3.459-3.599l-0.467,0.912l-2.742,2.917C334.375,253.697,334.343,253.71,334.29,253.71L334.29,253.71z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.033,255.371c-0.029,0-0.08-0.01-0.108-0.022c-0.077-0.068-0.077-0.17-0.026-0.242         l4.045-5.455l-3.775,5.654C335.127,255.349,335.077,255.371,335.033,255.371L335.033,255.371z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.041,286.298l-1.073-0.376c-0.455-0.334-0.873-0.625-1.378-1.094         c-0.527-0.51-0.806-0.748-1.164-1.215c-0.429-0.504-0.654-0.829-1.03-1.385c-0.059-0.07-0.041-0.181,0.039-0.228         c0.092-0.038,0.189-0.026,0.246,0.035c0.366,0.544,0.57,0.863,0.999,1.361c0.359,0.452,0.622,0.694,1.02,1.064         c0.608,0.571,1.015,0.86,1.473,1.18L337.041,286.298L337.041,286.298z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.615,312.585c-0.398-1.646,0.405-3.275,1.792-3.638        c1.41-0.327,2.861,0.706,3.289,2.375c0.403,1.659-0.395,3.281-1.775,3.633C337.498,315.288,336.021,314.238,335.615,312.585        L335.615,312.585z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.385,315.125c-1.311,0-2.521-1.056-2.872-2.516c-0.41-1.709,0.412-3.395,1.87-3.758         c1.843,0.081,3.036,0.961,3.428,2.441c0.408,1.712-0.431,3.4-1.867,3.768L338.385,315.125L338.385,315.125z M337.939,308.997         c-1.844,0.405-2.612,1.968-2.214,3.55c0.334,1.373,1.449,2.357,2.659,2.357v0.122l0.509-0.182         c1.323-0.325,2.083-1.903,1.701-3.502C340.24,309.962,339.143,308.997,337.939,308.997L337.939,308.997z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.62,283.875c-0.679-0.121-1.031-0.504-1.415-1.051c-0.403-0.443-0.633-0.697-0.81-1.039         l-0.562-1.242l-0.15,0.076l-0.842-1.713c-0.04-0.076,0-0.178,0.073-0.213c0.09-0.041,0.192,0,0.23,0.088l1.528,2.838         c0.177,0.318,0.383,0.551,0.616,0.81C347.849,283.158,348.185,283.509,348.62,283.875L348.62,283.875z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.831,298.867c-0.505,0-0.788-0.227-1.167-0.507c-0.495-0.38-0.764-0.546-1.284-0.852         c-0.597-0.353-0.823-0.493-1.187-0.676c-0.476-0.253-0.749-0.386-1.238-0.602c-0.437-0.19-0.751-0.309-1.121-0.435         l-0.533-0.365l0.639,0.053c0.377,0.125,0.706,0.234,1.166,0.438c0.483,0.218,0.76,0.37,1.247,0.626         c0.353,0.161,0.598,0.301,0.883,0.481c0.843,0.507,1.128,0.683,1.632,1.06C351.263,298.372,351.528,298.613,351.831,298.867         L351.831,298.867z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.051,317.943c-0.038,0-0.09,0-0.136-0.012c-2.876-0.053-6.061-2.328-6.976-3.848l0,0         c-0.02,0-0.532-0.549-0.77-1.079c-0.091-0.186,0.012-0.42,0.191-0.49c0.203-0.067,0.406,0,0.509,0.196         c0.171,0.434,0.64,0.9,0.64,0.9c0.794,1.281,3.754,3.518,6.413,3.58c4.996,0.268,5.478-3.563,5.478-3.601         c0.557-3.285-0.481-4.11-2.236-5.073c-0.017,0.013-0.968-0.483-2.096-0.293c1.219-0.978,2.392-0.392,2.453-0.365         c1.866,1.023,3.253,2.103,2.62,5.859C343.142,313.752,342.348,317.943,337.051,317.943L337.051,317.943z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "337.137,317.932 336.993,317.191 340.344,316.049 341.609,314.425 341.994,312.028          342.705,313.119 341.663,315.755 340.787,316.646 339.226,317.497 337.137,317.932        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.479,298.127c-0.786,0-1.537-0.111-2.222-0.324c-2.137-0.638-3.905-2.016-4.806-3.805         c-0.801-1.558-0.904-3.338-0.281-5.112c0.153,1.828,0.242,3.401,0.942,4.77c0.814,1.583,2.438,2.868,4.359,3.43         c1.247,0.386,2.684,0.386,4.309-0.008l0.181,0.737C152.083,298.016,151.253,298.127,150.479,298.127L150.479,298.127z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "150.227,297.713 148.702,297.585 148.778,296.833 150.227,296.963 152.029,296.801          153.836,296.164 152.185,297.525 150.227,297.713        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.328,293.297c-0.623,0-1.222-0.137-1.729-0.425c-0.991-0.573-1.523-1.624-1.46-2.957         c0.697,1.087,1.08,1.876,1.819,2.31c0.888,0.488,2.184,0.418,3.099-0.152c0.611-0.383,1.057-1.358,1.096-2.386         c0-0.849-0.385-1.562-0.458-1.7c-0.917-1.588-2.166-2.418-3.702-2.508h-0.012c-0.203,0-0.366-0.166-0.366-0.373         c-0.016-0.227,0.187-0.39,0.417-0.378c1.65,0,3.278,1.073,4.32,2.894c0.27,0.475,0.535,1.277,0.535,2.073         c-0.026,1.085-0.484,2.415-1.436,3.007C151.829,293.1,151.066,293.297,150.328,293.297L150.328,293.297z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.533,289.662c0-1.512,0.965-2.727,2.16-2.727        c1.204,0,2.159,1.215,2.159,2.727c0,1.503-0.955,2.727-2.159,2.727C148.498,292.389,147.533,291.165,147.533,289.662        L147.533,289.662z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.693,292.476c-1.261,0-2.239-1.237-2.239-2.813c0-1.586,0.978-2.82,2.239-2.82         c1.271,0,2.249,1.234,2.249,2.82C151.942,291.207,150.937,292.476,149.693,292.476L149.693,292.476z M149.693,287.008         c-1.16,0-2.059,1.171-2.059,2.654c0,1.475,0.898,2.637,2.059,2.637c1.142,0,2.084-1.181,2.084-2.637         C151.778,288.198,150.835,287.008,149.693,287.008L149.693,287.008z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.614,293.038l0.889-1.491c0.941-0.706,1.794-1.426,2.519-2.164         c3.609-3.729,5.922-8.166,7.094-13.57c1.128-5.224,0.535-11.093-0.307-14.531c-1.945-8.065-7.727-14.963-13.46-16.043         l0.142-0.735c6,1.13,12.036,8.268,14.043,16.604c0.866,3.506,1.463,9.52,0.316,14.858c-1.191,5.542-3.579,10.11-7.281,13.935         c-0.748,0.76-1.638,1.51-2.631,2.26L161.614,293.038L161.614,293.038z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.705,257.099c-0.521,0-1.054-0.078-1.563-0.203c-1.475-0.413-3.229-1.739-3.941-2.97         c-0.507-0.902-0.79-1.967-0.79-3.005c0.751,0.91,0.994,1.849,1.453,2.636c0.594,1.064,2.187,2.26,3.455,2.611         c1.654,0.434,3.432,0.062,4.523-0.899c0.981-0.848,1.402-2.157,1.21-3.753c-0.037-0.332-0.139-0.811-0.42-1.102l0.533-0.521         c0.436,0.443,0.573,1.073,0.636,1.521c0.282,2.359-0.647,3.715-1.473,4.424C158.412,256.654,157.077,257.099,155.705,257.099         L155.705,257.099z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "156.073,256.643 155.209,255.966 158.616,254.813 159.15,254.125 159.709,251.857          160.458,251.959 159.771,254.53 158.313,256.007 156.073,256.643        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.769,248.128c-0.458,0.192-0.711,0.357-1.042,0.7c-0.306,0.356-0.408,0.457-0.662,1.025         c-0.178,0.396-0.204,0.876-0.28,1.447L155.769,248.128z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.363,286.258c0.213-1.317,0.621-2.329,0.621-3.474c0-2.357-2.021-4.511-4.259-4.511v-0.75         c2.619,0,5.008,2.508,5.008,5.261C156.734,284.121,156.251,285.322,155.363,286.258L155.363,286.258z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.508,289.927c0.595-1.421,1.219-2.687,1.219-4.035c0-2.433-2.287-4.739-4.693-4.739         v-0.746c2.786,0,5.431,2.674,5.431,5.485C155.464,287.469,154.751,288.939,153.508,289.927L153.508,289.927z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.432,283.864c-0.017,0-0.017-0.015,0-0.026l0.376-0.459l0.701-0.859         c0.418-0.533,0.6-0.758,0.813-1.14l0.8-1.024l-0.152-0.078c0.051-0.078,0.532-0.861,0.634-0.861h0.014h0.012         c0.09,0,0.471-0.569,0.471-0.569l0,0l-0.979,1.509l0.154,0.086l-0.813,1.029l0.15,0.087c-0.229,0.38-0.418,0.633-0.672,0.953         l-0.875,1.085c-0.053,0.082-0.345,0.341-0.424,0.254C159.594,283.814,159.468,283.864,159.432,283.864L159.432,283.864z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.832,299.302l0.725-1.003c0.609-0.422,0.943-0.667,1.553-1.043         c0.506-0.313,0.813-0.508,1.347-0.785c0.429-0.228,0.758-0.367,1.115-0.531c0.093-0.041,0.56-0.152,0.599-0.08         c0.025,0.063,0.203,0.039,0.266,0.052c0.027,0,0.039,0,0.014,0.012l-0.737,0.332c-0.345,0.151-0.674,0.294-1.105,0.521         c-0.521,0.277-0.827,0.458-1.324,0.771c-0.609,0.37-0.939,0.609-1.524,1.026L155.832,299.302L155.832,299.302z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.45,253.529c-0.025,0-0.051-0.01-0.088-0.035l-0.05-0.065l-2.036-2.002         c-0.05-0.061-0.662-0.606-0.582-0.67c0.046-0.063-0.37-0.47-0.37-0.47h0.01l1.17,0.888c0.406,0.354,0.661,0.594,1.004,0.952         l1.042,1.078c0.066,0.062,0.09,0.204,0.025,0.264C173.539,253.508,173.491,253.529,173.45,253.529L173.45,253.529z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.725,264.234c-1.474-3.461-3.101-6.162-5.312-9.115c-0.129-0.164-0.09-0.407,0.077-0.538         c0.178-0.113,0.405-0.088,0.533,0.081C176.284,257.688,177.95,260.48,178.725,264.234L178.725,264.234z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.418,285.539c1.2-2.13,2.874-4.313,3.765-6.084c0.827-1.692,1.402-3.278,1.73-4.846         c0.037-0.207,0.228-0.334,0.43-0.295c0.206,0.051,0.333,0.243,0.306,0.444c-0.355,1.639-0.94,3.272-1.793,5.022         C175.917,281.672,174.226,283.875,172.418,285.539L172.418,285.539z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.149,255.078c1.729-1.965,3.177-3.815,3.85-6.135l0.726,0.228         C177.989,251.653,176.438,253.649,174.149,255.078L174.149,255.078z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.749,242.106c-1.318-1.889-2.669-3.677-4.904-5.417l0.458-0.592         C176.692,237.932,178.09,239.848,178.749,242.106L178.749,242.106z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.765,222.033c0.715,0.658,1.173,1.368,1.504,2.142L176.765,222.033z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.075,236.032c-0.896,0.802-1.759,1.293-2.543,1.598L174.075,236.032z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.946,237.123c-0.583,0.278-0.852,0.468-1.477,0.671c-0.71,0.243-1.167,0.345-1.815,0.369         L173.946,237.123z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.581,236.347c1.588-2.457,2.925-3.968,3.509-5.995c0.062-0.204,0.278-0.319,0.485-0.257         c0.19,0.053,0.302,0.269,0.241,0.458C178.166,232.749,176.717,234.396,174.581,236.347L174.581,236.347z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.896,213.79c0.635,0.432,1.104,1.025,1.412,1.583L176.896,213.79z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.694,227.702c-2.844,0-5.222-0.698-7.46-2.209c-2.669-1.776-4.548-4.348-5.133-7.048         c1.28,2.359,3.048,4.756,5.552,6.429c2.147,1.433,4.386,2.13,7.157,2.078c4.576-0.049,8.415-2.498,10.46-4.769         c0.853-0.924,1.49-1.89,1.847-2.8c0.073-0.191,0.277-0.293,0.481-0.214c0.192,0.075,0.278,0.292,0.204,0.482         c-0.383,1-1.068,2.049-1.986,3.041c-2.145,2.385-6.176,4.96-10.982,5.011C165.784,227.702,165.733,227.702,165.694,227.702         L165.694,227.702z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.264,224.671c-0.367,0-0.648-0.154-1.004-0.382c-0.711-0.457-1.094-0.787-1.717-1.384         c-0.711-0.694-1.055-1.163-1.564-1.927c-0.507-0.747-0.798-1.214-1.155-2.116c-0.167-0.417-0.242-0.748-0.331-1.09         c-0.026-0.089-0.064-0.544,0.014-0.57c0.075-0.025,0.075-0.267,0.098-0.267c0,0,0,0,0.016,0.013l0.191,0.75         c0.086,0.328,0.164,0.631,0.33,1.04c0.33,0.871,0.609,1.301,1.119,2.049c0.496,0.749,0.837,1.195,1.526,1.879         c0.607,0.582,0.962,0.888,1.679,1.344c0.43,0.289,0.76,0.443,1.115,0.623C159.481,224.658,159.365,224.671,159.264,224.671         L159.264,224.671z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.725,204.964c-1.194-1.244-2.162-2.65-3.468-3.743l0.497-0.567         C177.149,201.817,178.202,203.352,178.725,204.964L178.725,204.964z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.507,220.855c-2.416,0-4.921-0.725-6.001-1.664c1.625,0.417,5.325,1.41,8.262,0.645         c7.524-1.889,9.79-7.607,10.298-9.306c0.051-0.206,0.277-0.302,0.469-0.253c0.189,0.064,0.318,0.264,0.255,0.468         c-0.549,1.803-2.937,7.838-10.847,9.831C167.184,220.765,166.345,220.855,165.507,220.855L165.507,220.855z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.453,219.675c-0.116,0-0.231-0.014-0.371-0.014c-0.801-0.011-1.271-0.052-2.124-0.254         c-0.596-0.128-0.941-0.239-1.512-0.469c-0.432-0.178-0.711-0.341-1.045-0.544c-0.073-0.054-0.353-0.292-0.313-0.368         c0.037-0.079-0.115-0.255-0.04-0.214l0.506,0.29c0.331,0.19,0.61,0.356,1.032,0.521c0.545,0.239,0.877,0.329,1.448,0.455         c0.826,0.19,1.287,0.229,2.06,0.254c0.88,0,1.157-0.016,2.251-0.164C165.431,219.583,165.099,219.675,164.453,219.675         L164.453,219.675z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.331,215.88c-0.035,0-0.074,0-0.114,0c-3.979-0.063-6.572-2.32-6.928-6.032l0.751-0.065         c0.317,3.346,2.58,5.286,6.192,5.35c2.629-0.048,4.332-1.356,5.452-3.74c1.475-3.133,0.841-6.961-1.601-9.775         c3.201,2.546,3.877,6.693,2.288,10.091C168.151,214.323,165.888,215.88,163.331,215.88L163.331,215.88z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.142,215.465c-0.167,0-0.32-0.115-0.354-0.279c-0.052-0.205,0.063-0.407,0.252-0.459         l2.621-0.685l1.446-1.116l0.941-1.344l1.131-3.854l0.396,1.926l-1.934,3.78l-1.654,1.282l-2.744,0.735         C163.204,215.465,163.165,215.465,163.142,215.465L163.142,215.465z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.808,206.967c0.333-1.142,1.502-1.815,2.646-1.484        c1.146,0.318,1.819,1.522,1.477,2.648c-0.306,1.144-1.5,1.79-2.647,1.474C160.142,209.286,159.506,208.071,159.808,206.967        L159.808,206.967z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.871,209.772l-0.612-0.08c-1.153-0.327-1.857-1.585-1.536-2.751         c0.292-0.963,1.169-1.623,2.148-1.623c1.195,0.239,1.679,0.62,1.959,1.153c0.29,0.521,0.354,1.118,0.203,1.688         C163.765,209.108,162.874,209.772,161.871,209.772L161.871,209.772z M162.175,205.558c-1.296,0-2.034,0.599-2.29,1.435         c-0.292,1.066,0.358,2.231,1.425,2.536l0.56,0.077c0.93,0,1.742-0.62,1.981-1.498c0.154-0.518,0.102-1.076-0.176-1.557         c-0.266-0.484-0.711-0.828-1.245-0.977C162.352,205.573,162.262,205.558,162.175,205.558L162.175,205.558z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.912,220.548 147.696,219.257 149.59,212.559 151.699,209.49 154.875,207.169          157.113,206.421 157.203,206.699 155.017,207.437 151.93,209.692 149.857,212.673 147.912,220.548        ",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.513,236.195c-1.244-0.834-1.905-1.863-2.337-2.571c-1.221-2.018-2.124-4.591-2.695-7.636         c-0.166-0.737-0.254-1.522-0.357-2.384c-0.203-1.75-0.228-4.998,0.687-8.586c0.357-1.242,0.598-2.053,1.181-3.285         c0.422-0.9,1.147-2.219,1.717-2.979c0.612-0.851,1.17-1.456,1.781-1.965c0.659-0.534,1.322-1.053,1.933-1.459         c4.512-2.839,8.555-2.588,10.803-1.393l-0.151,0.29c-2.188-1.142-6.089-1.383-10.475,1.385         c-0.611,0.391-1.245,0.912-1.88,1.434c-0.612,0.493-1.145,1.085-1.729,1.898c-0.574,0.748-1.272,2.042-1.679,2.931         c-0.586,1.218-0.84,2.003-1.168,3.234c-0.916,3.539-0.877,6.722-0.79,7.557c0.203,1.749,0.293,2.536,0.458,3.26         c0.56,3.005,1.46,5.542,2.656,7.534C147.887,234.143,148.523,235.158,149.513,236.195L149.513,236.195z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.208,235.484c0-1.254,0.917-2.24,2.098-2.24        c1.131,0,2.061,0.986,2.061,2.24c0,1.219-0.93,2.248-2.061,2.248C159.125,237.732,158.208,236.703,158.208,235.484        L158.208,235.484z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.899,244.349c-2.783-0.037-5.273-1.417-7.588-3.385c-1.095-0.874-2.083-1.874-2.898-2.89         c-0.127-0.167-0.101-0.395,0.077-0.522c0.176-0.138,0.407-0.099,0.509,0.054c0.786,0.974,1.726,1.926,2.784,2.778         C149.032,242.283,151.422,243.615,153.899,244.349L153.899,244.349z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.266,245.694c-0.175,0-0.353-0.14-0.368-0.328c-0.025-0.204,0.116-0.394,0.332-0.42         c2.452-0.303,4.437-1.346,5.733-3.005c1.169-1.497,1.653-3.45,1.398-5.48c-0.419-3.307-3.51-5.716-5.365-5.869         c2.52-0.521,5.67,2.336,6.102,5.785c0.305,2.218-0.252,4.357-1.551,6.02c-1.396,1.802-3.609,2.97-6.228,3.298         C160.319,245.694,160.293,245.694,160.266,245.694L160.266,245.694z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "159.709,245.404 165.137,242.22 166.586,239.773 166.993,237.21 167.731,237.337          166.751,241.231 165.66,242.739 162.631,244.681 159.709,245.404        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.86,203.442c-1.678,0-3.33-0.671-4.421-1.522c1.879,0.52,4.347,1.293,6.357,0.38         c2.134-0.976,3.531-2.51,4.271-4.679l0.71,0.242c-0.812,2.368-2.338,4.044-4.663,5.108         C173.389,203.301,172.624,203.442,171.86,203.442L171.86,203.442z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172.166,203.074 171.302,203.01 172.166,202.325 174.785,201.338 177.48,197.888          177.973,196.392 178.688,196.621 177.456,199.421 175.19,201.944 172.166,203.074        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.521,195.806c-0.762-0.899-1.155-1.85-1.805-2.483c-0.558-0.532-1.31-0.825-2.061-0.787         l-0.012-0.745c0.931-0.142,1.894,0.315,2.608,1C172.039,193.563,172.521,194.689,172.521,195.806L172.521,195.806z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.169,197.923c-0.128,0-0.255,0-0.383-0.012c1.78-0.607,2.809-1.531,3.43-3.778         c0.051-0.189,0.28-0.305,0.458-0.254c0.205,0.051,0.318,0.254,0.253,0.457C172.689,195.249,171.947,197.923,169.169,197.923         L169.169,197.923z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.524,195.096c0-1.382,1.054-2.497,2.313-2.497        c1.293,0,2.312,1.114,2.312,2.497c0,1.383-1.019,2.525-2.312,2.525C167.579,197.621,166.524,196.479,166.524,195.096        L166.524,195.096z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.838,197.71c-1.326,0-2.395-1.165-2.395-2.614c0-2.878,4.793-2.865,4.793,0         C171.236,196.545,170.159,197.71,168.838,197.71L168.838,197.71z M168.838,192.688c-1.222,0-2.226,1.079-2.226,2.409         c0,2.691,4.46,2.691,4.46,0C171.073,193.753,170.08,192.688,168.838,192.688L168.838,192.688z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.797,195.096l0.04,1.195L171.797,195.096z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.482,168.377c-3.22-0.924-5.532-3.588-6.705-6.632c-0.06-0.187,0.029-0.404,0.218-0.481         c0.204-0.076,0.407,0.026,0.485,0.217C169.599,164.359,171.785,166.87,174.482,168.377L174.482,168.377z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.166,169.859c-0.027,0-0.061,0-0.089-0.024l-0.851-0.465         c-0.557-0.295-1.032-0.549-1.653-0.978c-0.965-0.686-1.5-1.091-2.339-1.89c-0.583-0.583-0.938-0.927-1.435-1.598         c-0.279-0.37-0.445-0.66-0.623-0.979c0.468,0.144,0.633,0.42,0.886,0.779c0.485,0.668,0.841,1,1.401,1.556         c0.824,0.788,1.346,1.193,2.299,1.849c0.626,0.421,1.083,0.675,1.616,0.965l0.863,0.481c0.078,0.039,0.115,0.141,0.064,0.229         C175.282,169.835,175.219,169.859,175.166,169.859L175.166,169.859z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.097,164.649c-0.659-0.09-1.093-0.369-1.47-0.623c-0.715-0.455-1.375-0.9-2.084-1.7         c-0.778-0.821-1.249-1.416-1.782-2.507c-0.268-0.52-0.383-0.902-0.509-1.335c-0.039-0.087-0.128-0.569-0.039-0.607         c0.09-0.026,0.039-0.34,0.074-0.29l0.271,0.798c0.125,0.418,0.253,0.786,0.497,1.281c0.534,1.066,0.966,1.623,1.726,2.448         c0.7,0.76,1.307,1.166,2.021,1.636C182.208,164.017,182.629,164.28,183.097,164.649L183.097,164.649z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.771,163.331c-0.65,0-1.105-0.229-1.64-0.66c-0.685-0.531-1.07-0.898-1.703-1.646         c-0.43-0.56-0.688-0.901-1.019-1.51c-0.228-0.432-0.354-0.773-0.494-1.142c-0.04-0.089-0.142-0.556-0.051-0.595         c0.088-0.038,0.051-0.332,0.062-0.28l0.306,0.75c0.129,0.353,0.243,0.685,0.473,1.104c0.316,0.596,0.572,0.926,0.991,1.47         c0.608,0.711,0.979,1.067,1.639,1.586c0.548,0.427,0.994,0.658,1.527,0.924C189.822,163.331,189.799,163.331,189.771,163.331         L189.771,163.331z",
    style: {
      fill: "#DBC190"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.683,155.358c-0.114-1.247,0.623-2.336,1.675-2.438        c1.045-0.128,2.035,0.797,2.163,2.054c0.115,1.216-0.621,2.332-1.679,2.435C196.776,157.524,195.813,156.598,195.683,155.358        L195.683,155.358z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.525,215.527c-2.182,0-4.32-1.217-5.563-3.221c1.777,1.433,3.737,2.598,5.721,2.473         c3.178-0.063,4.52-1.828,5.032-2.878c0.837-1.689,0.71-3.77-0.321-5.163c-0.123-0.165-0.085-0.406,0.09-0.521         c0.152-0.124,0.396-0.087,0.509,0.077c1.199,1.609,1.347,3.994,0.395,5.935c-1.004,2.041-3.084,3.246-5.683,3.298         C345.654,215.527,345.604,215.527,345.525,215.527L345.525,215.527z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.04,240.129c-0.229,0-0.433,0-0.636-0.027c-4.043-0.404-7.322-2.674-9.713-6.76         c-1.269-2.091-2.187-4.6-2.794-7.671c-0.125-0.685-0.203-1.433-0.306-2.216l-0.127-1.055         c-0.102-0.961-0.14-4.208,0.815-7.785c0.328-1.293,0.583-2.119,1.169-3.295c0.432-0.892,1.168-2.247,1.753-3.034         c0.65-0.863,1.197-1.471,1.831-1.991c0.662-0.558,1.271-1.065,1.933-1.497c5.208-3.259,10.421-2.572,12.865-0.189         l-0.521,0.544c-2.226-2.181-7.043-2.777-11.938,0.28c-0.611,0.408-1.223,0.9-1.858,1.433         c-0.584,0.485-1.093,1.051-1.701,1.876c-0.584,0.761-1.272,2.055-1.691,2.905c-0.548,1.128-0.803,1.914-1.107,3.158         c-0.927,3.448-0.889,6.656-0.8,7.509l0.128,1.05c0.09,0.774,0.164,1.495,0.292,2.169c0.597,2.968,1.475,5.4,2.709,7.431         c2.271,3.87,5.336,6.013,9.138,6.39c1.436,0.141,3.456-0.264,4.663-1.307c0.624-0.544,0.965-1.213,1.004-1.99         c0.713,1.015,0.283,1.861-0.507,2.562C160.394,239.685,158.502,240.129,157.04,240.129L157.04,240.129z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.574,169.648c-0.146,0-0.284,0-0.419,0c-10.277-0.115-18.452-4.667-23.878-7.677         l-1.586-0.871c-1.096-0.596-2.235-0.546-2.797,0.137c-0.689,0.838-0.578,2.044,0.281,2.832         c-1.663-0.51-1.807-2.171-0.859-3.311c0.779-0.963,2.33-1.091,3.731-0.318l1.603,0.877         c5.674,3.155,13.432,7.467,23.517,7.582c6.813-0.09,12.435-1.41,17.007-4.516c4.702-3.17,9.227-7.114,7.105-12.224         c-0.699-1.674-2.048-2.864-3.826-3.348c-2.037-0.545-4.373-0.088-6.074,1.206c-1.119,0.823-1.728,1.595-1.969,2.419         c-0.324,1.029-0.67,2.981,0.592,4.581c1.335,1.735,3.459,1.837,4.273,1.572c1.271-0.407,2.233-1.319,2.603-2.524         c0.321-1.001,0.157-2.028-0.419-2.766c-0.325-0.44-0.926-0.633-1.584-0.482c-0.777,0.181-1.328,0.749-1.479,1.535         c-0.032,0.203-0.255,0.331-0.443,0.308c-0.204-0.041-0.328-0.241-0.29-0.449c0.217-1.076,0.986-1.888,2.042-2.126         c0.947-0.192,1.86,0.085,2.354,0.757c0.729,0.927,0.924,2.222,0.547,3.438c-0.455,1.445-1.594,2.547-3.105,3.032         c-1.137,0.344-3.557,0.15-5.102-1.838c-1.451-1.865-1.076-4.085-0.719-5.253c0.284-0.973,0.995-1.862,2.238-2.812         c1.883-1.433,4.479-1.939,6.736-1.32c2.009,0.543,3.532,1.889,4.326,3.792c2.313,5.592-2.428,9.776-7.378,13.124         C304.979,168.124,299.408,169.648,292.574,169.648L292.574,169.648z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.787,159.617c1.065-1.117,2.079-2.079,2.466-3.311c0.302-0.99,0.167-1.965-0.387-2.69         c-0.381-0.481-0.636-0.799-1.572-0.847c-0.205-0.015-0.372-0.178-0.356-0.396c0.01-0.203,0-0.328,0.406-0.353         c1.269,0.075,1.691,0.595,2.057,1.066c0.764,0.987,0.955,2.218,0.561,3.446C312.503,157.993,311.309,159.146,309.787,159.617         L309.787,159.617z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.103,163.015c0-1.281,1.022-2.308,2.321-2.308        c1.291,0,2.348,1.027,2.348,2.308c0,1.291-1.057,2.335-2.348,2.335C264.125,165.35,263.103,164.305,263.103,163.015        L263.103,163.015z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.002,154.748c0.199-1.181,1.193-1.979,2.19-1.791        c0.978,0.178,1.625,1.27,1.452,2.426c-0.233,1.148-1.211,1.949-2.193,1.772C308.461,156.989,307.813,155.899,308.002,154.748        L308.002,154.748z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.611,169.605c1.879-2.215,2.617-2.862,2.831-5.854c0.192-2.372-0.683-4.148-2.841-5.758         c-0.171-0.127-0.206-0.37-0.08-0.534c0.129-0.163,0.355-0.189,0.535-0.076c2.386,1.788,3.357,3.78,3.124,6.426         C250.951,167.033,250.127,167.861,247.611,169.605L247.611,169.605z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "330.35,188.274 329.616,168.985 330.35,168.985 330.35,188.274        ",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.724,168.857c1.387-1.379,2.138-2.445,2.211-4.248c0.029-0.2,0.23-0.442,0.407-0.352         c0.203,0.01,0.356,0.188,0.356,0.391C250.593,166.753,249.683,168.063,247.724,168.857L247.724,168.857z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.758,147.632c-0.066-2.081-2.097-2.283-2.871-2.283        c-2.279,0-2.898,1.421-5.695,2.904c-3.562,1.903-5.064,2.32-8.21,2.359c-3.131-0.04-4.679-0.457-8.215-2.359        c-2.822-1.483-3.309-2.864-5.571-2.864c-1.216,0-2.793,1.063-2.732,2.989c0,0-0.035,0.637,0.067,1.056        c0.025,0.176,0.243,0.112,0.303,0.251c-0.023-0.937,0.154-1.432,0.612-2.053c0.584-0.824,1.577-1.025,1.982-1.025        c2.275,0,3.104,1.443,5.912,2.954c3.542,1.89,5.046,2.306,8.198,2.332c3.149-0.026,4.728-0.442,8.237-2.332        c2.832-1.51,3.639-3.082,5.886-3.082c0.8,0,1.357,0.522,1.604,1.318c0.161,0.482,0.059,0.797,0.087,0.99        c0.037,0.1,0.15,0.1,0.186,0.204C270.609,148.621,270.781,148.497,270.758,147.632L270.758,147.632z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#4B2508"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.538,152.259L254.538,152.259c-3.234-0.009-4.804-0.454-8.378-2.368         c-1.006-0.532-1.742-1.067-2.402-1.523c-1.195-0.835-1.968-1.395-3.33-1.395c-0.281,0-1.169,0.166-1.68,0.874         c-0.405,0.546-0.573,0.941-0.532,1.831l-1.053-0.179c-0.114-0.444-0.079-1.105-0.063-1.13         c-0.051-1.153,0.455-1.927,0.888-2.384c0.595-0.607,1.425-0.977,2.208-0.977c1.542,0,2.355,0.611,3.385,1.384         c0.611,0.455,1.322,0.989,2.355,1.534c3.44,1.841,4.941,2.271,8.058,2.321c3.1-0.05,4.542-0.457,8.02-2.321         c1.006-0.535,1.729-1.064,2.338-1.522c1.104-0.798,1.983-1.432,3.535-1.432c0.751,0,3.18,0.191,3.248,2.649         c0.031,0.661-0.068,0.951-0.146,1.193l-0.115-0.076l-0.883,0.15l-0.096-0.976c-0.117-0.391-0.434-1.066-1.233-1.066         c-1.28,0-2.021,0.558-3.165,1.383c-0.691,0.508-1.479,1.091-2.54,1.662C259.447,151.78,257.796,152.25,254.538,152.259         L254.538,152.259z M244.215,147.772c0.637,0.443,1.348,0.952,2.302,1.459c3.497,1.864,4.909,2.269,8.021,2.294         c3.138-0.039,4.651-0.455,8.058-2.294c1.044-0.56,1.808-1.118,2.465-1.599c1.144-0.849,2.058-1.535,3.601-1.535         c0.649,0,1.194,0.293,1.575,0.799c-0.418-1-1.586-1.178-2.35-1.178c-1.326,0-2.004,0.521-3.082,1.291         c-0.639,0.471-1.39,1.019-2.436,1.586c-3.586,1.905-5.151,2.348-8.375,2.384c-3.271-0.036-4.842-0.479-8.402-2.384         C245.055,148.317,244.609,148.039,244.215,147.772L244.215,147.772z M240.196,145.754c-0.582,0-1.216,0.294-1.675,0.764         c-0.252,0.266-0.547,0.683-0.648,1.293c0.078-0.128,0.167-0.268,0.268-0.397c0.674-0.935,1.78-1.188,2.288-1.188         c1.372,0,2.265,0.493,3.256,1.178c-0.193-0.15-0.385-0.278-0.548-0.402C242.144,146.25,241.482,145.754,240.196,145.754         L240.196,145.754z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.701,159.717c1.974-1.191,3.193-2.46,3.193-4.236c0-0.417,0.739-0.417,0.739,0         C204.633,157.613,203.157,159.186,200.701,159.717L200.701,159.717z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.215,235.743c-0.396,0-0.65-0.194-0.854-0.408c-0.456-0.454-0.866-0.91-1.323-1.562         c-1.344-2.027-2.401-4.59-2.843-7.037c-0.765-3.779-0.411-7.315-0.23-8.254c0.687-3.26,1.665-5.797,2.899-7.56         c1.446-2.044,3.455-3.476,6.099-4.359l0.253,0.708c-2.503,0.835-4.382,2.18-5.745,4.082c-1.169,1.675-2.11,4.122-2.77,7.269         c-0.179,0.898-0.507,4.309,0.226,7.972c0.433,2.35,1.437,4.809,2.746,6.764c0.408,0.596,0.812,1.025,1.22,1.455         c0.281,0.28,0.664,0.534,0.993,0.763C153.622,235.692,153.403,235.743,153.215,235.743L153.215,235.743z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.333,236.752c-1.384,0-2.515-0.834-3.659-1.986c-0.444-0.458-0.863-1.029-1.309-1.688         c-1.333-1.942-2.392-4.504-2.887-7.024c-0.71-3.691-0.418-7.23-0.175-8.283c0.7-3.348,1.64-5.822,2.885-7.543         c1.691-2.399,4.157-3.957,7.538-4.746l0.167,0.725c-3.191,0.748-5.505,2.206-7.096,4.449         c-1.184,1.65-2.082,4.034-2.759,7.281c-0.226,1-0.504,4.399,0.181,7.973c0.484,2.41,1.487,4.884,2.77,6.748         c0.42,0.612,0.812,1.155,1.22,1.586c1.577,1.573,2.928,2.385,5.163,1.951C156.607,236.576,155.945,236.752,155.333,236.752         L155.333,236.752z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.677,217.913c-0.482-3.375,0.038-5.505,2.12-7.902c1.299-1.472,2.532-2.106,3.943-2.841         c0.624-0.315,1.283-0.645,1.994-1.089c0.189-0.115,0.408-0.05,0.534,0.112c0.103,0.179,0.051,0.411-0.125,0.522         c-0.738,0.455-1.424,0.797-2.063,1.129c-1.344,0.695-2.515,1.292-3.708,2.661         C149.411,212.764,148.943,214.69,148.677,217.913L148.677,217.913z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.766,237.542c-0.438-0.064-0.926-0.129-1.642-0.686c-1.849-1.04-4.151-4.326-4.739-7.965         c-0.306-1.941-0.231-4.701,1.857-6.975c0.128-0.138,0.353-0.166,0.536-0.013c0.151,0.139,0.151,0.38,0.022,0.536         c-1.881,2.027-1.958,4.564-1.68,6.338c0.546,3.413,2.672,6.466,4.427,7.454c0.599,0.457,0.944,0.513,1.316,0.572         c0.337,0.04,0.702,0.091,1.148,0.355L335.766,237.542L335.766,237.542z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.945,227.129c-0.047,0-0.09,0-0.139,0c-4.222-0.063-8.973-1.992-11.564-4.689         c-1.758-1.802-1.881-3.817-1.835-5.188c0.038-2.03,0.634-3.234,2.116-4.236l0.429,0.62c-1.298,0.875-1.754,1.828-1.781,3.642         c-0.075,1.953,0.431,3.421,1.617,4.639c2.464,2.575,7.001,4.401,11.019,4.464c2.787-0.114,4.98-0.634,7.157-2.082         c2.912-1.937,4.083-4.524,4.523-6.335c0.244,2.13-0.979,4.883-4.104,6.959C348.149,226.406,345.705,227.129,342.945,227.129         L342.945,227.129z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.334,293.477c0,0,0,1.864-0.152,3.047        c-0.476,3.395-1.017,5.35-2.566,8.443c-1.498,2.989-2.709,4.556-5.115,6.895c-2.413,2.404-4.063,3.462-7.119,4.998        c-2.97,1.475-4.816,1.953-8.057,2.679c-3.2,0.731-5.083,0.872-8.373,1.022c-3.012,0.141-4.742,0.014-7.773-0.183        c-3.238-0.233-5.03-0.7-8.26-0.968c-2.652-0.225-4.167-0.443-6.838-0.443c-2.746,0.025-4.322,0.037-7.047,0.505        c-2.516,0.435-3.938,0.798-6.312,1.765c-3.294,1.321-6.99,3.624-7.792,4.653c-0.812-1.029-4.502-3.332-7.81-4.653        c-2.363-0.967-3.784-1.33-6.312-1.765c-2.708-0.468-4.288-0.479-7.031-0.505c-2.681,0-4.199,0.219-6.841,0.443        c-3.239,0.268-5.032,0.734-8.263,0.968c-3.026,0.196-4.752,0.323-7.778,0.183c-3.281-0.15-5.176-0.291-8.377-1.022        c-3.243-0.726-5.085-1.204-8.05-2.679c-3.048-1.536-4.714-2.594-7.117-4.998c-2.414-2.339-3.61-3.905-5.121-6.895        c-1.536-3.094-2.099-5.049-2.555-8.443c-0.153-1.183-0.153-3.047-0.153-3.047l0,0V169.229h150.774v124.248H329.334z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#DBC190"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.93,326.499l-0.306-0.381c-0.749-0.961-4.428-3.245-7.645-4.54         c-2.426-0.987-3.824-1.316-6.239-1.736c-2.691-0.474-4.245-0.481-6.963-0.505c-2.09,0-3.46,0.135-5.225,0.304l-1.591,0.136         c-1.523,0.13-2.72,0.308-3.901,0.474c-1.336,0.191-2.643,0.379-4.36,0.491c-3.141,0.226-4.817,0.343-7.82,0.193         c-3.315-0.158-5.237-0.306-8.453-1.041c-3.303-0.72-5.185-1.234-8.136-2.69c-2.972-1.498-4.714-2.588-7.207-5.073         c-2.541-2.485-3.698-4.058-5.201-7.001c-1.495-3.018-2.094-5.02-2.59-8.559c-0.153-1.198-0.153-3.094-0.153-3.094V169.229         l151.156-0.372l0.363,124.619c0.039,0,0.039,1.896-0.111,3.094c-0.49,3.551-1.092,5.541-2.606,8.559         c-1.474,2.943-2.642,4.516-5.185,7.016c-2.488,2.471-4.241,3.561-7.222,5.059c-2.924,1.456-4.802,1.971-8.118,2.703         c-3.194,0.723-5.123,0.87-8.459,1.028c-2.994,0.149-4.729,0.02-7.68-0.181c-1.85-0.125-3.148-0.313-4.499-0.504         c-1.165-0.166-2.368-0.344-3.902-0.474l-1.582-0.136c-1.759-0.169-3.138-0.304-5.216-0.304         c-2.719,0.023-4.29,0.031-6.968,0.505c-2.426,0.42-3.823,0.749-6.249,1.736c-3.205,1.295-6.89,3.579-7.64,4.54         L253.93,326.499L253.93,326.499z M232.777,318.584c2.771,0.025,4.358,0.053,7.095,0.519c2.414,0.42,3.914,0.779,6.4,1.79         c2.891,1.158,6.371,3.199,7.658,4.441c1.19-1.158,4.498-3.182,7.649-4.441c2.468-1.011,3.972-1.37,6.405-1.79         c2.735-0.466,4.322-0.493,7.084-0.519c2.121,0,3.508,0.127,5.287,0.31l1.588,0.132c1.551,0.148,2.749,0.312,3.955,0.473         c1.306,0.191,2.604,0.384,4.313,0.498c3.109,0.215,4.754,0.326,7.727,0.189c3.277-0.141,5.154-0.292,8.31-1.012         c3.335-0.738,5.091-1.205,7.961-2.64c2.894-1.464,4.599-2.512,7.031-4.938c2.474-2.418,3.606-3.956,5.044-6.812         c1.467-2.951,2.033-4.83,2.518-8.314c0.15-1.158,0.15-2.994,0.15-2.994l-0.023-124.248l-150.405,0.376l0.381,123.871         c0,0,0,1.836,0.151,2.994c0.46,3.484,1.029,5.363,2.516,8.314c1.428,2.871,2.57,4.394,5.033,6.812         c2.431,2.426,4.135,3.474,7.032,4.938c2.873,1.435,4.64,1.901,7.969,2.64c3.155,0.72,5.035,0.871,8.315,1.012         c2.975,0.154,4.679,0.025,7.602-0.178c1.816-0.126,3.112-0.318,4.425-0.51c1.193-0.161,2.412-0.324,3.955-0.473l1.589-0.132         C229.267,318.711,230.667,318.584,232.777,318.584L232.777,318.584z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 64.091,
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    },
    width: 64.344,
    x: 186.098,
    y: 176.799
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.829,241.256h-64.73l-0.369-64.458l64.713-0.38L250.829,241.256L250.829,241.256z          M250.064,176.799l-63.966,0.368l0.382,63.724l63.584-0.385V176.799L250.064,176.799z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,226.127l-1.966-0.48l-2.723-0.256l-0.204,1.852        c0,0,0.023,2.283,0.663,4.136c0.71,2.116,0.75,2.116,1.395,3.144c0.93,1.407,2.01,2.407,3.001,3.043        c1.528,0.993,3.075,1.497,4.651,1.346c4.31-0.368,6.281-5.009,7.273-8.816c1.041-4.005,3.967-6.172,5.848-4.728        c1.093,0.849,1.143,2.27,0.252,3.639c-0.993,1.471-3.226,2.18-3.226,2.18l2.302,2.946c0,0,4.941-0.662,5.883-5.798        c0.381-1.939-0.15-5.924-3.813-6.66c-4.301-0.859-6.508,1.513-7.782,3.983c-1.752,3.426-2.819,9.789-7.701,8.801        c-2.619-0.52-3.891-4.364-3.891-6.099L225.16,226.127z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.275,227.243c0,0-0.025,2.283-0.658,4.136        c-0.754,2.116-0.754,2.116-1.428,3.144c-0.903,1.407-1.979,2.407-2.974,3.043c-1.524,0.993-3.102,1.497-4.638,1.346        c-4.323-0.368-6.317-5.009-7.285-8.816c-1.042-4.005-3.965-6.172-5.848-4.728c-1.09,0.849-1.142,2.27-0.253,3.639        c0.993,1.471,3.203,2.18,3.203,2.18l-2.275,2.946c0,0-4.93-0.662-5.924-5.798c-0.33-1.939,0.599-5.565,3.855-6.66        c4.144-1.382,6.784,1.573,8.084,4.046c1.753,3.451,2.49,9.727,7.372,8.738c2.646-0.52,3.914-4.364,3.914-6.099l1.906-2.078        l2.875,0.897L216.275,227.243z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.054,199.992l8.415-9.092c0,0,1.262-1.025,1.262-2.651        l-1.717,0.277l-0.407-0.896l-0.104-0.888l2.349-0.511c0.043-0.366,0-0.657,0.068-1.089c0.051-0.369,0.152-0.557,0.243-0.964        l-2.556,0.162c0.126-0.43,0.089-0.655,0.242-1.089c0.128-0.327,0.165-0.479,0.404-0.849c0.458-0.063,0.903-0.178,1.478-0.241        c0.594-0.061,0.901-0.035,1.487-0.061c1.385-2.601,7.17-4.998,11.309-0.711c2.992,3.096,2.344,8.763-1.544,10.271        c-2.188,0.863-3.945,0.33-5.368-0.86l1.553-3.032c2.123,1.268,3.917-0.319,3.787-1.954c-0.153-2.077-1.501-3.345-3.431-3.523        c-1.755-0.141-3.013,0.836-3.814,2.434c-0.48,0.952-0.28,1.662-0.43,2.724c-0.178,1.157-0.092,1.815-0.435,2.995        c-0.242,0.835-0.89,1.89-1.844,2.804l-8.632,9.332l-33.634,36.27l-2.53-2.335L224.054,199.992z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.292,203.203c0,0,2.098,10.46,9.281,26.12        c3.674-1.343,5.819-2.208,9.688-2.208c3.888,0,6.035,0.739,9.687,2.208c7.165-15.66,9.303-26.12,9.303-26.12l-18.99-24.375        L199.292,203.203z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.167,187.094L233.31,204c0,0-1.768,8.19-7.131,20.567        c-2.034-0.456-3.789-0.874-6.042-1.026L220.167,187.094z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.403,187.085L203.247,204c0,0,1.755,8.203,7.119,20.567        c2.068-0.456,3.85-0.874,6.037-1.026V187.085z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 64.091,
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    },
    width: 64.349,
    x: 257.31,
    y: 176.799
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.02,241.256h-64.71l-0.372-64.458l64.72-0.38L322.02,241.256L322.02,241.256z          M321.271,176.799l-63.962,0.368l0.378,63.724l63.584-0.385V176.799L321.271,176.799z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321.43,296.43c-0.182,1.155-0.615,3.135-1.682,5.18        c-1.17,1.823-0.744,1.758-3.365,4.693c-1.289,1.426-3.291,2.645-4.874,3.51c-1.571,0.832-2.745,1.254-5.364,1.953        c-5.08,1.318-8.695,1.408-12.977,1.239c-3.367-0.151-5.911-0.542-8.021-0.851c-3.027-0.389-5.267-0.621-8.722-0.772        c-1.648-0.073-3.227-0.073-4.804,0c-1.878,0.092-3.735,0.384-5.71,0.772c-4.279,0.865-8.654,2.51-8.654,2.51l0.052-66.927        h64.374v45.714C321.684,293.451,321.528,295.705,321.43,296.43L321.43,296.43z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.876,315.201v-0.537l0.062-66.927l64.746-0.381l0.379,46.095         c0,0.039-0.152,2.297-0.256,3.033c-0.201,1.318-0.657,3.296-1.725,5.286l-0.729,1.216c-0.456,0.838-0.789,1.432-2.699,3.57         c-1.037,1.146-2.666,2.326-4.963,3.58c-1.575,0.84-2.75,1.27-5.444,1.993c-4.473,1.167-8.329,1.45-13.095,1.245         c-3.068-0.128-5.461-0.473-7.471-0.766c-3.588-0.465-5.821-0.709-9.28-0.858c-1.636-0.073-3.202-0.073-4.768,0         c-1.856,0.09-3.696,0.394-5.654,0.775c-4.195,0.849-8.54,2.47-8.597,2.487L256.876,315.201L256.876,315.201z          M321.314,247.737l-64.005,0.367l0.327,66.021c1.275-0.443,4.783-1.65,8.205-2.336c1.996-0.395,3.86-0.701,5.753-0.771         c1.578-0.091,3.171-0.091,4.856,0c3.459,0.137,5.721,0.377,8.746,0.771c2.566,0.365,4.96,0.706,7.982,0.84         c4.678,0.172,8.471-0.082,12.865-1.234c2.643-0.68,3.763-1.104,5.293-1.914c2.21-1.216,3.784-2.328,4.76-3.424         c1.844-2.081,2.155-2.609,2.611-3.423l0.725-1.228c0.995-1.892,1.434-3.783,1.635-5.028c0.09-0.722,0.246-2.938,0.246-2.938         V247.737L321.314,247.737z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.18,266.582c-0.623-0.191-1.541-0.647-1.541-0.647        c0.242-0.192,0.459-0.214,0.677-0.444c0.319-0.314,0.277-0.607,0.467-1.023c0.154-0.396,0.126-0.739,0.521-1.031        c0.223-0.19,0.588-0.227,0.868-0.124c0.267,0.062,0.624,0.286,0.673,0.578c0.091,0.447-0.126,0.677-0.18,1.144        c-0.096,0.445-0.255,0.688-0.148,1.155c0.02,0.292,0.148,0.394,0.279,0.687C275.795,266.875,274.803,266.744,274.18,266.582        L274.18,266.582z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.398,267.345c-0.023-0.294,0.194-0.52,0.476-0.52        c0.265,0,0.497,0.226,0.497,0.464c0.021,0.277-0.191,0.511-0.463,0.511C273.635,267.8,273.398,267.596,273.398,267.345        L273.398,267.345z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.02,254.438c0,0-0.068-0.056-0.12-0.091        c-0.277-0.231-0.315-0.523-0.468-0.865c-0.114-0.329-0.194-0.544-0.244-0.927c-0.033-0.291,0-0.48,0-0.796        c0-0.294,0.029-0.458,0-0.752c-0.033-0.277-0.033-0.468-0.151-0.732c-0.104-0.127-0.304-0.253-0.255-0.316        c0.08-0.079,0.193-0.025,0.322,0c0.328,0.023,0.48,0.124,0.72,0.316c0.319,0.254,0.436,0.455,0.538,0.824        c0.152,0.43,0.217,0.709,0.328,1.138c0.078,0.245,0.107,0.383,0.229,0.573c0.129,0.216,0.242,0.315,0.397,0.507l0,0        c-0.239,0.264-0.344,0.445-0.626,0.675c-0.201,0.188-0.431,0.288-0.632,0.447H272.02z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.748,262.737c-0.019,0.547-0.019,1.204,0,2.235        c0.029,0.99-0.177,1.508-0.086,2.127c0.031,0.467,0.19,0.656,0.52,1.205c0.67,0.99,1.421,1.216,0.834,2.882        c-0.379,1.087-0.185,0.769-0.316,1.286c-0.141,0.573-0.141,0.731-0.323,1.476c-0.175,0.673-0.325,2.058-0.497,3.525        c-0.026,0.239,0,0.384-0.026,0.493c-0.104,0.242-0.319,0.204-0.625,0.242c-0.362,0.053-0.221,0.799-0.343,1.307l-0.305,0.295        l-1.26-0.355l-0.904-0.296l0.128-0.795c0.181-0.103,0.28-0.174,0.458-0.315c0.436-0.385,0.663-0.697,0.908-1.235        c0.234-0.569,0.234-0.923,0.364-1.559c0.131-0.669,0.306-1.093,0.245-1.792c-0.067-0.603-0.336-0.9-0.396-1.482        c-0.104-0.505,0.07-0.822-0.071-1.301c-0.215-0.584,0.222-0.526-0.971-1.123c0,0,0.049,0.486,0.147,0.793        c0.05,0.201,0.185,0.303,0.185,0.545c0,0.314-0.258,0.426-0.436,0.686c-0.405,0.527-0.841,0.629-1.299,1.114        c-1.076,1.052-1.699,1.7-2.336,3.067c-0.218,0.415-0.218,0.902-0.496,1.129c-0.217,0.217-0.525,0.129-0.801,0.166        c-0.278,0.051-0.438,0.123-0.623,0.339c-0.149,0.194-0.189,0.329-0.189,0.571l-0.307,0.176l-1.019-0.176l-1.141-0.402        l0.202-0.811c0.732-0.577,1.101-0.245,1.625-0.685c0.332-0.241,0.456-0.459,0.741-0.814c0.17-0.25,0.254-0.443,0.458-0.697        c0.148-0.202,0.271-0.305,0.437-0.517c0.376-0.445,0.526-0.741,0.833-1.244c0.203-0.395,0.391-0.607,0.557-1.053        c0.121-0.269,0.153-0.432,0.203-0.728c0.041-0.233,0.066-0.443,0.066-0.629c-0.148,0.063-0.649,0.224-0.804,0.265        c0,0.063,0,0.534,0,0.637c-0.022,0.249-0.022,0.503-0.239,0.646c-0.15,0.081-0.24,0.109-0.436,0.081        c-0.181-0.036-0.316-0.151-0.365-0.335c-0.104-0.17-0.027-0.291-0.027-0.495c-0.038-0.062-0.038-0.321-0.038-0.382        c-0.276,0.038-0.391,0.038-0.673,0.038c-0.316,0-0.407-0.009-0.689-0.06c0,0.111,0.033,0.438,0,0.537        c-0.062,0.242-0.023,0.424-0.201,0.602c-0.154,0.123-0.319,0.186-0.509,0.123c-0.154-0.028-0.206-0.109-0.305-0.241        c-0.122-0.162-0.053-0.328-0.084-0.554c0-0.092,0-0.661,0-0.74c-0.806-0.291-1.519-0.734-2.125-1.275        c0,0-0.456,0.163-0.582,0.163c-2.794,0.633-4.849,0.665-7.355,0.316c-0.051,0.674-0.083,1.151-0.276,1.928        c-0.159,0.7-0.392,1.026-0.507,1.724c-0.101,0.453-0.127,0.766-0.166,1.221c-0.044,0.832,0,1.256,0.126,2.115        c0.083,0.52,0.187,0.801,0.245,1.33c0,0.333,0.097,0.393-0.026,0.563c-0.136,0.175-0.43-0.02-0.717,0.082        c-0.178,0.093-0.273,0.216-0.356,0.422c-0.099,0.161-0.12,0.285-0.12,0.479l-0.564,0.234l-0.993-0.254l-0.887-0.373        l0.092-0.76c0.305-0.233,0.521-0.281,0.735-0.566c0.211-0.254,0.313-0.462,0.342-0.813c0.102-0.544,0.152-0.828,0.178-1.373        c0.037-0.58,0-0.926,0-1.47c0-0.203-0.076-0.313-0.178-0.485c-0.063-0.192-0.104-0.29-0.215-0.453        c-0.24-0.403-0.067-1.911-0.088-2.754c-0.039-0.213-0.07-0.356-0.102-0.516l-0.306,0.068        c-0.282,0.044-0.487,0.109-0.956-0.032c-0.674-0.188-0.902-0.343-1.104-0.28c-0.281,0.055-0.559,0-0.738-0.102        c-0.684,0.671-0.905,0.751-1.555,1.436c-0.253,0.229-0.364,0.327-0.303,0.527c0.156,0.817,0.801,0.913,1.276,1.435        c0.225,0.282,0.722,0.479,0.479,0.863c-0.154,0.253-0.479,0.222-0.559,0.505c-0.023,0.235,0.039,0.434,0.229,0.591        l-0.039,0.721l-0.497,0.909l-0.485,0.533l-0.782-0.304c-0.029-0.62-0.078-0.961-0.23-1.548        c-0.154-0.636-0.346-1.002-0.622-1.529c-0.548-1.003-0.78-1.152-1.211-1.865c-0.735-1.27-0.333-1.242,0.258-2.172        c0.459-0.748,0.953-1,1.575-1.67c-0.279-0.484-0.428-0.98-0.943-1.155c-0.227-0.1-0.632-1.04-1.129-2.497        c-0.037-0.131,0-0.418,0.062-0.677c0.024-0.087,0.05-0.186,0.128-0.276l-1.679-0.761c0.153-0.106,0.353-0.178,0.538-0.331        c-0.218,0.039-0.385,0-0.586,0.022c-0.197,0.017-0.277,0.08-0.5,0.107c-0.316,0.034-0.493,0-0.771-0.068        c-0.41-0.089-0.613-0.163-0.994-0.327c-0.479-0.218-0.674-0.472-1.169-0.674c-0.587-0.254-0.942-0.242-1.57-0.377        c-0.365,0.021-0.616,0.041-1.022-0.09c-0.205-0.063-0.284-0.377-0.419-0.608c-0.101-0.169-0.519-0.878-0.651-1.132        c-0.104-0.175-0.104-0.293-0.182-0.457c0.209-0.125,0.314-0.467,0.62-0.566c0.149-0.063,0.276,0,0.455-0.051        c0.091-0.041,0.153-0.08,0.284-0.142c0.4-0.19,0.479-0.456,0.835-0.79c0.333-0.291,0.547-0.425,0.819-0.769        c0.221-0.271,0.375-0.42,0.529-0.736c0.121-0.293,0-0.518,0.211-0.8c0.111-0.162,0.268-0.191,0.435-0.303        c0.397-0.276,0.649-0.353,0.978-0.671c0.282-0.241,0.387-0.412,0.626-0.636c0.189-0.099,0.467-0.231,0.467-0.231        c1.068,0.17,1.452,0.333,2.335,0.715c0.72,0.315,1.732,0.935,1.732,0.935c0.18-0.174,0.376-0.327,0.653-0.456        c0.327-0.164,0.566-0.224,0.948-0.266c0.286-0.022,0.459-0.047,0.742,0.014c0.253,0.051,0.459,0.152,0.712,0.341        c-0.253,0.267-0.411,0.526-0.589,0.778c-0.275,0.286-0.227,0.518-0.436,0.793c-0.303,0.421-0.488,0.574-1.136,0.816        l1.662,0.544c0,0,1.511-0.018,3.013-0.142c2.902-0.229,2.902-0.676,4.857-0.837c1.04-0.091,2.744,0.321,4.523,0.264        c1.511-0.012,2.336-0.163,3.85-0.327c1.539-0.191,2.401-0.485,3.98-0.595c1.324-0.064,2.063-0.039,3.356,0.062        c1.292,0.112,2.095,0.048,3.24,0.466c0.735,0.253,1.536,0.395,2.124,1.131c0.179,0.242,0.344,0.406,0.436,0.647        c0.096,0.243,0.213,0.447,0.252,0.732c0.021,0.31,0.089,0.553,0.089,0.807c0,0.376-0.067,0.757-0.245,1.147        c-0.597,1.271-0.941,1.434-1.853,1.918C307.943,262.636,307.853,262.675,307.748,262.737L307.748,262.737z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.9,264.5l0.447-0.924c-0.484,0.325-1.678,0.325-2.658,0.19l0.611-0.878         c-0.229,0.027-0.584-0.039-0.869-0.151c-0.351-0.14-0.547-0.276-0.833-0.518l1.372-0.574         c0.498-0.112,0.867-0.288,1.208-0.467c0.493-0.229,1.001-0.483,1.867-0.558c0.812-0.09,2.097-0.09,6.026,0.546         c2.342,0.396,3.355,0.214,4.248-0.19c0.457-0.203,0.682-0.597,0.76-1.254c0.049-0.559-0.303-0.993-0.625-1.256         c-0.081,0-0.541-0.221-0.541-0.305c0-0.09-0.296-0.295-0.212-0.295c0.031,0.041,0.942,0.315,0.972,0.346         c0.377,0.314,0.813,0.838,0.742,1.547c-0.082,0.771-0.397,1.279-0.973,1.521c-0.916,0.432-1.98,0.634-4.434,0.213         c-3.879-0.629-5.125-0.619-5.937-0.545c-0.812,0.076-1.272,0.307-1.745,0.533c-0.363,0.179-0.746,0.367-1.279,0.495         l-1.304,0.281c1.198,0.315,1.81,0.416,1.81,0.416l-0.71,1.053c0.351-0.23,0.636-0.202,1.095-0.202         c0.607,0,1.598-0.203,1.609-0.214l0.346-0.066l-0.561,1.115c0.355-0.29,0.662-0.328,1.148-0.459         c0.505-0.123,0.858-0.364,1.227-0.59c0.422-0.282,0.863-0.574,1.5-0.637c1.099-0.077,1.959,0.142,2.813,0.354         c0.859,0.216,1.688,0.418,2.686,0.316c0.95-0.062,1.408-0.101,1.967-0.354c0.104-0.04,0.482-0.091,0.523,0         c0.021,0.101,0.289,0.089,0.187,0.128l-0.583,0.176c-0.6,0.281-1.119,0.314-1.78,0.369c-1.346,0.103-2.241-0.111-3.073-0.318         c-0.816-0.204-1.706-0.43-2.696-0.327c-0.558,0.052-0.942,0.304-1.35,0.569c-0.38,0.252-0.791,0.506-1.35,0.637         c-0.506,0.136-0.811,0.175-1.349,0.242L295.9,264.5L295.9,264.5z",
    style: {
      fill: "#F9EB2E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.908,255.978c-0.403-0.038-0.686,0.029-1.053,0.231        c-0.367,0.235-0.431,0.547-0.676,0.889c0.334,0.071,0.51,0.288,0.896,0.202c0.239-0.078,0.401-0.193,0.578-0.393        c0.254-0.265,0.332-0.518,0.332-0.901L273.908,255.978z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.908,255.978c-0.403-0.038-0.686,0.029-1.053,0.231c-0.367,0.235-0.431,0.547-0.676,0.889         c0.334,0.071,0.51,0.288,0.896,0.202c0.239-0.078,0.401-0.193,0.578-0.393c0.254-0.265,0.332-0.518,0.332-0.901         L273.908,255.978z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.471,270.865c0,0,0,0,0-0.012l0.232-0.859l-0.232-0.307         c-0.078-0.953-0.09-1.231-0.182-1.596c-0.111-0.447-0.201-0.688-0.405-1.092c-0.05-0.092-0.174-0.496-0.092-0.547         c0.092-0.035,0.042-0.292,0.068-0.254c0.012,0.017,0.327,0.658,0.327,0.658c0.205,0.423,0.307,0.674,0.433,1.152         c0.102,0.396,0.112,0.705,0.128,1.016l0.127,0.979c-0.006,0.092-0.127,0.585-0.211,0.585l0,0l0,0         C283.572,270.589,283.494,270.865,283.471,270.865L283.471,270.865z",
    style: {
      fill: "#F9EB2E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.971,265.429c0,0-0.188,0.632-0.271,1.052c-0.27,1.051-0.524,1.611-0.732,2.689         c-0.034,0.188-0.072,0.351-0.101,0.518L288.971,265.429z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.827,262.737l1.752,0.8c0.89-0.496,1.958-1.48,2.743-3.067        c0.688-1.349,0.805-2.067,1.085-3.371l-1.413-0.444l-0.277,0.044c-0.432,1.362-0.561,2.131-1.271,3.276        c-0.608,1.023-1.352,1.801-2.057,2.368L274.827,262.737z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.851,262.766 274.891,262.383 275.322,262.383         275.718,262.607       ",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.717,276.891c0.277-0.382,0.393-0.646,0.708-0.987        c0.362-0.392,0.616-0.55,1.021-0.898c0.115,0.02,0.277-0.028,0.394,0.062c-0.037,0.413-0.064,0.734-0.148,1.188        c-0.07,0.38-0.171,0.598-0.284,0.95c-0.091,0.297-0.111,0.508-0.317,0.762c-0.118,0.176-0.209,0.242-0.353,0.397        C279.322,277.791,278.717,277.369,278.717,276.891L278.717,276.891z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.544,278.34c0.458,0.151,0.735,0.213,1.172,0.429        c0.468,0.228,0.689,0.433,1.149,0.724c0.02,0.122,0.082,0.254,0.02,0.367c-0.404,0.125-0.701,0.19-1.169,0.201        c-0.396,0.021-0.608,0.021-0.991,0c-0.326-0.011-0.51,0.021-0.826-0.076c-0.219-0.063-0.318-0.154-0.497-0.238        C303.857,279.201,304.086,278.463,304.544,278.34L304.544,278.34z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.934,276.754c0.428,0.164,0.697,0.201,1.138,0.414        c0.45,0.228,0.704,0.455,1.135,0.74c0.028,0.123,0.103,0.234,0.068,0.365c-0.433,0.091-0.753,0.179-1.203,0.218        c-0.408,0.023-0.622,0-0.986,0c-0.344-0.028-0.518,0-0.823-0.104c-0.181-0.066-0.312-0.125-0.498-0.256        C296.221,277.604,296.465,276.864,296.934,276.754L296.934,276.754z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.339,278.4c0.438,0.174,0.704,0.214,1.147,0.43        c0.484,0.23,0.699,0.463,1.135,0.746c0.039,0.103,0.084,0.234,0.061,0.355c-0.406,0.118-0.734,0.179-1.195,0.213        c-0.384,0.017-0.602,0-0.992,0c-0.307-0.021-0.529,0-0.816-0.084c-0.197-0.076-0.303-0.139-0.477-0.25        C282.633,279.259,282.872,278.553,283.339,278.4L283.339,278.4z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.303,255.119c-0.479-0.204-0.824-0.811-0.508-1.229        c0.113-0.179,0.322-0.153,0.451-0.32c0.131-0.214,0.094-0.405,0.094-0.648c0-0.302-0.132-0.441-0.168-0.732        c-0.055-0.318-0.099-0.507-0.099-0.824c0-0.509-0.048-0.837,0.267-1.243c0.189-0.243,0.521-0.456,0.648-0.482        c0.123,0.114-0.028,0.403-0.028,0.646c0.028,0.38,0.077,0.57,0.198,0.913c0.197,0.431,0.41,0.623,0.568,1.066        c0.175,0.405,0.303,0.634,0.34,1.051c0,0.354-0.037,0.585-0.165,0.927c-0.15,0.267-0.231,0.432-0.482,0.623        c-0.218,0.191-0.382,0.281-0.61,0.343C276.607,255.23,276.492,255.208,276.303,255.119L276.303,255.119z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.782,261.482l-1.045-0.078c-1.153,0-1.431,0.017-1.763,0.066l-0.473-0.027l0.455-0.15         c0.32-0.053,0.615-0.092,0.994-0.092l0.967,0.055c1.262,0.025,1.406-0.077,1.742-0.268l1.668-1.317l-1.629,1.396l0.049,0.073         C274.423,261.332,274.18,261.443,273.782,261.482L273.782,261.482z",
    style: {
      fill: "#D90037"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.107,268.278c0.305,0.37,0.657,0.664,1.244,0.892L278.107,268.278z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.393,266.582c0.618,0.124,0.395,2.619,1.383,3.193L279.393,266.582z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.581,270.956l0.284-0.193c0.8-0.312,1.509-0.798,2.122-1.394L301.581,270.956z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.522,269.75c-0.077,0-0.15-0.048-0.183-0.122c-0.012-0.089,0.044-0.181,0.131-0.204         c1.473-0.37,2.693-0.939,3.715-1.414c0.898-0.414,1.615-0.758,2.258-0.832c-0.563,0.406-1.283,0.75-2.135,1.136         c-1.014,0.482-2.247,1.056-3.762,1.437H295.522L295.522,269.75z",
    style: {
      fill: "#F9EB2E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.313,270.309l-0.018-0.012l-0.751-0.571l-0.075,0.157         c-1.012-0.498-1.512-1.004-1.996-1.488c-0.418-0.417-0.801-0.811-1.465-1.176c-1.034-0.801-1.342-1.069-2.027-0.98         l-0.686-0.264l0.2-0.012c1.332-0.156,1.685,0.175,2.069,0.518c1.31,0.82,1.744,1.255,2.15,1.671         c0.486,0.497,0.941,0.952,1.829,1.388c0.089,0.049,0.575,0.375,0.538,0.465C305.028,270.08,305.336,270.309,305.313,270.309         L305.313,270.309z",
    style: {
      fill: "#F9EB2E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.552,266.188l1.179,1.194l1.834-0.222        c0,0-0.365-0.388-0.641-0.579c-0.129-0.102-0.182-0.191-0.333-0.23c-0.104-0.039-0.206-0.021-0.316-0.021        c-0.196-0.018-0.282-0.039-0.475-0.039c-0.278,0-0.415-0.023-0.701-0.043c-0.214,0-0.305,0-0.517,0L297.552,266.188z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.188,258.588c-0.091-0.171-0.182-0.215-0.353-0.302        c-0.285-0.165-0.84-0.226-0.84-0.226l-0.176,1.369l1.471-0.368C307.291,259.062,307.32,258.76,307.188,258.588        L307.188,258.588z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.224,264.467l0.331-0.767c-0.305-0.036-0.463-0.073-0.738-0.163        c-0.326-0.063-0.516-0.129-0.861-0.203c-0.374-0.089-0.59-0.125-0.994-0.192c-0.306-0.038-0.506-0.123-0.865-0.062        c-0.269,0.023-0.391,0.129-0.636,0.231c-0.306,0.151-0.468,0.286-0.729,0.455c-0.39,0.214-0.566,0.34-0.937,0.497        c-0.363,0.123-0.558,0.164-0.923,0.264c-0.609,0.164-0.971,0.23-1.604,0.265l1.778,0.687L303.224,264.467z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.42,264.883l0.76-1.219c0,0-0.76,0.164-1.24,0.217        c-0.94,0.1-1.455,0.061-2.393-0.029l0.227,1.324l1.502,0.67L295.42,264.883z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.443,262.129c0,0,0.779-0.163,1.238-0.325        c0.405-0.158,0.586-0.31,0.99-0.446c0.229-0.129,0.409-0.19,0.662-0.27c0.355-0.111,0.561-0.123,0.943-0.175        c0.354-0.016,0.559,0.024,0.912,0.052c0.541,0.012,0.839,0.061,1.357,0.123c0.5,0.052,0.743,0.102,1.234,0.182        c0.486,0.088,0.738,0.151,1.235,0.213c0.8,0.163,1.255,0.266,2.069,0.383c0.676,0.062,1.045,0.124,1.693,0.124        c0.495-0.023,0.771-0.04,1.228-0.102l-0.456,0.72l-4.342-0.365l-4.604-0.253l-3.293,0.321h-0.558L293.443,262.129z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.356,259.051c0.214,0.061,0.333,0.061,0.547,0.034        c0.255-0.023,0.38-0.193,0.66-0.201c0.181,0,0.331,0,0.509,0.128c0.127,0.05,0.152,0.109,0.231,0.243        c0.048,0.146,0.122,0.212,0.085,0.377c-0.037,0.22-0.238,0.315-0.469,0.315c-0.176,0-0.328-0.039-0.435-0.203        c-0.053-0.112-0.053-0.186-0.024-0.303c-0.218,0.067-0.406,0.067-0.607,0C268.599,259.366,268.479,259.255,268.356,259.051        L268.356,259.051z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.356,259.051c0.214,0.061,0.333,0.061,0.547,0.034c0.255-0.023,0.38-0.193,0.66-0.201         c0.181,0,0.331,0,0.509,0.128c0.127,0.05,0.152,0.109,0.231,0.243c0.048,0.146,0.122,0.212,0.085,0.377         c-0.037,0.22-0.238,0.315-0.469,0.315c-0.176,0-0.328-0.039-0.435-0.203c-0.053-0.112-0.053-0.186-0.024-0.303         c-0.218,0.067-0.406,0.067-0.607,0C268.599,259.366,268.479,259.255,268.356,259.051z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.18,295.151c-0.623-0.175-1.541-0.647-1.541-0.647        c0.242-0.166,0.459-0.192,0.677-0.417c0.319-0.313,0.277-0.61,0.467-1.032c0.154-0.401,0.126-0.729,0.521-1.05        c0.223-0.183,0.588-0.214,0.868-0.126c0.267,0.086,0.624,0.318,0.673,0.597c0.091,0.432-0.126,0.685-0.18,1.127        c-0.096,0.458-0.255,0.709-0.148,1.132c0.02,0.318,0.148,0.417,0.279,0.732C275.795,295.467,274.803,295.341,274.18,295.151        L274.18,295.151z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.398,295.911c-0.023-0.263,0.194-0.509,0.476-0.509        c0.265,0,0.497,0.217,0.497,0.484c0.021,0.277-0.191,0.508-0.463,0.508C273.635,296.395,273.398,296.193,273.398,295.911        L273.398,295.911z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.02,283.016c0,0-0.068-0.064-0.12-0.102        c-0.277-0.229-0.315-0.493-0.468-0.866c-0.114-0.324-0.194-0.517-0.244-0.896c-0.033-0.318,0-0.479,0-0.813        c0-0.289,0.029-0.443,0-0.736c-0.033-0.3-0.033-0.481-0.151-0.731c-0.104-0.154-0.304-0.277-0.255-0.318        c0.08-0.09,0.193-0.025,0.322,0c0.328,0.021,0.48,0.1,0.72,0.318c0.319,0.25,0.436,0.432,0.538,0.808        c0.152,0.432,0.217,0.698,0.328,1.155c0.078,0.24,0.107,0.371,0.229,0.572c0.129,0.207,0.242,0.289,0.397,0.479v0.029        c-0.239,0.256-0.344,0.416-0.626,0.649c-0.201,0.21-0.431,0.313-0.632,0.452H272.02z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.748,291.323c-0.019,0.556-0.019,1.215,0,2.248        c0.029,0.982-0.177,1.508-0.086,2.134c0.031,0.436,0.19,0.648,0.52,1.171c0.67,1.015,1.421,1.239,0.834,2.878        c-0.379,1.088-0.185,0.799-0.316,1.316c-0.141,0.574-0.141,0.724-0.323,1.476c-0.175,0.649-0.325,2.042-0.497,3.526        c-0.026,0.23,0,0.376-0.026,0.484c-0.104,0.251-0.319,0.212-0.625,0.251c-0.362,0.049-0.221,0.798-0.343,1.303l-0.305,0.269        l-1.26-0.332l-0.904-0.318l0.128-0.797c0.181-0.104,0.28-0.163,0.458-0.294c0.436-0.405,0.663-0.683,0.908-1.237        c0.234-0.563,0.234-0.936,0.364-1.548c0.131-0.697,0.306-1.091,0.245-1.82c-0.067-0.577-0.336-0.872-0.396-1.456        c-0.104-0.507,0.07-0.822-0.071-1.31c-0.215-0.605,0.222-0.513-0.971-1.11c0,0,0.049,0.484,0.147,0.789        c0.05,0.199,0.185,0.305,0.185,0.518c0,0.332-0.258,0.455-0.436,0.697c-0.405,0.533-0.841,0.65-1.299,1.129        c-1.076,1.049-1.699,1.697-2.336,3.07c-0.218,0.414-0.218,0.871-0.496,1.125c-0.217,0.191-0.525,0.133-0.801,0.17        c-0.278,0.043-0.438,0.123-0.623,0.338c-0.149,0.167-0.189,0.329-0.189,0.564l-0.307,0.181l-1.019-0.181l-1.141-0.424        l0.202-0.813c0.732-0.573,1.101-0.229,1.625-0.649c0.332-0.272,0.456-0.491,0.741-0.818c0.17-0.257,0.254-0.446,0.458-0.724        c0.148-0.207,0.271-0.298,0.437-0.521c0.376-0.44,0.526-0.734,0.833-1.213c0.203-0.398,0.391-0.613,0.557-1.068        c0.121-0.287,0.153-0.446,0.203-0.74c0.041-0.226,0.066-0.415,0.066-0.602c-0.148,0.061-0.649,0.195-0.804,0.254        c0,0.075,0,0.53,0,0.621c-0.022,0.276-0.022,0.53-0.239,0.653c-0.15,0.103-0.24,0.103-0.436,0.081        c-0.181-0.041-0.316-0.141-0.365-0.332c-0.104-0.164-0.027-0.275-0.027-0.493c-0.038-0.079-0.038-0.306-0.038-0.368        c-0.276,0.013-0.391,0.013-0.673,0.013c-0.316,0-0.407-0.013-0.689-0.053c0,0.103,0.033,0.435,0,0.558        c-0.062,0.242-0.023,0.408-0.201,0.574c-0.154,0.135-0.319,0.189-0.509,0.135c-0.154-0.012-0.206-0.103-0.305-0.226        c-0.122-0.181-0.053-0.332-0.084-0.558c0-0.09,0-0.673,0-0.736c-0.806-0.292-1.519-0.735-2.125-1.281        c0,0-0.456,0.141-0.582,0.166c-2.794,0.609-4.849,0.669-7.355,0.318c-0.051,0.674-0.083,1.152-0.276,1.91        c-0.159,0.689-0.392,1.033-0.507,1.712c-0.101,0.485-0.127,0.739-0.166,1.242c-0.044,0.809,0,1.255,0.126,2.117        c0.083,0.534,0.187,0.808,0.245,1.314c0,0.325,0.097,0.388-0.026,0.577c-0.136,0.172-0.43-0.012-0.717,0.09        c-0.178,0.064-0.273,0.205-0.356,0.394c-0.099,0.192-0.12,0.289-0.12,0.507l-0.564,0.205l-0.993-0.241l-0.887-0.371        l0.092-0.772c0.305-0.205,0.521-0.257,0.735-0.546c0.211-0.266,0.313-0.456,0.342-0.806c0.102-0.551,0.152-0.857,0.178-1.373        c0.037-0.578,0-0.951,0-1.477c0-0.197-0.076-0.313-0.178-0.504c-0.063-0.189-0.104-0.288-0.215-0.455        c-0.24-0.379-0.067-1.916-0.088-2.727c-0.039-0.214-0.07-0.354-0.102-0.534l-0.306,0.088c-0.282,0.04-0.487,0.104-0.956-0.048        c-0.674-0.175-0.902-0.326-1.104-0.297c-0.281,0.056-0.559,0.032-0.738-0.072c-0.684,0.649-0.905,0.761-1.555,1.41        c-0.253,0.226-0.364,0.354-0.303,0.546c0.156,0.812,0.801,0.919,1.276,1.444c0.225,0.266,0.722,0.479,0.479,0.863        c-0.154,0.254-0.479,0.201-0.559,0.505c-0.023,0.228,0.039,0.42,0.229,0.583l-0.039,0.711l-0.497,0.902l-0.485,0.529        l-0.782-0.295c-0.029-0.605-0.078-0.95-0.23-1.529c-0.154-0.637-0.346-1.012-0.622-1.537c-0.548-1.021-0.78-1.152-1.211-1.885        c-0.735-1.242-0.333-1.226,0.258-2.144c0.459-0.764,0.953-1.021,1.575-1.677c-0.279-0.479-0.428-0.987-0.943-1.177        c-0.227-0.093-0.632-1.032-1.129-2.489c-0.037-0.111,0-0.428,0.062-0.68c0.024-0.09,0.05-0.166,0.128-0.281l-1.679-0.748        c0.153-0.104,0.353-0.16,0.538-0.318c-0.218,0.023-0.385-0.025-0.586,0.023c-0.197,0.017-0.277,0.068-0.5,0.1        c-0.316,0.035-0.493-0.021-0.771-0.083c-0.41-0.065-0.613-0.167-0.994-0.332c-0.479-0.19-0.674-0.455-1.169-0.647        c-0.587-0.251-0.942-0.239-1.57-0.377c-0.365,0.012-0.616,0.032-1.022-0.091c-0.205-0.091-0.284-0.393-0.419-0.62        c-0.101-0.175-0.519-0.863-0.651-1.138c-0.104-0.171-0.104-0.284-0.182-0.472c0.209-0.102,0.314-0.43,0.62-0.536        c0.149-0.065,0.276,0,0.455-0.054c0.091-0.062,0.153-0.069,0.284-0.121c0.4-0.199,0.479-0.508,0.835-0.804        c0.333-0.288,0.547-0.452,0.819-0.794c0.221-0.244,0.375-0.397,0.529-0.715c0.121-0.288,0-0.541,0.211-0.798        c0.111-0.161,0.268-0.198,0.435-0.327c0.397-0.279,0.649-0.344,0.978-0.649c0.282-0.237,0.387-0.405,0.626-0.659        c0.189-0.09,0.467-0.201,0.467-0.201c1.068,0.143,1.452,0.329,2.335,0.709c0.72,0.293,1.732,0.941,1.732,0.941        c0.18-0.193,0.376-0.33,0.653-0.484c0.327-0.164,0.566-0.201,0.948-0.258c0.286-0.028,0.459-0.028,0.742,0.033        c0.253,0.037,0.459,0.128,0.712,0.326c-0.253,0.279-0.411,0.531-0.589,0.764c-0.275,0.292-0.227,0.529-0.436,0.8        c-0.303,0.442-0.488,0.577-1.136,0.818l1.662,0.559c0,0,1.511-0.032,3.013-0.159c2.902-0.232,2.902-0.65,4.857-0.827        c1.04-0.108,2.744,0.308,4.523,0.258c1.511-0.021,2.336-0.144,3.85-0.313c1.539-0.187,2.401-0.505,3.98-0.59        c1.324-0.079,2.063-0.04,3.356,0.058c1.292,0.092,2.095,0.027,3.24,0.447c0.735,0.268,1.536,0.418,2.124,1.126        c0.179,0.231,0.344,0.406,0.436,0.663c0.096,0.227,0.213,0.432,0.252,0.744c0.021,0.294,0.089,0.543,0.089,0.797        c0,0.389-0.067,0.771-0.245,1.146c-0.597,1.264-0.941,1.418-1.853,1.923C307.943,291.238,307.853,291.276,307.748,291.323        L307.748,291.323z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.9,293.055l0.447-0.884c-0.467,0.315-1.616,0.394-2.658,0.155l0.611-0.849         c-0.229,0.013-0.584-0.042-0.869-0.154c-0.351-0.158-0.556-0.292-0.833-0.532c0.66-0.397,0.938-0.434,1.345-0.56         c0.537-0.128,0.895-0.305,1.247-0.47c0.481-0.238,0.989-0.484,1.845-0.571c0.834-0.073,2.15-0.065,6.037,0.571         c2.342,0.379,3.355,0.219,4.248-0.19c0.457-0.2,0.682-0.601,0.76-1.278c0.061-0.609-0.406-1.078-0.625-1.259         c-0.081,0-0.541-0.192-0.541-0.294c0-0.081-0.312-0.273-0.212-0.273c0.04,0,0.942,0.285,0.972,0.314         c0.255,0.205,0.824,0.771,0.742,1.549c-0.082,0.795-0.386,1.292-0.973,1.549c-0.943,0.425-2.006,0.617-4.434,0.211         c-3.824-0.623-5.125-0.635-5.937-0.555c-0.8,0.068-1.249,0.289-1.733,0.533c-0.375,0.178-0.758,0.352-1.291,0.482         c-0.434,0.136-0.729,0.189-1.123,0.24c1.018,0.374,1.621,0.467,1.621,0.467l-0.702,1.029         c0.378-0.188,0.685-0.166,1.095-0.166c0.607,0,1.598-0.219,1.598-0.219l0.357-0.061l-0.561,1.102         c0.355-0.29,0.662-0.322,1.148-0.445c0.492-0.123,0.858-0.365,1.215-0.596c0.434-0.282,0.875-0.579,1.534-0.626         c1.076-0.111,1.954,0.134,2.79,0.349c0.859,0.209,1.688,0.42,2.686,0.318c0.934-0.064,1.408-0.102,1.967-0.378         c0.104-0.028,0.492-0.075,0.523,0.012c0.021,0.087,0.289,0.071,0.187,0.112l-0.583,0.189c-0.6,0.292-1.119,0.33-1.78,0.379         c-1.358,0.091-2.241-0.098-3.073-0.314c-0.816-0.188-1.717-0.406-2.696-0.323c-0.558,0.028-0.958,0.282-1.373,0.566         c-0.383,0.235-0.768,0.507-1.326,0.634c-0.506,0.123-0.811,0.173-1.349,0.218L295.9,293.055L295.9,293.055z",
    style: {
      fill: "#F9EB2E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.908,284.578c-0.403-0.063-0.686,0-1.053,0.219        c-0.367,0.236-0.431,0.536-0.676,0.895c0.334,0.077,0.51,0.271,0.896,0.2c0.239-0.072,0.401-0.171,0.578-0.392        c0.254-0.287,0.332-0.53,0.332-0.922H273.908z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.908,284.578c-0.403-0.063-0.686,0-1.053,0.219c-0.367,0.236-0.431,0.536-0.676,0.895         c0.334,0.077,0.51,0.271,0.896,0.2c0.239-0.072,0.401-0.171,0.578-0.392c0.254-0.287,0.332-0.53,0.332-0.922H273.908z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.471,298.146c0,0,0,0,0-0.031v-0.009v-1.144c-0.078-0.95-0.09-1.223-0.182-1.602         c-0.102-0.44-0.201-0.678-0.417-1.12c-0.038-0.081-0.153-0.497-0.08-0.536c0.068-0.037,0.042-0.266,0.068-0.266         c0,0,0,0,0,0.012c0.012,0.012,0.327,0.647,0.327,0.656c0.205,0.446,0.307,0.719,0.433,1.184         c0.102,0.394,0.112,0.684,0.128,1.002l0.127,0.973c-0.006,0.094-0.127,0.6-0.211,0.6l0,0l0,0         C283.572,297.865,283.494,298.146,283.471,298.146L283.471,298.146z",
    style: {
      fill: "#F9EB2E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.971,294.026c0,0-0.188,0.629-0.271,1.026c-0.27,1.074-0.524,1.634-0.732,2.71         c-0.034,0.192-0.072,0.353-0.101,0.507L288.971,294.026z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.827,291.323l1.752,0.786c0.89-0.484,1.958-1.482,2.743-3.063        c0.688-1.314,0.805-2.061,1.085-3.355l-1.413-0.447l-0.277,0.042c-0.432,1.345-0.561,2.122-1.271,3.268        c-0.608,1.018-1.352,1.821-2.057,2.387L274.827,291.323z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.851,291.363 274.891,290.979 275.322,290.979         275.718,291.193       ",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.717,305.484c0.277-0.393,0.393-0.646,0.708-1.002        c0.362-0.377,0.616-0.557,1.021-0.887c0.115,0,0.277-0.023,0.394,0.067c-0.037,0.394-0.064,0.735-0.148,1.19        c-0.07,0.355-0.171,0.59-0.284,0.924c-0.091,0.322-0.111,0.525-0.317,0.779c-0.118,0.181-0.209,0.251-0.353,0.402        C279.322,306.385,278.717,305.955,278.717,305.484L278.717,305.484z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.544,306.932c0.458,0.149,0.735,0.193,1.172,0.406        c0.468,0.23,0.689,0.455,1.149,0.746c0.02,0.111,0.082,0.234,0.02,0.355c-0.404,0.117-0.701,0.181-1.169,0.213        c-0.396,0.02-0.608,0.02-0.991,0c-0.326-0.023-0.51,0-0.826-0.083c-0.219-0.067-0.318-0.142-0.497-0.251        C303.857,307.793,304.086,307.043,304.544,306.932L304.544,306.932z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.934,305.32c0.428,0.164,0.697,0.226,1.138,0.445        c0.45,0.227,0.704,0.428,1.135,0.713c0.028,0.128,0.103,0.259,0.068,0.391c-0.433,0.09-0.753,0.174-1.203,0.192        c-0.408,0.036-0.622,0.02-0.986,0c-0.344-0.019-0.518,0.02-0.823-0.079c-0.181-0.063-0.312-0.155-0.498-0.254        C296.221,306.183,296.465,305.443,296.934,305.32L296.934,305.32z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.339,306.994c0.438,0.178,0.704,0.219,1.147,0.423        c0.484,0.224,0.699,0.442,1.135,0.731c0.039,0.116,0.084,0.254,0.061,0.382c-0.406,0.09-0.734,0.161-1.195,0.189        c-0.384,0.042-0.602,0.012-0.992,0c-0.307,0-0.529,0.012-0.816-0.067c-0.197-0.083-0.303-0.159-0.477-0.25        C282.633,307.859,282.872,307.125,283.339,306.994L283.339,306.994z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.303,283.715c-0.479-0.232-0.824-0.827-0.508-1.256        c0.113-0.166,0.322-0.129,0.451-0.289c0.131-0.248,0.094-0.408,0.094-0.662c0-0.303-0.132-0.455-0.168-0.737        c-0.055-0.329-0.099-0.493-0.099-0.839c0-0.477-0.048-0.811,0.267-1.215c0.189-0.254,0.521-0.455,0.648-0.487        c0.123,0.11-0.028,0.408-0.028,0.662c0.028,0.355,0.077,0.563,0.198,0.905c0.197,0.416,0.41,0.618,0.568,1.037        c0.175,0.411,0.303,0.637,0.34,1.08c0,0.353-0.037,0.582-0.165,0.9c-0.15,0.295-0.231,0.443-0.482,0.645        c-0.218,0.188-0.382,0.256-0.61,0.34C276.607,283.814,276.492,283.777,276.303,283.715L276.303,283.715z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#3227FC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.537,296.876c0.293,0.341,0.663,0.649,1.283,0.863L278.537,296.876z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.393,295.151c0.618,0.151,0.395,2.651,1.383,3.221L279.393,295.151z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.581,299.535l0.284-0.201c0.8-0.317,1.509-0.796,2.122-1.367L301.581,299.535z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.522,298.349c-0.077,0-0.15-0.05-0.183-0.131c-0.012-0.091,0.044-0.173,0.131-0.202         c1.473-0.367,2.693-0.938,3.715-1.408c0.861-0.402,1.625-0.758,2.258-0.831c-0.547,0.397-1.264,0.747-2.122,1.138         c-1.026,0.483-2.26,1.053-3.774,1.435H295.522L295.522,298.349z",
    style: {
      fill: "#F9EB2E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.313,298.879L305.313,298.879l-0.902-0.44c-0.953-0.472-1.453-0.968-1.92-1.442         c-0.436-0.426-0.818-0.822-1.482-1.188c-1.034-0.819-1.314-1.05-2.016-0.962l-0.678-0.111l0.461-0.201         c1.04-0.17,1.404,0.184,1.803,0.527c1.296,0.851,1.73,1.266,2.137,1.688c0.486,0.486,0.941,0.953,1.829,1.379         c0.107,0.059,0.575,0.373,0.538,0.454C305.028,298.661,305.336,298.879,305.313,298.879L305.313,298.879z",
    style: {
      fill: "#F9EB2E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.552,294.783l1.179,1.171l1.834-0.206        c0,0-0.365-0.387-0.641-0.597c-0.129-0.072-0.182-0.175-0.333-0.23c-0.104-0.015-0.206,0-0.316,0        c-0.196-0.015-0.282-0.038-0.475-0.038c-0.278-0.025-0.415-0.025-0.701-0.037c-0.214,0-0.305-0.02-0.517-0.02L297.552,294.783        z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.188,287.164c-0.091-0.156-0.182-0.189-0.353-0.289        c-0.285-0.185-0.84-0.244-0.84-0.244l-0.176,1.396l1.471-0.359C307.291,287.668,307.32,287.33,307.188,287.164        L307.188,287.164z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.224,293.055l0.331-0.756c-0.305-0.063-0.463-0.074-0.738-0.166        c-0.326-0.088-0.516-0.15-0.861-0.219c-0.374-0.092-0.59-0.135-0.994-0.189c-0.306-0.035-0.506-0.137-0.865-0.076        c-0.269,0.041-0.391,0.131-0.636,0.254c-0.306,0.143-0.468,0.295-0.729,0.462c-0.39,0.187-0.566,0.317-0.937,0.478        c-0.363,0.125-0.558,0.164-0.923,0.258c-0.609,0.178-0.971,0.239-1.604,0.299l1.778,0.662L303.224,293.055z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.42,293.477l0.76-1.24c0,0-0.76,0.174-1.24,0.212        c-0.94,0.103-1.455,0.07-2.393,0l0.227,1.325l1.502,0.666L295.42,293.477z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.356,287.621c0.214,0.063,0.333,0.063,0.547,0.063        c0.255-0.016,0.38-0.19,0.66-0.215c0.181,0,0.331-0.015,0.509,0.115c0.127,0.084,0.152,0.148,0.231,0.258        c0.048,0.131,0.122,0.223,0.085,0.356c-0.037,0.222-0.238,0.344-0.469,0.344c-0.176,0-0.328-0.058-0.435-0.226        c-0.053-0.09-0.053-0.166-0.024-0.289c-0.218,0.068-0.406,0.068-0.607,0C268.599,287.959,268.479,287.842,268.356,287.621        L268.356,287.621z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.356,287.621c0.214,0.063,0.333,0.063,0.547,0.063c0.255-0.016,0.38-0.19,0.66-0.215         c0.181,0,0.331-0.015,0.509,0.115c0.127,0.084,0.152,0.148,0.231,0.258c0.048,0.131,0.122,0.223,0.085,0.356         c-0.037,0.222-0.238,0.344-0.469,0.344c-0.176,0-0.328-0.058-0.435-0.226c-0.053-0.09-0.053-0.166-0.024-0.289         c-0.218,0.068-0.406,0.068-0.607,0C268.599,287.959,268.479,287.842,268.356,287.621z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.352,296.459c0.179,1.152,0.586,3.127,1.705,5.162        c1.131,1.812,0.697,1.758,3.318,4.682c1.294,1.426,3.292,2.67,4.869,3.51c1.599,0.863,2.77,1.254,5.361,1.953        c5.124,1.318,8.695,1.417,12.983,1.254c3.367-0.138,5.921-0.557,8.02-0.834c3.023-0.42,5.275-0.652,8.72-0.804        c1.665-0.06,3.242-0.073,4.803,0c1.883,0.115,3.743,0.407,5.749,0.804c4.242,0.834,8.564,2.496,8.564,2.496v-66.933        l-64.369-0.012v45.739C186.073,293.477,186.226,295.719,186.352,296.459L186.352,296.459z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#F9EB2E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.829,315.227l-0.51-0.189c-0.05-0.023-4.351-1.662-8.518-2.49         c-1.981-0.393-3.827-0.686-5.694-0.796c-1.554-0.073-3.115-0.064-4.767,0c-3.422,0.149-5.671,0.394-8.683,0.796l-1.142,0.164         c-1.884,0.259-4.12,0.563-6.916,0.686c-4.755,0.215-8.571-0.1-13.091-1.267c-2.572-0.698-3.778-1.1-5.443-1.993         c-1.515-0.807-3.61-2.09-4.97-3.58c-1.917-2.139-2.236-2.732-2.681-3.553l-0.688-1.182c-0.866-1.57-1.423-3.311-1.755-5.299         c-0.125-0.747-0.277-3.022-0.277-3.022v-45.764l64.749-0.356L250.829,315.227L250.829,315.227z M233.92,310.947         c0.75,0,1.5,0.018,2.236,0.07c1.908,0.094,3.764,0.389,5.795,0.801c3.387,0.668,6.837,1.863,8.113,2.33v-66.399         l-63.991,0.355l0.369,45.372l0,0c0.012,0,0.162,2.192,0.281,2.918c0.305,1.916,0.85,3.561,1.65,5.049         c0.315,0.508,0.52,0.875,0.701,1.19c0.436,0.825,0.735,1.35,2.58,3.423c1.282,1.413,3.292,2.635,4.768,3.424         c1.598,0.865,2.768,1.245,5.284,1.914c4.453,1.152,8.213,1.459,12.868,1.258c2.754-0.126,4.966-0.428,6.836-0.682         l1.144-0.152c3.026-0.424,5.289-0.664,8.749-0.801C232.206,310.977,233.067,310.947,233.92,310.947L233.92,310.947z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.798,307.539c1.022,0.656,2.075,1.256,3.028,1.771        c1.55,0.818,2.261,0.918,4.134,1.591v-62.772h-7.162v59.44V307.539z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.046,311.03l-1.524-0.521c-0.965-0.32-1.639-0.548-2.733-1.131         c-0.953-0.505-2.007-1.103-3.026-1.762l-0.035-59.489l7.233-0.085L201.046,311.03L201.046,311.03z M200.871,248.128         l-7.073,0.09l0.105,59.321c0.968,0.583,2.012,1.181,2.973,1.688c1.068,0.569,1.743,0.799,2.695,1.119l1.3,0.441V248.128         L200.871,248.128z",
    style: {
      fill: "#D90037"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.572,311.088v-62.96h-7.154v63.507        C222.417,311.635,227.321,311.244,229.572,311.088L229.572,311.088z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.325,311.739v-63.611l7.247-0.085l0.077,63.045c-2.328,0.234-7.224,0.64-7.224,0.64         L222.325,311.739L222.325,311.739z M229.48,248.128l-7.063,0.09l0.088,63.331c0.688-0.064,4.997-0.406,7.066-0.546         L229.48,248.128L229.48,248.128z",
    style: {
      fill: "#D90037"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.835,248.128h-7.121v62.709c2.316,0.229,4.728,0.569,7.161,1.246        L243.835,248.128z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.962,312.197l-0.104-0.023c-2.657-0.742-5.211-1.063-7.144-1.247l-0.074-62.799         l7.195-0.085L243.962,312.197L243.962,312.197z M243.758,248.128l-7.043,0.09l0.09,62.619         c1.843,0.103,4.362,0.423,6.982,1.134L243.758,248.128L243.758,248.128z",
    style: {
      fill: "#D90037"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.781,245.378c4.823-2.066,16.528-5.198,16.405-24.31         c-0.05-7.126-2.279-12.908-6.653-17.17c-5.479-5.341-12.448-6.62-15.685-6.605l-0.016-0.737         c3.15-0.064,10.548,1.293,16.221,6.809c4.523,4.4,6.834,10.365,6.889,17.704C372.07,240.749,359.514,244.111,354.781,245.378         L354.781,245.378z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.511,244.542c3.939-1.803,14.564-7.812,14.212-22.422         c-0.218-8.813-2.798-15.764-7.451-20.112c-3.486-3.246-7.992-4.933-12.908-4.716l-0.03-0.737         c5.019-0.254,9.818,1.522,13.449,4.906c4.81,4.488,7.478,11.631,7.7,20.645C371.838,237.198,360.805,243.413,356.511,244.542         L356.511,244.542z",
    style: {
      fill: "#4B2508"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 63.087,
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    },
    width: 9.182,
    x: 266.536,
    y: 176.901
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.807,240.065h-9.271l-0.099-63.164l9.28-0.089L275.807,240.065L275.807,240.065z          M275.638,176.901l-9.102,0.073l0.077,63.014l9.024-0.086V176.901L275.638,176.901z",
    style: {
      fill: "#D90037"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 63.087,
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    },
    width: 9.178,
    x: 284.921,
    y: 176.901
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.172,240.065h-9.251l-0.098-63.164l9.275-0.089L294.172,240.065L294.172,240.065z          M294.012,176.901l-9.091,0.073l0.075,63.014l9.016-0.086V176.901L294.012,176.901z",
    style: {
      fill: "#D90037"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 63.087,
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    },
    width: 9.192,
    x: 303.311,
    y: 176.901
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.584,240.065h-9.273l-0.087-63.164l9.279-0.089L312.584,240.065L312.584,240.065z          M312.412,176.901l-9.102,0.073l0.091,63.014l9.011-0.086V176.901L312.412,176.901z",
    style: {
      fill: "#D90037"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.259,248.128v64.398c-0.052,0-4.767,0.103-7.172-0.128v-64.247        L215.259,248.128z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#D90037"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_6_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.777,312.629c-1.521,0-3.442-0.032-4.701-0.154l-0.077-64.323l7.26-0.108l0.1,64.483         L212.777,312.629L212.777,312.629z M215.182,248.128l-7.095,0.104l0.08,64.166c1.192,0.025,3.09,0.064,4.611,0.064         l2.43-0.027L215.182,248.128L215.182,248.128z",
    style: {
      fill: "#D90037"
    }
  })))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalan);
export default __webpack_public_path__ + "static/media/catalan.d6a24e2037ae6b3f2dcbd77ffc6d8111.svg";
export { ForwardRef as ReactComponent };